import { FilterKeyTypes } from "../../shared/types/FilterKeys.types";

export const COUNT_OF_SHEET_INSTRUCTION_ROWS = 9;
export const HEADER_ROWS_COUNT = 6;
export const HEADER_ROWS_COUNT_WITHOUT_INSTRUCTIONS = 3;
export const EXCEL_BASE_DATE = 25567;
export const EXTRA_ROWS = 30;
export const MAX_ROW_SIZE = 120;
export const ROW_SIZE_FOR_API_CALL = 50;
export const SCROLL_THRESHOLD_VALUE = 50;

export const CONDITION_TRUE = "Yes";
export const CONDITION_FALSE = "No";
export const SCROLL_EVENT_LISTENER_TYPE = "scroll";

//Place holder text for the base components
export const ACCOUNTS_PLACEHOLDER = "Accounts";
export const CHART_OF_ACCOUNTS_PLACEHOLDER = "Chart of Accounts";
export const CLIENT_ENGAGEMENT_ENTITY_PLACEHOLDER = "Client-Engagement-Entity";
export const DEFAULT_SELECT_PLACEHOLDER = "Select...";
export const USERNAME_PLACEHOLDER = "Username";
export const PASSWORD_PLACEHOLDER = "Password";
export const ENTITY_PROJECT_PLACEHOLDER = "Entity Projects";
export const FETCHING_FILTERS_PLACEHOLDER = "Fetching filters if available";
export const LOADING_PLACEHOLDER = "Loading...";
export const NO_COA_PLACEHOLDER = "No Coa Found";
export const NO_COMBINATION_FOUND_PLACEHOLDER = "No Combination Found";
export const NO_DATA_PLACEHOLDER = "No data found";
export const NO_MATCHES_FOUND_PLACEHOLDER = "No matches found...";
export const NO_OPTIONS_FOUND_PLACEHOLDER = "No options found";
export const NO_RULE_ENGINE_PLACEHOLDER = "No Rule Engine Found";
export const PROJECT_MENU_PLACEHOLDER = "Project Menu";
export const PROJECT_PLACEHOLDER = "Project";
export const RULE_ENGINE_PLACEHOLDER = "Rule Engine";
export const SHEET_DOESNOT_EXIST_PLACEHOLDER = "Sheet does not exist";
export const FILTER_OPTIONS_PLACEHOLDER = "Filter Options";
//Navigation tab names
export const NAVIGATION_TABS = [
  "Deliverables",
  "Templates",
  "Chart of Accounts",
  "Administration",
];

// Keys for the base components
export const EXCEL_VIEW_ROUTE_KEY = "Allocation";
export const LANDING_ROUTE_KEY = "Landing";
export const LOGIN_ROUTE_KEY = "Login";
export const PROJECT_TYPE_REF_KEY = "projectType";
export const TAX_END_YEAR_REF_KEY = "taxEndYear";
export const TAX_START_YEAR_REF_KEY = "taxStartYear";
export const TAX_YEAR_TYPE_REF_KEY = "taxYearType";
export const USER_NAME_KEY = "userNameValue";
export const USER_PASSWORD_KEY = "userSecretValue";
export const LOGOUT = "Log Out";
export const NAVBAR_KEY = "navbar";

// Status message for the components
export const IMPORT_IN_PROGRESS_MESSAGE =
  " There is an import task for this project which is in progress. Please try after some time.";
export const NO_SHEETS_IN_HIERARCHY = "No sheets to display...";
export const TOAST_CONTAINER_CLASS = "mainContainerToast";
export const TOAST_DELIVERABLE_CREATED_MESSAGE =
  "Deliverable created successfully.";
export const TOAST_POSITION = "top-center";

// Labels values for the components
export const NEW_TEMPLATE_LABEL = "New Template";
export const NEW_COA_LABEL = "New CoA Template";
export const GLOBAL_COA_LABEL = "Global Chart of Accounts";
export const CLIENT_NAME_LABEL = "Client ";
export const ENGAGEMENT_NAME_LABEL = "Engagement";
export const TAX_YEAR_NAME_LABEL = "Tax Year";
export const PROJECT_TYPE_LABEL = "Project Type";
export const TAX_YEAR_END_DATE_LABEL = "Tax Year End Date";
export const TAX_YEAR_START_DATE_LABEL = "Tax Year Start Date";
export const TAX_YEAR_TYPE_LABEL = "Tax Year Type";
export const FILTER_NAME_LABEL = "Name";
export const VERSION = "v1.7";
export const CANCEL_BUTTON_LABEL = String.fromCharCode(0x2716);
export const APPLY_BUTTON_LABEL = String.fromCharCode(0x2714);
export const CLEAR_FILTER_TEXT = "Clear Filter";

export const FILTER_ITEMS_PROJECT: string[] = [
  "Clients",
  "Engagements",
  "Entity",
  "Tax Year",
];
export const PATHS_WITH_NO_SIDEBAR = ["login", "project"];
export const DEFAULT_DATE_FORMAT = "d-MMM-yy";
export const CHARACTERS_FOR_GETTING_COLUMN_INDEX = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
export const ITEMS_PER_PAGE = 10;

//Regex patterns used in the application
export const CELL_FORMULA_ROW_INDEX_INDETIFIER_REGEX = /[A-Za-z]{1,2}(?:\d+)/g;
export const CELL_ROW_INDEX_REPLACER_REGEX = /\d+/;
export const COLUMN_IDENTIFIER_REGEX = /[A-Za-z]+/;
export const DATE_REGEX = /^(?=.*d)(?=.*m)(?=.*y).+$/;
export const PERCENTAGE_END_REGEX = /%$/;
export const ROW_IDENTIFIER_REGEX = /\d+/;
export const ALPHANUMERICAL_IDENTIFIER_REGEX = /[A-Za-z]/;

//Error messages
export const TEMPLATE_NOT_FOUND = "Template Not Found";
export const OPTION_NOT_FOUND = "Option Not Found";
export const NO_ACTIVE_SHEET = "No active sheet found.";
//Deliverable Menu  constants
export const DELIVERABLE_NAME_UPDATED = "Deliverable name updated successfully";

//Create Template constants
export const SELECT_FILE_TO_UPLOAD = "Please select a file to upload";
export const ATTACH_FILE = "Please attach a .xlsx file";
export const CREATE_TEMPLATE = "Create Template";
export const CREATE_COA = "Create CoA";

//Default filter keys
export const DEFAULT_FILTER_KEYS: FilterKeyTypes = {
  Key1: "",
  Key2: "",
  Key3: "",
  Key4: "",
};

export const AG_GRID_HEADER_CHAR_WIDTH_PX = 8;
export const AG_GRID_HEADER_PADDING_PX = 80;
export const AG_GRID_COL_MIN_WIDTH_PX = 80;
export const AG_GRID_EMPTY_COL_WIDTH_PX = 52;

//Global constants — used across 2+ features
export const GLOBAL_CONSTANT = {
  TOAST_DEFAULT_ERROR_MESSAGE: "Something went wrong",
  GENERIC_ERROR_MESSAGE: "An error occurred",
  ACTIONS_ARIA_LABEL: "Actions",
  APPLY_TEXT: "Apply",
  DATE_FORMAT_MM_DD_YYYY: "MM/DD/YYYY",
  TABLE_PAGINATION_SHOW_TOTAL: (total: number, range: [number, number]) =>
    `${range[0]}-${range[1]} of ${total}`,
  ADMINISTRATOR_ROLE: "Administrator",
  CANCEL_TEXT: "Cancel",
  CREATE_TEXT: "Create",
  SAVE_TEXT: "Save",
  CLOSE_TEXT: "Close",
  BACK_BUTTON_LABEL: "Back",
  EDIT_TEXT: "Edit",
  DELETE_TEXT: "Delete",
  DEACTIVATE_TEXT: "Deactivate",
  REACTIVATE_TEXT: "Reactivate",
  RESET_TEXT: "Reset",
  LOCALE_EN_US: "en-US",
  IMPORT_BUTTON_LABEL: "Import",
  EXPORT_BUTTON_LABEL: "Export",
  ADDROW_TEXT: "Add Row",
  EDIT_ONLINE_TEXT: "Edit Online",
  ACTIVE_TABS_KEY: "activeTab",
  NAME_KEY: "templateName",
  MULTI_SHEET_KEY: "multiSheet",
  DELIVERABLE_NAME_LABEL: "Deliverable Name",
  FILTER_TAGS_LABEL: "Tags",
  FILTER_CREATED_BY_LABEL: "Created By",
  FILTER_CREATED_ON_LABEL: "Created On",
  GLOBAL_TEMPLATE_LABEL: "Global Template",
  DEFAULT_GUID: "00000000-0000-0000-0000-000000000000",
  TEMPLATE: "template",
  USER_ACCESS: "User Access",
  IMPORT_FAILED_MESSAGE: "Import failed",
  COA_NAME_LABEL: "CoA Name",
  CREATE_COA_BUTTON_LABEL: "Create CoA",
  CREATE_TEMPLATE_BUTTON_LABEL: "Create Template",
  NO_OF_DELIVERABLES_LABEL: "No. of Deliverables",
  TASK_POLLING_INTERVAL: 2000,
  ACCESS_TYPE: "Access Type",
  NO_PROJECTS_FOUND_PLACEHOLDER: "No data found...",
  USER_NAME_LABEL: "User Name",
  WRITE_ACCESS: "Write",
  ONLY_XLSX_FILES_ACCEPTED_MESSAGE: "Only .xlsx files are accepted",
  TEMPLATE_NAME_LABEL: "Template Name",
  UPLOADING_TEXT: "Uploading…",
  UPLOAD_FAILED_MESSAGE: "Upload failed",
  SAVING_TEXT: "Saving...",
  // Used by any column/header that lists a chart-of-accounts account name — shared by
  // SettingsView's Global CoA Mapping grid and CalculationsView's ProjectWorkspace trial
  // balance panel.
  ACCOUNT_NAME_COLUMN_HEADER: "Account Name",
  // Generic "Category" column header — shared by ConfigurationsView's Calc Profile table and
  // CalculationsView's ProjectWorkspace trial balance panel.
  CATEGORY_COLUMN_HEADER: "Category",
  // AG Grid header-name convention for a computed/formula column — shared by
  // ConfigurationsView's TemplateEditor and CalculationsView's ProjectWorkspace.
  COMPUTED_COLUMN_HEADER_TEXT: (name: string) => `∑ ${name}`,
  // AG Grid tooltip convention for a computed cell's formula — shared by ConfigurationsView's
  // TemplateEditor and CalculationsView's ProjectWorkspace.
  FORMULA_TOOLTIP_TEXT: (formula?: string | null) =>
    formula ? `Formula: ${formula}` : "Calculated",
  // Tax-year options for the shared ClientBanner's Tax Year pill — the banner renders on every
  // banner route (entities, tiering, engagements, financials, calculations, configurations, ...).
  TAX_YEARS: ["FY2025", "FY2024", "FY2023", "FY2022"],
  // Route prefixes where the shared ClientBanner hides its Partnership pill because the screen
  // does not use selectedPartnership (Entities has its own Partners tab; Engagements are
  // client-scoped; Structure is client+tax-year scoped only — WO-34668).
  PARTNERSHIP_HIDDEN_ROUTES: ["/entities", "/engagements", "/calculations/structure"],
  AG_GRID_ROW_BORDER_PARAMS: {
    rowBorder: { style: "solid", width: 1, color: "rgba(255, 255, 255, 0.3)" },
  },
  TASK_STATUS: {
    COMPLETED: "completed",
    IN_PROGRESS: "inprogress",
    FAILED: "failed",
    NO_TASK_FOUND: "No Task Found",
  },
  TASK_TYPE: {
    IMPORT: "import",
    RERUN: "RERUN",
  },
  // Used by the Invite User modal's Role field
  APPLICATION_ROLE_OPTIONS: [
    { value: "Preparer", label: "Preparer" },
    { value: "Reviewer", label: "Reviewer" },
    { value: "Administrator", label: "Administrator" },
  ],
};

//AdminView screen constants
export const ADMIN_VIEW_CONSTANT = {
  IN_DEVELOPMENT_BADGE_LABEL: "In Development",
  ADMINISTRATION_TITLE: "Administration",
  ADMIN_DESCRIPTION: "User management, permissions, and system configuration",
};

//AuthenticateView / Login screen constants
export const AUTHENTICATE_VIEW_CONSTANT = {
  MSAL_LOGIN_SCOPES: ["User.Read", "openid", "profile"],
  TOKEN_REFRESH_INTERVAL_MS: (3 * 60 * 60 - 60) * 1000, // 2h 59m
  SSO_SIGNIN_FAILED_TITLE: "Sign-in failed",
  SSO_SIGNIN_FAILED_DESCRIPTION:
    "Could not sign in with Microsoft. Please try again.",
  LOGIN_SUCCESS_MESSAGE: "Login Successful",
  INVALID_CREDENTIALS: "Invalid credentials",
  INVALID_CREDENTIALS_DESCRIPTION: "Invalid username or password",
  LOGO_ALT_TEXT: "Propel",
  APP_VERSION_LABEL: "v0.1",
  SIGN_IN_HEADING: "Sign in",
  SIGN_IN_SUBTEXT: "Welcome back — enter your credentials to continue.",
  EMAIL_LABEL: "Email Address",
  EMAIL_PLACEHOLDER: "you@firm.com",
  PASSWORD_LABEL: "Password",
  PASSWORD_FIELD_PLACEHOLDER: "••••••••",
  USERNAME_REQUIRED_TEXT: "UserName is required",
  PASSWORD_REQUIRED_TEXT: "Password is required",
  FORGOT_PASSWORD_TEXT: "Forgot Password?",
  SIGN_IN_BUTTON_TEXT: "Sign in",
  SSO_DIVIDER_TEXT: "— or —",
  SSO_BUTTON_TEXT: "Sign in with Microsoft",
  BRAND_TITLE: "Calc Engine",
  BRAND_SUBTITLE: "Building Calculation Infrastructure for Growing Firms",
};

//SettingsView screen constants — nested per sub-screen (Roles, StandardCalculations, ...)
export const SETTINGS_VIEW_CONSTANT = {
  ROLES: {
    PAGE_TITLE: "Roles",
    CREATE_ROLE_BUTTON_LABEL: "Create Role",
    FAILED_TO_LOAD_ROLES_MESSAGE: "Failed to load roles",
    FAILED_TO_LOAD_PERMISSION_CATALOG_MESSAGE:
      "Failed to load the permission catalog",
    FAILED_TO_DELETE_ROLE_MESSAGE: "Failed to delete role",
    ROLE_TABLE_HEADER: "Role",
    PERMISSIONS_TABLE_HEADER: "Permissions",
    PERMISSIONS_COLUMN_WIDTH_PX: 200,
    ACTIONS_COLUMN_WIDTH_PX: 60,
    NO_ROLES_FOUND_MESSAGE: "No roles found",
    SYSTEM_BADGE_LABEL: "System",
    DELETE_ROLE_ARIA_LABEL: "Delete role",
    PERMISSION_LABEL: "permission",
    DELETE_ROLE_CONFIRM_TITLE: (roleName: string) => `Delete ${roleName}?`,
    ROLE_DELETED_MESSAGE: (roleName: string) => `${roleName} deleted`,

    // CreateRoleModal
    CREATE_ROLE_MODAL_TITLE: "Create Role",
    CREATE_ROLE_MODAL_WIDTH_PX: 560,
    SELECT_PERMISSION_REQUIRED_MESSAGE:
      "Select at least one permission for this role",
    ROLE_CREATED_MESSAGE: "Role created",
    FAILED_TO_CREATE_ROLE_MESSAGE: "Failed to create role",
    ROLE_NAME_LABEL: "Role Name",
    ROLE_NAME_PLACEHOLDER: "e.g. Reviewer — East Region",
    ROLE_NAME_REQUIRED_MESSAGE: "Role name is required",
    DESCRIPTION_LABEL: "Description",
    DESCRIPTION_PLACEHOLDER: "What this role is for",
    DESCRIPTION_REQUIRED_MESSAGE: "Description is required",

    // RoleDetailModal
    ROLE_DETAIL_MODAL_WIDTH_PX: 640,
    FAILED_TO_LOAD_ROLE_DETAILS_MESSAGE: "Failed to load role details",
    ROLE_UPDATED_MESSAGE: "Role updated",
    FAILED_TO_SAVE_ROLE_MESSAGE: "Failed to save role",
    SYSTEM_ROLE_TAG_LABEL: "System Role",
    PERMISSIONS_LABEL: "Permissions",

    // PermissionGroupsPanel
    OTHER_PERMISSIONS_GROUP_LABEL: "Other Permissions",
    CLIENT_MANAGEMENT_GROUP_LABEL: "Client Management",
    TEMPLATE_LIBRARY_GROUP_LABEL: "Template Library",
    CALC_PROFILE_STANDARD_CALCULATIONS_GROUP_LABEL:
      "Calc Profile & Standard Calculations",
    PROJECT_WORKSPACE_GROUP_LABEL: "Project Workspace",
    UPLOAD_RUN_GROUP_LABEL: "Upload & Run",
    WORK_PAPERS_GROUP_LABEL: "Work Papers",
    USER_MANAGEMENT_GROUP_LABEL: "User Management",
    SETTINGS_COA_GROUP_LABEL: "Settings & CoA",
    COLLAPSE_GROUP_ARIA_LABEL: "Collapse group",
    EXPAND_GROUP_ARIA_LABEL: "Expand group",
  },

  USER_MANAGEMENT: {
    PAGE_TITLE: "User Management",
    INVITE_USER_BUTTON_LABEL: "Invite User",
    COMING_SOON_SUFFIX: " coming soon",
    FAILED_TO_LOAD_USERS_MESSAGE: "Failed to load users",
    SEARCH_USERS_PLACEHOLDER: "Search users...",
    NO_USERS_MATCH_SEARCH_MESSAGE: "No users match your search",
    NO_USERS_FOUND_MESSAGE: "No users found",
    USER_TABLE_HEADER: "User",
    ROLE_TABLE_HEADER: "Role",
    LAST_ACTIVE_TABLE_HEADER: "Last Active",
    ROLE_COLUMN_WIDTH_PX: 180,
    LAST_ACTIVE_COLUMN_WIDTH_PX: 200,
    ACTIONS_COLUMN_WIDTH_PX: 48,
    ALL_USERS_LABEL: "All Users",
    ADMIN_USERS_LABEL: "Admin Users",
    APPLICATION_USERS_LABEL: "Application Users",
    ACTIONS_ARIA_LABEL: "Actions",
    INACTIVE_BADGE_LABEL: "Inactive",
    DEACTIVATE_CONFIRM_TITLE: "Deactivate this user?",
    DEACTIVATE_SUCCESS_MESSAGE: "User deactivated",
    DEACTIVATE_FAILED_MESSAGE: "Failed to deactivate user",
    CHANGE_ROLE_TEXT: "Change Role",
    MANAGE_CLIENT_ACCESS_TEXT: "Manage Client Access",
    SELECT_ROLE_PLACEHOLDER: "Select a role",

    // ChangeRoleModal
    CHANGE_ROLE_MODAL_TITLE: "Change Role",
    CHANGE_ROLE_MODAL_WIDTH_PX: 420,
    CURRENT_ROLE_LABEL: "Current Role",
    NEW_ROLE_LABEL: "New Role",
    ROLE_CHANGED_SUCCESS_MESSAGE: "Role updated",
    ROLE_CHANGE_FAILED_MESSAGE: "Failed to update role",

    // ClientAccessModal
    CLIENT_ACCESS_MODAL_TITLE: "Client Access",
    CLIENT_ACCESS_MODAL_WIDTH_PX: 480,
    ADD_CLIENT_PLACEHOLDER: "Add a client...",
    NO_CLIENTS_ASSIGNED_MESSAGE: "No clients assigned",
    CLIENT_ACCESS_UPDATED_SUCCESS_MESSAGE: "Client access updated",
    CLIENT_ACCESS_UPDATE_FAILED_MESSAGE: "Failed to update client access",
    FAILED_TO_LOAD_CLIENT_ACCESS_MESSAGE: "Failed to load client access",
    REMOVE_CLIENT_ARIA_LABEL: (clientName: string) => `Remove ${clientName}`,

    // InviteUserModal
    INVITE_USER_MODAL_TITLE: "Invite User",
    INVITE_USER_MODAL_WIDTH_PX: 480,
    SEND_INVITE_BUTTON_LABEL: "Send Invite",
    FIRST_NAME_LABEL: "First Name",
    LAST_NAME_LABEL: "Last Name",
    EMAIL_LABEL: "Email",
    ROLE_LABEL: "Role",
    FIRST_NAME_PLACEHOLDER: "Jane",
    LAST_NAME_PLACEHOLDER: "Smith",
    EMAIL_PLACEHOLDER: "jane.smith@firm.com",
    FIRST_NAME_REQUIRED_TEXT: "First Name is required",
    LAST_NAME_REQUIRED_TEXT: "Last Name is required",
    EMAIL_REQUIRED_TEXT: "Email is required",
    VALID_EMAIL_REQUIRED_TEXT: "Enter a valid email",
    ROLE_REQUIRED_TEXT: "Role is required",
    INVITATION_FAILED_MESSAGE: "Failed to send invitation",
    USER_ALREADY_EXISTS_MESSAGE: "User already exists",
    TEMP_PASSWORD_LABEL: "Temporary Password",
    TEMP_PASSWORD_INSTRUCTION:
      "Share this temporary password with the user. They will be prompted to change it on first login.",
    CLIENTS_LABEL: "Clients",
    SELECT_CLIENTS_PLACEHOLDER: "Select clients",
    CLIENTS_REQUIRED_TEXT: "Select at least one client for this user",
  },

  TIERING_CONFIGURATION: {
    PAGE_TITLE: "Tiering Configuration",
    PAGE_SUBTITLE:
      "Overrides for how a K-1 line resolves at the next tier up. No row means the line maps to itself.",
    OVERRIDES_TAB_LABEL: "Line Map Overrides",
    EFFECTIVE_TAB_LABEL: "Effective Mapping",
    ADD_OVERRIDE_BUTTON_LABEL: "Add Override",
    FAILED_TO_LOAD_MESSAGE: "Failed to load the line map",
    FAILED_TO_LOAD_EFFECTIVE_MESSAGE: "Failed to load the effective mapping",
    NO_ROWS_FOUND_MESSAGE: "No override rows found",
    SCOPE_FILTER_LABEL: "Scope",
    SCOPE_FILTER_ALL_OPTION: "All Scopes",
    CLIENT_FILTER_PLACEHOLDER: "Filter by client...",
    SCOPE_TABLE_HEADER: "Scope",
    CLIENT_TABLE_HEADER: "Client",
    SOURCE_LINE_TABLE_HEADER: "Source Line",
    TARGET_LINE_TABLE_HEADER: "Target Line",
    CODE_TABLE_HEADER: "Code",
    TAX_YEAR_TABLE_HEADER: "Tax Year",
    ACTIONS_TABLE_HEADER: "",
    ALL_YEARS_LABEL: "All years",
    WHOLE_BOX_LABEL: "Whole box",
    DELETE_ARIA_LABEL: "Deactivate row",
    DEACTIVATE_CONFIRM_TITLE: "Deactivate this override?",
    DEACTIVATE_SUCCESS_MESSAGE: "Override deactivated",
    DEACTIVATE_FAILED_MESSAGE: "Failed to deactivate override",
    SOURCE_LINE_TABLE_HEADER_EFFECTIVE: "K-1 Line",
    TARGET_LINE_TABLE_HEADER_EFFECTIVE: "Resolves To",
    OVERRIDE_BADGE_LABEL: "Override",
    IDENTITY_BADGE_LABEL: "Identity",
    MATCHED_SCOPE_LABEL: (scope: string) => `at ${scope} scope`,

    // AddEditLineMapModal
    ADD_MODAL_TITLE: "Add Line Map Override",
    EDIT_MODAL_TITLE: "Edit Line Map Override",
    MODAL_WIDTH_PX: 560,
    SCOPE_LABEL: "Scope",
    SCOPE_REQUIRED_MESSAGE: "Scope is required",
    CLIENT_LABEL: "Client",
    CLIENT_REQUIRED_MESSAGE: "Client is required for client scope",
    SELECT_CLIENT_PLACEHOLDER: "Select a client",
    SOURCE_LINE_LABEL: "Source Line",
    SOURCE_LINE_REQUIRED_MESSAGE: "Source line is required",
    SELECT_LINE_PLACEHOLDER: "Select a K-1 line",
    SOURCE_CODE_LABEL: "Source Code (optional)",
    SOURCE_CODE_PLACEHOLDER: "e.g. W — leave blank for the whole box",
    TARGET_LINE_LABEL: "Target Line",
    TARGET_LINE_REQUIRED_MESSAGE: "Target line is required",
    TARGET_CODE_LABEL: "Target Code (optional)",
    TAX_YEAR_LABEL: "Tax Year (optional)",
    TAX_YEAR_PLACEHOLDER: "Leave blank to apply to all years",
    SAME_LINE_WARNING_TITLE: "Source and target are the same line",
    SAME_LINE_WARNING_DESCRIPTION:
      "This pins the line to itself instead of leaving no row (identity is already the default). Continue anyway?",
    SAVE_BUTTON_LABEL: "Save",
    OVERRIDE_CREATED_MESSAGE: "Override created",
    OVERRIDE_UPDATED_MESSAGE: "Override updated",
    FAILED_TO_LOAD_LINES_MESSAGE: "Failed to load K-1 lines",
    FAILED_TO_SAVE_MESSAGE: "Failed to save override",
    DUPLICATE_MESSAGE: "A row already exists for this scope, client, line, code and year",
  },

  TAX_FORM_LINES: {
    PAGE_TITLE: "Tax Form Lines",
    PAGE_SUBTITLE:
      "View and map tax_form_line rows for K-1, K-2 and K-3 to the data that resolves them at calculation time.",
    FORM_FILTER_LABEL: "Form",
    SELECT_FORM_PLACEHOLDER: "Select a form",
    PART_FILTER_PLACEHOLDER: "Part (e.g. II)",
    SECTION_FILTER_PLACEHOLDER: "Section (e.g. 1)",
    NEEDS_REVIEW_FILTER_LABEL: "Needs Review",
    MAPPED_FILTER_LABEL: "Mapped",
    FILTER_ALL_OPTION: "All",
    FILTER_YES_OPTION: "Yes",
    FILTER_NO_OPTION: "No",
    LINE_TABLE_HEADER: "Line",
    DESCRIPTION_TABLE_HEADER: "Description",
    SECTION_TABLE_HEADER: "Section",
    SUB_SECTION_TABLE_HEADER: "Sub-Section",
    SORT_TABLE_HEADER: "Sort",
    MAPPING_TABLE_HEADER: "Mapping",
    NEEDS_REVIEW_TABLE_HEADER: "Needs Review",
    UNMAPPED_LABEL: "Unmapped",
    NO_ROWS_FOUND_MESSAGE: "No lines found for this form and filter set",
    FAILED_TO_LOAD_FORMS_MESSAGE: "Failed to load tax forms",
    FAILED_TO_LOAD_LINES_MESSAGE: "Failed to load tax form lines",
    NO_ACCESS_TITLE: "You don't have permission to view Tax Form Lines",
    NO_ACCESS_DESCRIPTION:
      "This screen requires the Tax Form Admin permission. Contact an administrator if you believe you should have access.",
    GENERIC_LOCK_MESSAGE: "This form is currently locked for editing by another admin.",
    LOCK_MESSAGE: (until: string) => `This form is being edited by another admin until ${until}.`,

    // EditTaxFormLineModal
    EDIT_MODAL_TITLE: "Edit Line Mapping",
    MODAL_WIDTH_PX: 560,
    MAPPING_TYPE_LABEL: "Mapping Type",
    MAPPING_TYPE_PLACEHOLDER: "Unmapped",
    MAPPING_REF_LABEL: "Mapping Reference (JSON, optional)",
    MAPPING_REF_PLACEHOLDER: 'e.g. {"lineCodes":["K1_L11"]}',
    OPERATION_TYPE_LABEL: "Operation Type",
    OPERATION_TYPE_REQUIRED_MESSAGE: "Operation type is required for a Calculated line",
    OPERATION_TYPE_PLACEHOLDER: "e.g. sum",
    LINE_ID_LIST_LABEL: "Referenced Line IDs (JSON array, optional)",
    LINE_ID_LIST_PLACEHOLDER: '["<line-id-1>", "<line-id-2>"]',
    LINE_ID_LIST_INVALID_MESSAGE: "Must be a JSON array of line ids, e.g. [\"<line-id-1>\"]",
    EXPECTED_VALUE_LABEL: "Expected Value (optional)",
    EXPECTED_VALUE_PLACEHOLDER: "e.g. /1 — for a FixedCheckbox line",
    REVERSE_SIGN_LABEL: "Reverse Sign",
    NEEDS_REVIEW_LABEL: "Needs Review",
    SAVE_BUTTON_LABEL: "Save",
    LINE_UPDATED_MESSAGE: "Line mapping updated",
    FAILED_TO_SAVE_MESSAGE: "Failed to save the line mapping",
    LINE_NOT_FOUND_MESSAGE: "This line no longer exists",

    // Import (K-2/K-3 only)
    IMPORT_BUTTON_LABEL: "Import K-2/K-3 Lines",
    IMPORT_MODAL_TITLE: "Import K-2/K-3 Lines",
    FORM_CODE_LABEL: "Form",
    FORM_YEAR_LABEL: "Form Year",
    FILE_LABEL: "Line Import Excel File",
    SELECT_FILE_BUTTON_LABEL: "Select File",
    PREVIEW_BUTTON_LABEL: "Preview",
    COMMIT_BUTTON_LABEL: "Commit Import",
    IMPORT_PREVIEW_SUCCESS_MESSAGE: "Preview complete — review the results below before committing",
    IMPORT_COMMIT_SUCCESS_MESSAGE: "Import committed",
    IMPORT_FAILED_MESSAGE: "Import failed",
    FILE_REQUIRED_MESSAGE: "Select a file first",
    TOTAL_ROWS_LABEL: "Rows in file",
    NEW_LABEL: "New",
    CHANGED_LABEL: "Changed",
    UNCHANGED_LABEL: "Unchanged",
    ERRORS_LABEL: "Errors",
    ROW_TABLE_HEADER: "Row",
    NAME_TABLE_HEADER: "Name",
    REASON_TABLE_HEADER: "Reason",

    // Form PDF preview pane (WO-4 2c, ADO #34784)
    ACTIONS_TABLE_HEADER: "",
    EDIT_BUTTON_LABEL: "Edit",
    EDIT_BUTTON_ARIA_LABEL: "Edit line mapping",
    PDF_NOT_FOUND_MESSAGE: "No PDF template is available for this form",
    PDF_ACCESS_ERROR_MESSAGE: "Couldn't load this form's preview — check your access and try again",
    PDF_PAGE_OF: (page: number, total: number) => `Page ${page} of ${total}`,
    FIELD_NOT_IN_VIEW_MESSAGE: "That line is not in the current page or filter",
    FIELD_LINE_LOOKUP_FAILED_MESSAGE: "Failed to find that line in the form",

    // Form Builder (WO-FB-3) — form picker badges
    LOCK_FORBIDDEN_MESSAGE: "You don't have permission to edit this form.",
    LOCK_FORM_NOT_FOUND_MESSAGE: "This form no longer exists or isn't visible to you.",
    LOCK_FAILED_MESSAGE: "Couldn't acquire the edit lock for this form. Try again.",
    LOCK_LOST_MESSAGE: "Your edit lock on this form was lost. Re-enter Edit mode to continue.",
    EDIT_MODE_LABEL: "Edit mode",
    EDIT_MODE_ON_NOTICE: "Edit mode: you hold the edit lock on this form. Leave Edit mode to release it.",
    EDIT_MODE_VIEW_ONLY_NOTICE: (detail: string) => `View only — ${detail}`,
    UPLOAD_BUTTON_LABEL: "Upload Form",
    UPLOAD_MODAL_TITLE: "Upload a new form",
    UPLOAD_SUBMIT_LABEL: "Upload",
    UPLOAD_NAME_LABEL: "Name",
    UPLOAD_NAME_REQUIRED_MESSAGE: "Enter a form name",
    UPLOAD_CLASSIFICATION_LABEL: "Classification",
    UPLOAD_CLASSIFICATION_HELP: "Letters, digits, _ and - only. K1, K2 and K3 are reserved.",
    UPLOAD_CLASSIFICATION_REQUIRED_MESSAGE: "Enter a classification",
    UPLOAD_CLASSIFICATION_FORMAT_MESSAGE: "Use letters, digits, _ and - only",
    UPLOAD_CLASSIFICATION_RESERVED_MESSAGE: "K1, K2 and K3 are reserved for the shared forms",
    UPLOAD_SCOPE_LABEL: "Scope",
    UPLOAD_SCOPE_PARTNER: "Partner (one per partner)",
    UPLOAD_SCOPE_PARTNERSHIP: "Partnership",
    UPLOAD_TAX_YEAR_LABEL: "Tax year (optional)",
    UPLOAD_JURISDICTION_LABEL: "Jurisdiction (optional)",
    UPLOAD_JURISDICTION_HELP: "Federal or a two-letter state code",
    UPLOAD_JURISDICTION_FORMAT_MESSAGE: "Enter Federal or a two-letter state code",
    UPLOAD_FILE_LABEL: "PDF file",
    UPLOAD_FILE_REQUIRED_MESSAGE: "Select a PDF file",
    UPLOAD_FILE_TYPE_MESSAGE: "Only .pdf files are accepted",
    UPLOAD_FILE_SIZE_MESSAGE: "The PDF must be 10 MB or smaller",
    UPLOAD_FILE_EMPTY_MESSAGE: "The selected file is empty",
    UPLOAD_SUCCESS_MESSAGE: "Form uploaded",
    UPLOAD_FAILED_MESSAGE: "Failed to upload the form",
    DELETE_FORM_BUTTON_LABEL: "Delete Form",
    DELETE_FORM_CONFIRM_TITLE: "Delete this form?",
    DELETE_FORM_CONFIRM_DESCRIPTION:
      "This form and its lines will no longer be available. Other users of the form lose access immediately.",
    DELETE_FORM_OK_TEXT: "Delete",
    DELETE_FORM_SUCCESS_MESSAGE: "Form deleted",
    DELETE_FORM_FAILED_MESSAGE: "Failed to delete the form",
    SHARED_FORM_RESTRICTED_MESSAGE: "Shared forms (K-1, K-2, K-3) can't be deleted or have lines added or removed.",
    FIELD_LIST_NAME_HEADER: "PDF field",
    FIELD_LIST_TYPE_HEADER: "Type",
    FIELD_LIST_PAGE_HEADER: "Page",
    FIELD_LIST_STATUS_HEADER: "Status",
    FIELD_HAS_LINE_LABEL: "Has line",
    FIELD_FREE_LABEL: "No line",
    FIELD_LIST_SEARCH_PLACEHOLDER: "Search fields",
    FIELD_LIST_FREE_ONLY_LABEL: "No line only",
    FIELD_LIST_EMPTY_MESSAGE: "No fields match",
    FIELD_LIST_SUMMARY: (total: number, free: number) => `${total} fields, ${free} without a line`,
    FIELD_LIST_FAILED_MESSAGE: "Failed to load the form's PDF fields",
    PICK_MODE_VIEW: "View",
    PICK_MODE_PICK: "Pick fields",
    PICK_COUNT: (n: number) => `${n} field${n === 1 ? "" : "s"} selected`,
    // WO-15: counts bar, bulk assign
    NOT_APPLICABLE_FILTER_LABEL: "Not applicable",
    COUNTS_CHIP_LABELS: {
      total: "Total",
      mapped: "Lines mapped",
      unmapped: "Unmapped",
      needsReview: "Needs Review",
      notApplicable: "Not applicable",
      blankLine: "Blank Line",
      blankDescription: "Blank Description",
    },
    COUNTS_FAILED_MESSAGE: "Failed to load line counts",
    BULK_ASSIGN_BUTTON_LABEL: (n: number) => `Bulk assign (${n})`,
    BULK_SELECT_PAGE_BANNER: (shown: number, total: number) =>
      `All ${shown} lines on this page are selected.`,
    BULK_SELECT_ALL_MATCHING_LABEL: (total: number) => `Select all ${total} matching this filter`,
    BULK_SELECT_ALL_OVER_CAP_MESSAGE: (total: number, cap: number) =>
      `${total} lines match, more than the ${cap} a single bulk update can change. Narrow the filter first.`,
    BULK_ALL_MATCHING_SELECTED: (total: number) => `All ${total} lines matching this filter are selected.`,
    BULK_CLEAR_SELECTION_LABEL: "Clear selection",
    BULK_MODAL_TITLE: (n: number) => `Bulk assign ${n} line${n === 1 ? "" : "s"}`,
    BULK_MODAL_INTRO:
      "Line and Description are never changed. Only the mapping and the Needs Review flag are.",
    BULK_ACTION_LABEL: "Mapping",
    BULK_ACTION_NOT_APPLICABLE: "Mark as Not applicable",
    BULK_ACTION_CLEAR: "Clear mapping (back to Unmapped)",
    BULK_ACTION_NONE: "Leave the mapping as it is",
    BULK_CLEAR_REVIEW_LABEL: "Clear Needs Review",
    BULK_PREVIEW_BUTTON_LABEL: "Preview changes",
    BULK_APPLY_BUTTON_LABEL: "Apply",
    BULK_PREVIEW_STALE_HINT: "Preview the change before applying it.",
    BULK_PREVIEW_SUMMARY: (r: { selected: number; wouldUpdate: number; mappingChanged: number; needsReviewCleared: number; unchanged: number }) =>
      `${r.selected} selected · ${r.wouldUpdate} will change (${r.mappingChanged} mapping, ${r.needsReviewCleared} review flag) · ${r.unchanged} already as requested`,
    BULK_ERRORS_TITLE: "These lines block the update. Nothing was changed.",
    BULK_ERROR_LINE_HEADER: "Line",
    BULK_ERROR_REASON_HEADER: "Reason",
    BULK_APPLIED_MESSAGE: (n: number) => `Updated ${n} line${n === 1 ? "" : "s"}`,
    BULK_FAILED_MESSAGE: "Bulk update failed",
    BULK_K1_LOCKED_MESSAGE: "Bulk assign is not available on the K-1 form. Edit K-1 lines one at a time.",
    BULK_COUNT_MISMATCH_MESSAGE: "The matching lines changed since you selected them. Reload and select again.",
    BULK_TOO_MANY_MESSAGE: "Too many lines for one bulk update. Narrow the selection.",
    LINE_LOCKED_MESSAGE: "The Line number cannot be changed on the K-1 form.",
    LINE_FIELD_LABEL: "Line",
    PICK_CLEAR_LABEL: "Clear",
    PICK_CAP_REACHED_MESSAGE: (max: number) => `You can pick at most ${max} fields at a time.`,
    PICK_HAS_LINE_MESSAGE: "That field already has a line.",
    FIELD_PICK_ARIA_LABEL: "Pick this field",
    OUTPUT_CODES_LABEL: "Output codes",
    OUTPUT_CODES_PLACEHOLDER: "Search and add output codes",
    OUTPUT_CODES_FAILED_MESSAGE: "Failed to load output codes",
    OUTPUT_CODES_K1_GROUP: "K-1 catalog",
    OUTPUT_CODES_TEMPLATE_GROUP: "Template outputs",
    OUTPUT_CODES_CURRENT_GROUP: "Already on this line",
    OUTPUT_CODES_BAD_JSON_MESSAGE: "The mapping reference isn't a valid JSON object, so codes can't be edited here. Fix it below first.",
    ADD_LINE_BUTTON_LABEL: "Add Line",
    ADD_LINE_MODAL_TITLE: "Add a line",
    ADD_LINE_SUBMIT_LABEL: "Add line",
    ADD_LINE_SUCCESS_MESSAGE: "Line added",
    ADD_LINE_FAILED_MESSAGE: "Failed to add the line",
    LABEL_FIELD_LABEL: "Label",
    LABEL_REQUIRED_MESSAGE: "Enter a label",
    LABEL_BLANK_HINT: "This line has no label yet. Type one to edit its details, or change only its mapping below.",
    // WO-15 import report
    IMPORT_BLANK_FLAGGED_TITLE: (n: number) =>
      `${n} row${n === 1 ? "" : "s"} with a blank Line or Description ${n === 1 ? "is" : "are"} imported flagged Needs Review`,
    IMPORT_FLAGGED_FIELD_HEADER: "PDF field",
    IMPORT_FLAGGED_BLANK_HEADER: "Blank",
    IMPORT_FLAGGED_BLANK_LINE: "Line",
    IMPORT_FLAGGED_BLANK_DESCRIPTION: "Description",
    IMPORT_PRESERVED_EDITS_MESSAGE: (n: number) =>
      `${n} line${n === 1 ? " was" : "s were"} edited by an admin since the last import. The file's values were not applied to ${n === 1 ? "it" : "them"}.`,
    PDF_FIELD_LABEL: "PDF field",
    PDF_FIELD_REQUIRED_MESSAGE: "Choose a PDF field",
    PDF_FIELD_PLACEHOLDER: "Search fields without a line",
    DATA_TYPE_LABEL: "Data type",
    DATA_TYPE_HELP: "Leave empty to default from the PDF field (checkbox = boolean, otherwise string)",
    SORT_HELP: "Leave empty to place the line at the end",
    PDF_FIELD_LOCKED_MESSAGE: "The PDF field of a shared form's line can't be changed.",
    BULK_CREATE_BUTTON_LABEL: (n: number) => `Create ${n} line${n === 1 ? "" : "s"}`,
    BULK_CREATE_FAILED_MESSAGE: "Failed to create the lines",
    BULK_SKIPPED_TITLE: "Some fields were skipped",
    BULK_SKIPPED_FIELD_HEADER: "PDF field",
    BULK_SKIPPED_REASON_HEADER: "Reason",
    DETAILS_SECTION_TITLE: "Details",
    MAPPING_SECTION_TITLE: "Mapping",
    DETAILS_NO_PDF_FIELD_MESSAGE: "This line has no PDF field, so its details can't be edited here. Its mapping can still be edited below.",
    DELETE_LINE_ARIA_LABEL: "Delete line",
    DELETE_LINE_CONFIRM_TITLE: "Delete this line?",
    DELETE_LINE_SUCCESS_MESSAGE: "Line deleted",
    DELETE_LINE_FAILED_MESSAGE: "Failed to delete the line",
    DELETE_LINE_ALREADY_GONE_MESSAGE: "That line was already deleted",
    // WO-53: map a line to a cell of a template. Server text is shown as sent; these are fallbacks.
    TEMPLATE_CELL_TYPE: "TemplateCell",
    TEMPLATE_CELL_LABEL: "Template cell",
    TEMPLATE_CELL_TEMPLATE_LABEL: "Template",
    TEMPLATE_CELL_TEMPLATE_PLACEHOLDER: "Choose a template",
    TEMPLATE_CELL_TEMPLATES_FAILED_MESSAGE: "Failed to load the templates",
    TEMPLATE_CELL_CURRENT_TEMPLATE: (id: string) => `Template ${id} (current)`,
    TEMPLATE_CELL_SHEET_LABEL: "Sheet",
    TEMPLATE_CELL_SHEET_PLACEHOLDER: "Choose a sheet",
    TEMPLATE_CELL_SHEETS_FAILED_MESSAGE: "Failed to load the template's sheets",
    TEMPLATE_CELL_KIND_CELL: "Cell",
    TEMPLATE_CELL_KIND_NAME: "Defined name",
    TEMPLATE_CELL_ADDRESS_LABEL: "Cell address",
    TEMPLATE_CELL_NAME_LABEL: "Defined name to use",
    TEMPLATE_CELL_CELL_PLACEHOLDER: "For example C7",
    TEMPLATE_CELL_NAME_PLACEHOLDER: "Choose or type a defined name",
    TEMPLATE_CELL_CHECKING: "Checking…",
    TEMPLATE_CELL_VALID_MESSAGE: (address: string | null) => (address ? `Found at ${address}` : "Found"),
    TEMPLATE_CELL_NOT_FOUND_MESSAGE: "That cell was not found in the template",
    TEMPLATE_CELL_INCOMPLETE_MESSAGE: "Choose a template, a sheet, and a cell or defined name",
    TEMPLATE_CELL_VALIDATE_FAILED_MESSAGE: "Could not check the cell",
    TEMPLATE_CELL_MAPPINGS: {
      TITLE: "Template cell mappings",
      ENTITY_LABEL: "Show for entity",
      ENTITY_PLACEHOLDER: "All templates in your firm",
      ENTITY_NEEDS_CLIENT: "Pick a client in the header to choose an entity",
      ENTITIES_FAILED_MESSAGE: "Failed to load the entities",
      PROFILE_FAILED_MESSAGE: "Failed to load the calculation profiles",
      NO_PROFILE_MESSAGE: "This entity has no calculation profile for the selected tax year, so the table shows what applies to the client.",
      // The server's status values; any other value is shown as sent.
      STATUS_CURRENT: "Current",
      STATUS_OTHER_VERSION: "Other version of the template (save the line again to validate it)",
      EMPTY: "No lines on this form are mapped to a template cell",
      LINE_HEADER: "Line",
      TEMPLATE_HEADER: "Template",
      VERSION_HEADER: "Version",
      SHEET_HEADER: "Sheet",
      CELL_HEADER: "Cell",
      STATUS_HEADER: "Status",
    },
    SHARED_FORM_BADGE: "Shared",
    TENANT_FORM_BADGE: "Yours",
    // WO-38 Stage 1: read-only "Fed by" view. Shows what the server sent; no tax arithmetic.
    FED_BY: {
      COLUMN_HEADER: "Fed by",
      EMPTY_FEEDERS: "No calculation output feeds this line yet",
      EMPTY_FEEDERS_SHORT: "Not fed yet",
      NOT_USED: "Not used by calculations",
      SHADOWED: (lineName: string | null) =>
        lineName ? `Fed through another line (${lineName})` : "Fed through another line",
      CONFLICT_CHIP: "More than one output feeds this line",
      FAILED_MESSAGE: "Could not load which calculations feed these lines",
      PANEL_TITLE: "Fed by",
      FIRM_WIDE_NOTICE:
        "This view covers every template in your firm, so some conflicts shown may not apply to the client you work on. Pick a client and tax year in the header to see only what applies.",
      CLIENT_NOTICE: (clientName: string | null, taxYear: string | null) =>
        `Showing what applies to ${clientName ?? "the selected client"}${taxYear ? `, ${taxYear}` : ""}.`,
      PROFILE_NOTICE: (taxYear: string | null) =>
        `Showing what applies to the selected calculation profile${taxYear ? `, ${taxYear}` : ""}.`,
      // Placed/unplaced/conflict count template output codes; unfed counts mapped lines. The units
      // differ, so each part names its own.
      COUNTS: (placed: number, unplaced: number, conflict: number, unfed: number) =>
        `${placed} calculation ${placed === 1 ? "output is" : "outputs are"} placed on a line. ` +
        `${unfed} mapped ${unfed === 1 ? "line is" : "lines are"} not fed by any calculation. ` +
        `${unplaced} ${unplaced === 1 ? "output has" : "outputs have"} no line, ` +
        `${conflict} ${conflict === 1 ? "output is" : "outputs are"} fed by more than one template.`,
      DETAILS_TOGGLE: "Form details",
      TEMPLATES_TITLE: "Templates",
      NO_TEMPLATES: "No templates to show",
      CODE_STATUS_PLACED: "Placed",
      CODE_STATUS_UNPLACED: "Not placed on a line",
      CODE_STATUS_CONFLICT: "In conflict",
      PLACED_ON: (lineName: string) => `on ${lineName}`,
      NOT_SHOWN: (count: number) => `Not shown here: ${count} calculation${count === 1 ? "" : "s"} skipped`,
      UNNAMED_ITEM: "Unnamed calculation",
    },
  },

  COA_MAPPING_GLOBAL: {
    PAGE_TITLE: "Global CoA Mapping",
    PAGE_SUBTITLE:
      "Tenant-wide default account-name-to-K-1-line mapping. Individual clients can still override specific accounts on their own CoA Mapping screen.",
    DOWNLOAD_BUTTON_TEXT: "Download",
    UPLOAD_BUTTON_TEXT: "Upload",
    RESTORE_DEFAULT_BUTTON_TEXT: "Restore Default",
    REVERT_CONFIRM_TITLE: "Revert to CalcEngine default?",
    REVERT_CONFIRM_DESCRIPTION:
      "This removes your tenant's custom mapping and falls back to the seeded default.",
    REVERT_OK_TEXT: "Revert",
    TENANT_OVERRIDE_LABEL: "Tenant Override",
    CALCENGINE_DEFAULT_LABEL: "CalcEngine Default",
    ACCOUNTS_MAPPED_TEXT: (count: number) =>
      `${count} account${count === 1 ? "" : "s"} mapped`,
    LOADING_TEXT: "Loading…",
    EMPTY_STATE_MESSAGE: "No global mapping rows found.",
    FAILED_TO_LOAD_MESSAGE: "Failed to load global CoA mapping",
    DOWNLOAD_FILE_NAME: "coa-global-mapping.xlsx",
    FAILED_TO_DOWNLOAD_MESSAGE: "Failed to download global CoA mapping",
    REVERTED_SUCCESS_MESSAGE: "Reverted to CalcEngine default mapping",
    FAILED_TO_RESTORE_MESSAGE: "Failed to restore default mapping",
    UPLOAD_SUCCESS_MESSAGE: (saved: number, skippedNote: string) =>
      `Uploaded — ${saved} row(s) saved${skippedNote}`,
    // ACCOUNT_NAME_COLUMN_HEADER moved to GLOBAL_CONSTANT — also used by
    // CalculationsView/ProjectWorkspace's trial balance panel.
    CATEGORY_COLUMN_HEADER: "Category (K-1 Line)",
  },

  STANDARD_CALCULATIONS: {
    NAME_PATTERN: /^[A-Za-z0-9\s]+$/,
    INVALID_NAME_MESSAGE:
      "Invalid name - only letters and numbers are allowed.",
    DUPLICATE_NAME_MESSAGE: (name: string) =>
      `Calculation "${name}" already exists`,
  },

  // External K1 Intake (WO-3 Part 2, ADO 34673, wiki FR-20.5) — reverse-mapping admin screen.
  EXTERNAL_K1_MAPPING: {
    PAGE_TITLE: "External K1 Mapping",
    PAGE_SUBTITLE: "Map an externally-uploaded K-1's Box/Code to a K-1 tax form line.",
    ADD_BUTTON_TEXT: "Add Mapping",
    EDIT_BUTTON_TEXT: "Edit",
    DELETE_BUTTON_TEXT: "Delete",
    DELETE_CONFIRM_TITLE: "Deactivate this mapping?",
    SCOPE_COLUMN_HEADER: "Scope",
    CLIENT_COLUMN_HEADER: "Client",
    BOX_COLUMN_HEADER: "Box",
    CODE_COLUMN_HEADER: "Code",
    DESCRIPTION_COLUMN_HEADER: "Description",
    TARGET_LINE_COLUMN_HEADER: "Target K-1 Line",
    TAX_YEAR_COLUMN_HEADER: "Tax Year",
    SCOPE_FILTER_PLACEHOLDER: "Filter by scope",
    MODAL_TITLE_CREATE: "Add External K1 Mapping",
    MODAL_TITLE_EDIT: "Edit External K1 Mapping",
    SCOPE_LABEL: "Scope",
    CLIENT_LABEL: "Client",
    BOX_LABEL: "Box",
    BOX_PLACEHOLDER: "e.g. 13",
    CODE_LABEL: "Code (optional — blank applies to the whole box)",
    CODE_PLACEHOLDER: "e.g. W",
    DESCRIPTION_LABEL: "Description (optional, for reference)",
    TARGET_LINE_LABEL: "Target K-1 line",
    TARGET_LINE_PLACEHOLDER: "Search K-1 lines…",
    TAX_YEAR_LABEL: "Tax year (optional — blank applies to all years)",
    BOX_REQUIRED_MESSAGE: "Box is required.",
    TARGET_LINE_REQUIRED_MESSAGE: "Target K-1 line is required.",
    CLIENT_REQUIRED_MESSAGE: "Client is required for a client-scoped row.",
    SAVED_MESSAGE: "Mapping saved.",
    DEACTIVATED_MESSAGE: "Mapping deactivated.",
    FAILED_TO_LOAD_MESSAGE: "Failed to load mappings.",
    FAILED_TO_LOAD_LINES_MESSAGE: "Failed to load K-1 tax form lines.",
    GENERIC_ERROR_MESSAGE: "Something went wrong — try again.",
  },
};

//TemplateView screen constants
export const TEMPLATE_VIEW_CONSTANT = {
  ENGINE_NAME_LABEL: "Engine Name",
  IMPORT_TEMPLATE_BUTTON_LABEL: "Import Template",
  SEARCH_TEMPLATES_PLACEHOLDER: "Search Templates",
  PUBLISH_TEMPLATE_BUTTON_LABEL: "Publish Template",
  SHEETS_HEADING: "Sheets",
  ADD_NEW_SHEET_BUTTON_LABEL: "Add New Sheet",
  DRAG_TO_REORDER_TOOLTIP: "Drag to reorder",
  DEPENDENCIES_HEADING: "Dependencies",
  NO_DEPENDENCIES_HEADING: "No Dependencies",

  SHEET_CREATE: {
    SHEET_NAME_PLACEHOLDER: "Sheet Name",
    ADD_COLUMN_BUTTON_LABEL: "Add Column",
    COLUMN_HEADING_1_LABEL: "Heading 1",
    COLUMN_HEADING_2_LABEL: "Heading 2",
    COLUMN_TYPE_LABEL: "Type",
    INPUT_TYPE_LABEL: "Input",
    ROW_REFERENCE_TYPE_LABEL: "Row Reference",
    COLUMN_REFERENCE_TYPE_LABEL: "Column Reference",
    CALCULATION_TYPE_LABEL: "Calculation",
    DIAGNOSTICS_TYPE_LABEL: "Diagnostics",
    REFERENCE_DATA_LABEL: "Reference Data",
    SELECT_SHEET_PLACEHOLDER: "Select Sheet",
    SELECT_COLUMN_PLACEHOLDER: "Select Column",
    LOOP_ORDER_LABEL: "Loop Order",
  },
};

//shared/screen-components/DeliverableCreateComponent constants
export const DELIVERABLE_CREATE_COMPONENT_CONSTANT = {
  CREATE_DELIVERABLE_BUTTON_LABEL: "Create Deliverable",
  CREATE_NEW_DELIVERABLE_LABEL: "Create New Deliverable",
  DELIVERABLE_CREATED: "Deliverable created successfully",
  ENTER_DELIVERABLE_NAME: "Enter Deliverable Name",
  ENTER_DELIVERABLE_NAME_MESSAGE: "Please enter your Deliverable Name",
  FILTER_COA_LABEL: "CoA",
  SELECT_COA: "Select CoA",
  SELECT_TAG: "Select Tag",
  SELECT_TEMPLATE: "Select Template",
  SELECT_TEMPLATE_MESSAGE: "Please select Template",
};

//shared/screen-components/DeliverableMenuComponent constants
export const DELIVERABLE_MENU_COMPONENT_CONSTANT = {
  DASHBOARD: "Dashboard",
  FILTER_TEMPLATE_LABEL: "Template",
};

// TC-19.2.12: sheet edit session locks (DeliverableMenuComponent / useSheetEditLock).
export const SHEET_EDIT_LOCK_CONSTANT = {
  STATUS_POLL_INTERVAL_MS: 30000,
  EDITING_BY: (name: string) => `${name} is editing`,
  IMPORTING_BY: (name: string) => `${name} is importing`,
  EDITING_IN_ANOTHER_TAB: "You are editing this sheet in another tab",
  EDIT_BLOCKED: "This sheet is locked by another user",
  LOCK_LOST:
    "Your edit lock has expired. Another user may now edit this sheet; saving may be blocked.",
  CANCEL_RELEASE_FAILED:
    "Edit cancelled, but the lock could not be released. It expires in a few minutes.",
};

//shared/screen-components/ExcelViewComponent constants (SpreadSheetViewComponent.tsx + ExcelViewComponent.helper.ts)
export const EXCEL_VIEW_COMPONENT_CONSTANT = {
  MAX_RECORDS_FOR_SHEET: 1000000,
  IMPORT_SUCCESS_MESSAGE: "Imported successfully",
  IMPORT_TASK_PENDING_MESSAGE: "Import task is in progress.",
  IS_SHEET_CHANGED: "Do you want to save the unsaved changes?",
  SAVE_TASK_PENDING_MESSAGE: "Save task is in progress.",
  SAVE_SUCCESS: "Changes saved successfully",
  SAVE_ERROR: "Error while saving",
};

//shared/screen-components/CommonCreateComponent constants
export const COMMON_CREATE_COMPONENT_CONSTANT = {
  COA_CREATED_MESSAGE: "CoA created successfully",
  TEMPLATE_CREATED_MESSAGE: "Template created successfully",
  PLEASE_ATTACH_A_FILE_MESSAGE: "Please attach a file",
  ENTER_TEMPLATE_NAME_MESSAGE: "Please enter Template Name",
  ENTER_COA_NAME_MESSAGE: "Please enter Coa Name",
  ATTACH_FILE_LABEL: "Attach File",
  ATTACH_FILE_REQUIRED_MESSAGE: "Please attach a File",
  SELECT_FILE_BUTTON_TEXT: "Select File",
  STANDARD_CALCULATION_LABEL: "Standard Calculation",
  SELECT_STANDARD_CALCULATION_PLACEHOLDER: "Select a standard calculation…",
  STANDARD_CALCULATION_REQUIRED_MESSAGE: "Please select a Standard Calculation",
  STANDARD_CALCULATIONS_LOAD_FAILED_MESSAGE: "Could not load standard calculations",
};

//shared/utils/ExcelFormulaEvaluator constants
export const EXCEL_FORMULA_EVALUATOR_CONSTANT = {
  NODE_TYPE: {
    FUNCTION: "function",
    BINARY_EXPRESSION: "binary-expression",
    CELL: "cell",
    NUMBER: "number",
    TEXT: "text",
  },
  UNSUPPORTED_FUNCTION_MESSAGE: "Unsupported function",
  UNSUPPORTED_NODE_TYPE_MESSAGE: "Unsupported node type",
};

//ConfigurationsView screen constants — nested per sub-screen (CalcProfile, Templates, TemplateEditor, PartnershipSettings)
export const STANDARD_CALC_DETAIL_CONSTANT = {
  CIRCULAR_DEPENDENCY_TOOLTIP:
    "Not allowed: this would create a circular dependency",
  DEPENDENCIES_PICKER_MAX_HEIGHT: "11.25rem",
  CIRCULAR_OPTION_OPACITY: 0.45,
};

export const CONFIGURATIONS_VIEW_CONSTANT = {
  // Shared across CalcProfile.tsx + Templates.tsx (byte-for-byte identical maps/checks in both files)
  SC_CATEGORY_COLORS: {
    Tax: { bg: "rgba(37,99,235,0.15)", color: "#60a5fa" },
    Allocation: { bg: "rgba(242,101,34,0.15)", color: "#F26522" },
    Capital: { bg: "rgba(124,58,237,0.15)", color: "#a78bfa" },
    Depreciation: { bg: "rgba(20,184,166,0.15)", color: "#2dd4bf" },
    Output: { bg: "rgba(34,197,94,0.15)", color: "#22c55e" },
    Event: { bg: "rgba(255,255,255,0.07)", color: "#9ca3af" },
  } as Record<string, { bg: string; color: string }>,
  UNTAGGED_COLORS: { bg: "rgba(255,255,255,0.06)", color: "#6b7280" },
  MAX_UPLOAD_FILE_SIZE_BYTES: 50 * 1024 * 1024,
  FILE_SIZE_LIMIT_MESSAGE: "File exceeds 50 MB limit",
  READY_TO_UPLOAD_MESSAGE: (fileName: string) => `${fileName} ready to upload`,
  SAVING_TEXT: "Saving…",
  STANDARD_CALCULATION_LABEL: "Standard Calculation",

  CALC_PROFILE: {
    // DepWarning / AddCalcModal dependency tooltips
    DEPENDS_ON_WARNING: (names: string) =>
      `Depends on ${names} — add it to the profile`,
    DEPENDS_ALSO_ADD_WARNING: (names: string) =>
      `Depends on ${names} — also add it`,

    // AssignTemplateModal
    ASSIGN_TEMPLATE_MODAL_TITLE: "Assign Template",
    ASSIGN_TEMPLATE_MODAL_WIDTH_PX: 520,
    TEMPLATE_ASSIGNED_MESSAGE: (fileName: string) =>
      `Template assigned: ${fileName}`,
    FAILED_TO_ASSIGN_TEMPLATE_MESSAGE: "Failed to assign template",
    DROP_ZONE_UPLOAD_TEXT: "Drag & drop or click to upload",
    XLSX_FILE_HINT_TEXT: ".xlsx files only · max 50 MB",
    UPLOAD_AND_ASSIGN_BUTTON_LABEL: "Upload & Assign",

    // CalcProfileTab
    PERIOD_LABEL: "Period",
    EVENT_LABEL: "Event",
    NO_CALCULATIONS_IN_PROFILE_TEXT: (typeLabel: string) =>
      `No ${typeLabel} calculations in this profile.`,
    ADD_CALCULATION_HINT_TEXT: "Click + Add Calculation to get started.",
    // CATEGORY_COLUMN_HEADER moved to GLOBAL_CONSTANT — also used by
    // CalculationsView/ProjectWorkspace's trial balance panel.
    TYPE_COLUMN_HEADER: "Type",
    TEMPLATE_COLUMN_HEADER: "Template",
    CLIENT_COPY_BADGE_LABEL: "Client Copy",
    GLOBAL_LIBRARY_BADGE_LABEL: "Global Library",
    DOWNLOAD_TEMPLATE_TOOLTIP: "Download template",
    REVERT_TEMPLATE_TOOLTIP: "Revert to global library template",
    NO_TEMPLATE_ASSIGNED_TEXT: "No template assigned",
    CONFIGURE_CHAINED_INPUTS_TOOLTIP: "Configure chained inputs",
    REMOVE_ITEM_TOOLTIP: (name: string) => `Remove ${name}`,
    CALCULATIONS_FOOTER_TEXT: (
      count: number,
      typeLabel: string,
      totalCount: number,
    ) =>
      `Showing ${count} ${typeLabel} calculation${count !== 1 ? "s" : ""} · ${totalCount} total in profile`,

    // AddCalcModal
    CALCULATIONS_ADDED_MESSAGE: (count: number) =>
      `${count} calculation${count !== 1 ? "s" : ""} added to profile`,
    FAILED_TO_ADD_CALCULATIONS_MESSAGE: "Failed to add calculations",
    PERIOD_CALCULATIONS_GROUP_LABEL: "Period Calculations",
    EVENT_CALCULATIONS_GROUP_LABEL: "Event Calculations",
    SELECT_CALCULATIONS_STEP_LABEL: "Select calculations",
    ASSIGN_TEMPLATES_STEP_LABEL: "Assign templates",
    ALL_CALCULATIONS_IN_PROFILE_TEXT:
      "All standard calculations are already in this profile.",
    NEXT_ASSIGN_TEMPLATES_BUTTON_LABEL: "Next — Assign Templates",
    TEMPLATE_SELECTION_OPTIONAL_TEXT:
      "Template selection is optional — you can assign templates later.",
    NO_TEMPLATES_AVAILABLE_PLACEHOLDER:
      "No templates available — upload one first",
    ALL_TEMPLATES_FALLBACK_PLACEHOLDER:
      "All templates (none tagged to this SC)",
    NO_TEMPLATE_ASSIGNED_OPTIONAL_PLACEHOLDER:
      "No template assigned (optional)",
    ACTIVE_SUFFIX_LABEL: " (active)",
    UNTAGGED_SUFFIX_LABEL: " (untagged)",
    ADDING_TEXT: "Adding…",
    ADD_CALCULATIONS_TO_PROFILE_BUTTON_LABEL: (count: number) =>
      `Add ${count} Calculation${count !== 1 ? "s" : ""} to Profile`,
    ADD_CALCULATION_MODAL_TITLE: "Add Calculation to Profile",
    ADD_CALC_MODAL_WIDTH_PX: 600,

    // Pull latest template (TC-19.1.10)
    PULL_LATEST_TEMPLATE_TOOLTIP: "Pull latest template",
    PULL_LATEST_CONFIRM_TITLE: (name: string) => `Pull the latest template into ${name}?`,
    PULL_LATEST_CONFIRM_TEXT:
      "This calculation will use its rule engine's latest template version. Existing projects keep the version they were created with; projects created afterwards use the new one.",
    PULL_LATEST_CONFIRM_OK: "Pull latest",
    PULLED_LATEST_MESSAGE: (name: string, version: string) => `${name} now uses template ${version}`,
    ALREADY_LATEST_MESSAGE: (name: string) => `${name} is already on the latest template version`,
    FAILED_TO_PULL_LATEST_MESSAGE: "Failed to pull the latest template",
    PULL_LATEST_WARNINGS_TITLE: "Some links no longer match the new template",
    PULL_LATEST_WARNINGS_TEXT:
      "These links were kept, but their sheet is not in the new template version:",

    // ConfigureLinksModal
    FAILED_TO_LOAD_CHAINED_SHEETS_MESSAGE: "Failed to load chained sheets",
    FAILED_TO_LOAD_OUTPUT_SHEETS_MESSAGE:
      "Failed to load output sheets for the selected calculation",
    SHEET_LINKED_MESSAGE: (sheetName: string) => `${sheetName} linked`,
    FAILED_TO_SAVE_LINK_MESSAGE: "Failed to save link",
    SHEET_LINK_REMOVED_MESSAGE: (sheetName: string) =>
      `${sheetName} link removed`,
    FAILED_TO_REMOVE_LINK_MESSAGE: "Failed to remove link",
    CONFIGURE_LINKS_MODAL_TITLE: (name: string) => `Configure Links — ${name}`,
    CONFIGURE_LINKS_MODAL_WIDTH_PX: 560,
    LINK_WORKBOOK_MODAL_WIDTH_PX: 880,
    LINK_WORKBOOK_BUTTON_LABEL: "Link Workbook",
    BACK_TO_LINKS_BUTTON_LABEL: "Back",
    SOURCE_TEMPLATE_PLACEHOLDER: "Source template",
    TARGET_TEMPLATE_PLACEHOLDER: "Target template",
    NO_CHAINED_SHEETS_TEXT:
      "This calculation's template has no sheets configured to accept chained input.",
    SOURCE_CALCULATION_PLACEHOLDER: "Source calculation",
    SOURCE_SHEET_PLACEHOLDER: "Source sheet",
    FAILED_TO_LOAD_TEMPLATE_SHEETS_MESSAGE: "Failed to load the template sheets",
    NOT_MAPPED_TO_RULE_ENGINE_TEXT:
      "This calculation is not mapped to a rule engine template, so its sheets can't be linked.",
    NO_TEMPLATE_SHEETS_TEXT: "The mapped template has no sheets.",
    SOURCE_NOT_MAPPED_SUFFIX: " (no rule engine template)",
    REMOVING_TEXT: "Removing…",
    REMOVE_LINK_BUTTON_LABEL: "Remove Link",
    SAVE_LINK_BUTTON_LABEL: "Save Link",
    // FR-19.4 column mapping
    FAILED_TO_LOAD_LINK_CONFIG_MESSAGE: "Failed to load the link configuration",
    FAILED_TO_LOAD_TARGET_COLUMNS_MESSAGE: "Failed to load the columns of the target sheet",
    NO_LINK_SOURCES_TEXT:
      "No calculation in this profile has a mapped template to link from.",
    NO_LINK_TARGET_SHEETS_TEXT:
      "No mapped template has input sheets that can receive a link.",
    RETRY_BUTTON_LABEL: "Retry",
    SOURCE_PANE_TITLE: "Source",
    TARGET_PANE_TITLE: "Target",
    SOURCE_COLUMN_PLACEHOLDER: "Source column",
    TARGET_SHEET_PLACEHOLDER: "Target sheet",
    TARGET_COLUMN_PLACEHOLDER: "Target column",
    NO_COLUMNS_TEXT: "No columns",
    ADD_MAPPING_BUTTON_LABEL: "Add Mapping",
    REMOVE_MAPPING_BUTTON_LABEL: "Remove",
    SAVE_MAPPINGS_BUTTON_LABEL: "Save Mappings",
    MAPPING_ENTRY_TITLE: (n: number) => `Mapping ${n}`,
    MAPPINGS_SAVED_MESSAGE: (count: number) =>
      `${count} mapping${count !== 1 ? "s" : ""} saved`,
    FAILED_TO_SAVE_MAPPINGS_MESSAGE: "Failed to save the column mappings",
    MAPPING_OVERRIDE_NOTE:
      "A target column has one source. Saving a mapping for a column that is already mapped, or mapping the same column twice, overrides the earlier mapping.",
    MAPPING_OVERRIDES_EARLIER_TEXT:
      "Same target column as an earlier mapping — this mapping overrides it.",

    // CalcProfile (main)
    FAILED_TO_LOAD_PROFILE_MESSAGE: "Failed to load calculation profile",
    ITEM_REMOVED_MESSAGE: (name: string) => `${name} removed from profile`,
    FAILED_TO_REMOVE_CALCULATION_MESSAGE: "Failed to remove calculation",
    FAILED_TO_DOWNLOAD_TEMPLATE_MESSAGE: "Failed to download template",
    TEMPLATE_REVERTED_MESSAGE: (name: string) =>
      `${name} reverted to the global library template`,
    FAILED_TO_REVERT_TEMPLATE_MESSAGE: "Failed to revert template",
    SELECT_CLIENT_PARTNERSHIP_TITLE: "Select a client and partnership",
    SELECT_CLIENT_PARTNERSHIP_TEXT: "to view the calculation profile",
    PAGE_TITLE: "Calculation Profile",
    PAGE_SUBTITLE: (name: string) =>
      `${name} · The calculations that apply to this partnership.`,
    COPY_PROFILE_NO_PROFILE_TOOLTIP:
      "Add a calculation before copying this profile",
    COPY_PROFILE_MODAL_TITLE: "Copy Profile",
    COPY_PROFILE_MODAL_INTRO: (source: string, year: string) =>
      `Copy the calculations, templates and chained inputs from ${source} (${year}) to other partnerships of this client. Targets that already have calculations are skipped, never overwritten.`,
    COPY_PROFILE_LOADING_TEXT: "Loading partnerships…",
    COPY_PROFILE_LOAD_FAILED_MESSAGE: "Failed to load the client's partnerships",
    COPY_PROFILE_NO_TARGETS_TEXT: "This client has no other partnerships to copy to.",
    COPY_PROFILE_TAX_YEAR_PLACEHOLDER: "FY2025",
    COPY_PROFILE_TAX_YEAR_ARIA_LABEL: (name: string) => `Target tax year for ${name}`,
    COPY_PROFILE_INVALID_YEAR_TEXT: "Enter a 4-digit tax year",
    COPY_PROFILE_SUBMIT_LABEL: (count: number) =>
      `Copy to ${count} partnership${count === 1 ? "" : "s"}`,
    COPY_PROFILE_FAILED_MESSAGE: "Failed to copy the profile",
    COPY_PROFILE_DONE_LABEL: "Done",
    COPY_PROFILE_RESULT_TITLE: "Copy results",
    COPY_PROFILE_GROUP_CREATED: "Created",
    COPY_PROFILE_GROUP_FILLED: "Filled (existing empty profile)",
    COPY_PROFILE_GROUP_SKIPPED: "Skipped",
    COPY_PROFILE_GROUP_FAILED: "Failed",
    COPY_PROFILE_RESULT_COUNTS: (items: number, links: number) =>
      `${items} calculation${items === 1 ? "" : "s"}, ${links} link${links === 1 ? "" : "s"}`,
    COPY_PROFILE_LINKS_SKIPPED_TEXT: (count: number) =>
      `${count} link${count === 1 ? "" : "s"} skipped (one end is outside the source profile)`,
    DELETE_BLOCKED_TITLE: "Can't remove this calculation",
    DELETE_BLOCKED_OK_LABEL: "Got it",
    DELETE_BLOCKED_REASON_DEPENDENT: "Other calculations depend on it",
    DELETE_BLOCKED_REASON_PROJECT: "Projects have it selected",
    ITEM_REMOVED_LINKS_MESSAGE: (name: string, links: number) =>
      `${name} removed (${links} chained-input link${links === 1 ? "" : "s"} also removed)`,
    COPY_PROFILE_BUTTON_LABEL: "Copy Profile",
    ADD_CALCULATION_BUTTON_LABEL: "Add Calculation",
    AUTO_ADDED_SINGLE_MESSAGE: (name: string) =>
      `${name} was automatically added as a dependency.`,
    AUTO_ADDED_MULTIPLE_MESSAGE: (names: string) =>
      `${names} were automatically added as dependencies.`,
    DISMISS_ARIA_LABEL: "Dismiss",
    SEQUENCING_TAB_LABEL: "Sequencing",

    // SequencingTab
    NO_CALCULATIONS_TITLE: "No calculations in profile.",
    ADD_CALCULATIONS_FIRST_TEXT:
      "Add calculations first to see the execution order.",
    NO_UPSTREAM_DEPENDENCY_TEXT: "no upstream dependency — can run first",
    MUST_RUN_AFTER_TEXT: "must run after",
    EXECUTION_ORDER_EXPLANATION_TEXT:
      "Execution order is set automatically based on declared dependencies. Adding a calculation will auto-include any missing dependencies.",
  },

  TEMPLATES: {
    // Upload-flow messages specific to Templates.tsx (accepts .xlsx AND .xlsm — different wording
    // from GLOBAL_CONSTANT.ONLY_XLSX_FILES_ACCEPTED_MESSAGE, which is .xlsx-only)
    ONLY_XLSX_XLSM_FILES_ACCEPTED_MESSAGE:
      "Only .xlsx and .xlsm files are accepted",
    XLSX_XLSM_FILE_HINT_TEXT: "Only .xlsx and .xlsm files accepted (max 50MB)",
    TEMPLATE_EDITOR_DRAWER_WIDTH: "92vw",

    // formatBytes / formatRelative helpers
    NO_VALUE_PLACEHOLDER: "—",
    FILE_SIZE_LABEL_BYTES: (bytes: number) => `${bytes} B`,
    FILE_SIZE_LABEL_KB: (bytes: number) => `${(bytes / 1024).toFixed(0)} KB`,
    FILE_SIZE_LABEL_MB: (bytes: number) =>
      `${(bytes / 1024 / 1024).toFixed(1)} MB`,
    RELATIVE_TIME_MINUTES: (mins: number) => `${mins}m ago`,
    RELATIVE_TIME_HOURS: (hrs: number) => `${hrs}h ago`,
    RELATIVE_TIME_DAYS: (days: number) =>
      `${days} day${days !== 1 ? "s" : ""} ago`,

    // ScBadge
    UNTAGGED_BADGE_LABEL: "Untagged",

    // TemplateDetailsModal
    TEMPLATE_DETAILS_MODAL_TITLE: (fileName: string) =>
      `Template Details — ${fileName}`,
    DETAILS_MODAL_WIDTH_PX: 640,
    SHEETS_TAB_LABEL: "Sheets",
    VERSIONS_TAB_LABEL: (count: number) => `Versions (${count})`,
    USED_BY_TAB_LABEL: "Used By",
    NO_SHEET_CONFIG_TEXT:
      "No sheet configuration detected — legacy-format template.",
    SHEET_COLUMN_HEADER: "Sheet",
    ROLE_COLUMN_HEADER: "Role",
    VERSION_COLUMN_HEADER: "Version",
    UPLOADED_COLUMN_HEADER: "Uploaded",
    STATUS_COLUMN_HEADER: "Status",
    ACTIVE_BADGE_LABEL: "Active",
    INACTIVE_BADGE_LABEL: "Inactive",
    NO_USAGE_TEXT:
      "No calculation profile item currently references this template.",
    ACTIVE_REFERENCES_COLUMN_HEADER: "Active References",

    // VersionsDrawer
    VERSION_ACTIVATED_MESSAGE: (versionNumber: number) =>
      `v${versionNumber} set as active`,
    FAILED_TO_ACTIVATE_VERSION_MESSAGE: "Failed to activate version",
    DEACTIVATE_VERSION_CONFIRM_TITLE: (versionNumber: number) =>
      `Deactivate v${versionNumber}?`,
    DEACTIVATE_VERSION_CONFIRM_CONTENT:
      "This version will no longer be usable by the calculation engine.",
    VERSION_DEACTIVATED_MESSAGE: (versionNumber: number) =>
      `v${versionNumber} deactivated`,
    FAILED_TO_DEACTIVATE_VERSION_MESSAGE: "Failed to deactivate version",
    DOWNLOAD_FAILED_MESSAGE: "Download failed",
    FAILED_TO_LOAD_TEMPLATES_MESSAGE: "Failed to load templates",
    FAILED_TO_LOAD_STANDARD_CALCULATIONS_MESSAGE: "Failed to load standard calculations",
    VERSION_HISTORY_DRAWER_TITLE: "Version History",
    VERSIONS_DRAWER_WIDTH_PX: 580,
    UPLOADED_BY_COLUMN_HEADER: "Uploaded By",
    DATE_COLUMN_HEADER: "Date",
    SIZE_COLUMN_HEADER: "Size",
    ACTION_COLUMN_HEADER: "Action",
    ACTIONS_COLUMN_HEADER: "Actions",
    DEFAULT_UPLOADED_BY_LABEL: "admin",
    DOWNLOAD_BUTTON_LABEL: "Download",
    ACTIVATE_BUTTON_LABEL: "Activate",
    LATEST_NOTE_PREFIX: (notes: string) => `Latest: ${notes}`,

    // TagScModal
    SC_ASSIGNED_MESSAGE: "Standard Calculation assigned",
    SC_TAG_ENDPOINT_NOT_IMPLEMENTED_MESSAGE:
      "BackEnd endpoint not yet implemented — SC tagging requires PATCH /api/template/{id}/sc",
    FAILED_TO_ASSIGN_SC_MESSAGE: "Failed to assign Standard Calculation",
    ASSIGN_SC_MODAL_TITLE: "Assign Standard Calculation",
    ASSIGN_SC_MODAL_WIDTH_PX: 480,
    TEMPLATE_LABEL_PREFIX: "Template:",
    SELECT_STANDARD_CALCULATION_PLACEHOLDER: "Select a standard calculation…",
    ASSIGN_BUTTON_LABEL: "Assign",

    // EditDetailsModal
    FAILED_TO_UPDATE_TEMPLATE_MESSAGE: "Failed to update template",
    TEMPLATE_UPDATED_MESSAGE: "Template updated",
    EDIT_TEMPLATE_MODAL_TITLE: "Edit Template",
    EDIT_TEMPLATE_MODAL_WIDTH_PX: 480,
    TEMPLATE_NAME_REQUIRED_MESSAGE: "Template name cannot be empty",
    TEMPLATE_NAME_PLACEHOLDER: "Template name",
    DESCRIPTION_OPTIONAL_LABEL: "Description (optional)",
    DESCRIPTION_PLACEHOLDER: "What this template is used for",

    // UploadModal
    UPLOAD_NEW_TEMPLATE_MODAL_TITLE: "Upload New Template",
    UPLOAD_MODAL_WIDTH_PX: 520,
    DRAG_DROP_EXCEL_TEXT:
      "Drag & drop your Excel template here, or click to browse",
    TEMPLATE_UPLOADED_FAILED_VALIDATION_MESSAGE:
      "Template uploaded but failed structure validation",
    TEMPLATE_UPLOADED_SUCCESS_MESSAGE: (fileName: string) =>
      `${fileName} uploaded successfully`,
    INVALID_TEMPLATE_STRUCTURE_TEXT:
      "Invalid template structure — cannot be assigned to a calc profile item",
    SHEETS_DETECTED_TEXT: (count: number) =>
      `${count} sheet${count !== 1 ? "s" : ""} detected:`,
    LEGACY_TEMPLATE_NO_SHEETS_TEXT:
      "Legacy-format template — no new-convention sheets detected.",
    STANDARD_CALCULATION_REQUIRED_MESSAGE:
      "Please select a standard calculation",
    VERSION_NOTES_OPTIONAL_LABEL: "Version Notes (optional)",
    VERSION_NOTES_PLACEHOLDER: "Version notes or changelog",
    DONE_BUTTON_LABEL: "Done",
    UPLOAD_TEMPLATE_BUTTON_LABEL: "Upload Template",

    // Templates (main)
    PAGE_TITLE: "Template Management",
    PAGE_SUBTITLE: "Upload, version, and assign Excel calculation templates",
    UPLOAD_TEMPLATE_HEAD_BUTTON_LABEL: "+ Upload Template",
    SEARCH_TEMPLATES_PLACEHOLDER: "Search templates…",
    ALL_STANDARD_CALCULATIONS_OPTION_LABEL: "All Standard Calculations",
    ALL_STATUSES_OPTION_LABEL: "All Statuses",
    ACTIVE_OPTION_LABEL: "Active",
    INACTIVE_OPTION_LABEL: "Inactive",
    NO_TEMPLATES_FOUND_TITLE: "No templates found",
    TRY_CLEARING_FILTERS_TEXT: "Try clearing the filters.",
    UPLOAD_FIRST_TEMPLATE_HINT_TEXT:
      'Click "+ Upload Template" to add the first template.',
    TEMPLATE_NAME_COLUMN_HEADER: "Template Name",
    ACTIONS_MORE_ARIA_LABEL: "More actions",
    DETAILS_MENU_LABEL: "Details",
    EDIT_MENU_LABEL: "Edit",
    OPEN_EDITOR_MENU_LABEL: "Open Editor",
    VERSIONS_MENU_LABEL: (count: number) => `Versions (${count})`,
    TAG_SC_MENU_LABEL: "Tag SC",
    TEMPLATE_COUNT_FOOTER_TEXT: (count: number) =>
      `${count} template${count !== 1 ? "s" : ""}`,
    FILTERED_FROM_SUFFIX_TEXT: (totalCount: number) =>
      ` (filtered from ${totalCount})`,
    TEMPLATE_EDITOR_DRAWER_TITLE: "Template Editor",
  },

  TEMPLATE_EDITOR: {
    GRID_THEME_PARAMS: {
      backgroundColor: "rgb(8,12,28)",
      foregroundColor: "rgba(255,255,255,0.80)",
      headerBackgroundColor: "rgba(26,39,68,0.95)",
      headerTextColor: "rgba(255,255,255,0.50)",
      rowHoverColor: "rgba(255,255,255,0.04)",
      borderColor: "rgba(255,255,255,0.08)",
      fontSize: 13,
    },
    SAVED_VERSION_MESSAGE: "Saved as new template version",
    SAVE_FAILED_MESSAGE: "Save failed",
    INPUT_LEGEND_LABEL: "Input",
    FORMULA_LEGEND_LABEL: "Formula",
    OUTPUT_LEGEND_LABEL: "Output",
    // SAVING_TEXT moved to GLOBAL_CONSTANT — also used by CalculationsView/ProjectWorkspace.
    SAVE_VERSION_BUTTON_LABEL: "Save Version",
    LOADING_TEMPLATE_TEXT: "Loading template...",
    TEMPLATE_UNAVAILABLE_TEXT:
      "Template data unavailable — check template upload and try again.",
    LIVE_K1_OUTPUT_LABEL: "Live K-1 Output",
    RECALCULATING_TEXT: "Recalculating...",
    PARTNERS_LABEL: "Partners",
    NO_VALUE_PLACEHOLDER: "—",
    K1_OUTPUT_LINES: [
      { key: "L1", label: "Ordinary Income", icon: "↗" },
      { key: "L5", label: "Interest Income", icon: "↗" },
      { key: "L9a", label: "Net LT Cap Gain", icon: "↗" },
      { key: "L13", label: "Depreciation", icon: "↘" },
      { key: "L16", label: "Foreign Tax", icon: "→" },
      { key: "L20", label: "Ending Capital", icon: "↗" },
    ],
  },

  PARTNERSHIP_SETTINGS: {
    TAX_YEAR_END_DATE_FORMAT: "DD/MM/YYYY",
    TAX_YEAR_END_SAVED_MESSAGE: "Tax year end saved",
    MODULE_PROCESSING_SECTION_LABEL: "Module & Processing",
    FIXED_ASSET_MODULE_TITLE: "Fixed Asset Module",
    FIXED_ASSET_MODULE_DESC:
      "Enable or disable the fixed asset module for this partnership. Disable for investment-only funds.",
    PROCESSING_MODE_TITLE: "Calculation Processing Mode",
    PROCESSING_MODE_DESC:
      "How calculations are processed. External partnerships are excluded from the engine but remain in tiering structure.",
    // Display labels for the mode toggle buttons — NOT the calculationProcessingMode type-discriminant
    // value passed to handleModeChange()/the service, which must stay the raw 'CalcEngine' / 'External' literal.
    CALC_ENGINE_MODE_LABEL: "CalcEngine",
    EXTERNAL_MODE_LABEL: "External",
    GUARANTEED_PAYMENTS_TITLE: "Guaranteed Payments",
    GUARANTEED_PAYMENTS_DESC:
      "Flag whether any partners receive guaranteed payments.",
    TAX_ACCOUNTING_SECTION_LABEL: "Tax & Accounting",
    TAX_YEAR_END_TITLE: "Tax Year End",
    TAX_YEAR_END_DESC: "Partnership tax year-end date.",
    SAVE_SETTINGS_BUTTON_LABEL: "Save Settings",
    FAILED_TO_LOAD_SETTINGS_MESSAGE: "Failed to load partnership settings",
    FAILED_TO_SAVE_SETTINGS_MESSAGE: "Failed to save settings",
    PAGE_TITLE: "Settings",
    PAGE_SUBTITLE: (name: string) =>
      `${name} · Configure before running any calculations.`,
    PARTNERS_TAB_LABEL: "Partners",
    EXTERNAL_K1_INPUT_LABEL: "External K-1 Input",
    SALT_TAB_LABEL: "State & Local Tax",
    SALT_COMING_SOON_TITLE: "State & Local Tax Settings",
    SELECT_CLIENT_PARTNERSHIP_TEXT:
      "Select a client and partnership to view settings",
    SETTINGS_SAVED_AUTOMATICALLY_TEXT: "Settings saved automatically",
  },
};

//CalculationsView constants — nested per sub-screen
export const CALCULATIONS_VIEW_CONSTANT = {
  ACCOUNT_ID_COLUMN_HEADER: "Account ID",
  AMOUNT_COLUMN_HEADER: "Amount",

  UPLOAD_INPUT: {
    PAGE_TITLE: "Upload Input",
    PAGE_SUBTITLE:
      "Upload Excel files to populate calculation inputs for this engagement.",
    UPLOADING_FOR_PREFIX: "Uploading for:",
    INPUT_TYPE_COLUMN_HEADER: "Input Type",
    DESCRIPTION_COLUMN_HEADER: "Description",
    UPLOAD_FILE_COLUMN_HEADER: "Upload File",
    TEMPLATE_COLUMN_HEADER: "Template",
    STATUS_COLUMN_HEADER: "Status",
    GO_TO_COA_MAPPING_TEXT: "Go to CoA Mapping",
    UPLOAD_FILE_BUTTON_TEXT: "Upload File",
    READY_STATUS_LABEL: "Ready",
    CONFIGURE_STATUS_LABEL: "Configure →",
    COMING_SOON_STATUS_LABEL: "Coming Soon",
    UPLOAD_ANOTHER_TEXT: "Upload another",
    RETRY_TEXT: "Retry",
    TRIAL_BALANCE_ROWS_LOADED_TEXT: (count: number) =>
      `${count} trial balance row${count === 1 ? "" : "s"} already loaded`,
    MAP_ACCOUNTS_TEXT: "Map Accounts",
    UPLOAD_ANOTHER_FILE_TEXT: "Upload another file",
    DOWNLOAD_TEMPLATE_BUTTON_TEXT: "Download Template",
    FAILED_TO_DOWNLOAD_TEMPLATE_MESSAGE: (name: string) =>
      `Failed to download template for ${name}`,
    PARTNERS_IMPORTED_MESSAGE: (imported: number) =>
      `${imported} partners imported`,
    TRIAL_BALANCE_IMPORTED_MESSAGE: (imported: number) =>
      `Trial balance imported — ${imported} rows`,
    UPLOADED_SUCCESSFULLY_MESSAGE: "Uploaded successfully",
    PARTIAL_IMPORT_MESSAGE: (imported: number, skipped: number) =>
      `${imported} imported, ${skipped} skipped — see errors for detail`,
    NO_RECORDS_IMPORTED_MESSAGE: "0 records imported — check file format",
  },

  // External K1 Intake (WO-3 Part 2, ADO 34673, wiki FR-20.5).
  EXTERNAL_K1: {
    MODAL_TITLE: "Upload External K-1",
    ENTITY_LABEL: "External partnership",
    ENTITY_PLACEHOLDER: "Select the external lower-tier partnership",
    NO_EXTERNAL_ENTITIES_MESSAGE: "No entity for this client is marked External — mark one on the Entities screen first.",
    NO_CLIENT_MESSAGE: "Select a client before uploading an external K-1.",
    TAX_YEAR_LABEL: "Tax year",
    YEAR_PLACEHOLDER: "e.g. 2024",
    YEAR_INVALID_MESSAGE: "Enter a four-digit year, e.g. 2024.",
    RECEIVING_LABEL: "Receiving partnership",
    RECEIVING_PLACEHOLDER: "Select the partnership that receives this K-1",
    RECEIVING_PROJECT_LABEL: "Receiving project",
    RECEIVING_PROJECT_PLACEHOLDER: "Select the project this K-1 belongs to",
    NO_RECEIVERS_MESSAGE: (external: string) =>
      `${external} isn't linked to any partnership. Add the relationship under Tiering first.`,
    NO_RECEIVING_PROJECT_MESSAGE: (receiving: string, year: number) =>
      `Create the project for ${receiving} FY${year} first.`,
    CHOOSE_PROJECT_HINT: (receiving: string, count: number, year: number) =>
      `${receiving} has ${count} FY${year} projects. Choose the one this K-1 belongs to.`,
    PDF_PARTNERSHIP_LINE: (name: string | null, id: string | null) =>
      `Issuing partnership on the K-1: ${name ?? "—"}${id ? ` · ${id}` : ""}`,
    PDF_PARTNER_LINE: (name: string | null, id: string | null) =>
      `Partner on the K-1: ${name ?? "—"}${id ? ` · ${id}` : ""}`,
    FILE_LABEL: "K-1 PDF",
    PREVIEW_BUTTON_TEXT: "Preview",
    CONFIRM_BUTTON_TEXT: "Confirm",
    PREVIEWING_TEXT: "Previewing…",
    CONFIRMING_TEXT: "Confirming…",
    BOX_COLUMN_HEADER: "Box",
    CODE_COLUMN_HEADER: "Code",
    AMOUNT_COLUMN_HEADER: "Amount",
    MAPPED_TO_COLUMN_HEADER: "Mapped to",
    STATUS_COLUMN_HEADER: "Status",
    MAPPED_BADGE_LABEL: "Mapped",
    UNMAPPED_BADGE_LABEL: "Unmapped",
    ALL_EMPTY_WARNING: "No K-1 box values were found in this PDF.",
    PREVIEWED_STALE_HINT: "The file, entity, year or receiving partnership changed since the last preview — preview again before confirming.",
    UNMAPPED_LINES_HINT: "Some lines have no mapping yet. Pick a K-1 line for each one; every pick is saved as a mapping for this client.",
    PICKS_REQUIRED_HINT: "Pick a K-1 line for every unmapped line to confirm.",
    UPLOAD_ANOTHER_BUTTON_TEXT: "Upload another",
    ALREADY_CURRENT_MESSAGE: "Same file already uploaded — nothing changed.",
    HISTORY_BUTTON_TEXT: "History",
    HISTORY_MODAL_TITLE: "External K-1 Upload History",
    HISTORY_EMPTY_TEXT: "No uploads yet for this partnership.",
    FILE_NAME_COLUMN_HEADER: "File",
    UPLOADED_AT_COLUMN_HEADER: "Uploaded",
    // WO-12 Part B — inline mapping of unmapped lines.
    PICK_LINE_PLACEHOLDER: "Pick a K-1 line…",
    PICK_LINE_UNAVAILABLE_PLACEHOLDER: "K-1 line list unavailable",
    PICK_LINE_ARIA_LABEL: (box: string, code: string | null) => `K-1 line for Box ${box}${code ? ` Code ${code}` : ""}`,
    PICK_SAVED_HINT: "Will be saved as a mapping for this client",
    LINES_UNAVAILABLE_MESSAGE:
      "We couldn't load the K-1 line list, so unmapped lines can't be mapped here right now. Lines that are already mapped are not affected.",
    LINES_RETRY_TEXT: "Try again",
    // WO-12 Part B — PDF years, plan and result sentences (all counts, names and years come from the API / the dialog's own selection).
    PDF_YEAR_SAME: (year: number) => `Tax year on the PDF: ${year}`,
    PDF_YEAR_RANGE: (begin: number, end: number) => `Tax year on the PDF: ${begin} to ${end}`,
    PLAN_CREATE_PROJECT: (name: string) => `Will create the project "${name}".`,
    PLAN_REUSE_PROJECT: (name: string) => `Will reuse the project "${name}".`,
    PLAN_SOURCE_CREATED: (external: string, receiving: string, year: number) =>
      `Will add ${external} as a source for ${receiving} FY${year}.`,
    PLAN_SOURCE_UPDATED: (receiving: string, year: number) =>
      `Will complete the existing source for ${receiving} FY${year}.`,
    PLAN_SOURCE_UNCHANGED: (receiving: string, year: number) =>
      `The source for ${receiving} FY${year} is already in place.`,
    RESULT_PROJECT_CREATED: (name: string) => `Created the project "${name}".`,
    RESULT_PROJECT_REUSED: (name: string) => `Reused the project "${name}".`,
    RESULT_SOURCE_CREATED: (external: string, receiving: string, year: number) =>
      `Added ${external} as a source for ${receiving} FY${year}.`,
    RESULT_SOURCE_UPDATED: (receiving: string, year: number) =>
      `Completed the source for ${receiving} FY${year}.`,
    RESULT_SOURCE_UNCHANGED: (receiving: string, year: number) =>
      `The source for ${receiving} FY${year} was already in place.`,
    RESULT_K1_SAVED: (receiving: string, year: number) => `K-1 saved for ${receiving} FY${year}.`,
    RESULT_MAPPINGS_SAVED: (count: number) => `Saved ${count} new mapping${count === 1 ? "" : "s"} for this client.`,
    GENERIC_ERROR_MESSAGE: "Something went wrong — try again.",
  },

  // Trial Balance Import v2 (ADO 35240, Feature 34668): two-step upload modal.
  TRIAL_BALANCE_IMPORT: {
    MODAL_TITLE: "Import Trial Balance",
    STEP_UPLOAD_TITLE: "Upload",
    STEP_MAP_TITLE: "Map columns",
    STEP_REVIEW_TITLE: "Review",
    STEP_FINALIZE_TITLE: "Finalize",
    DROP_HINT_TEXT: "Click or drag an .xlsx trial balance file here",
    FILE_NAME_LABEL: "Selected file",
    READING_FILE_TEXT: "Reading file…",
    SHEET_SUMMARY: (sheet: string, rows: number) =>
      `Sheet "${sheet}" — ${rows} data row${rows === 1 ? "" : "s"}`,
    FIELD_ACCOUNT_ID: "Account ID",
    FIELD_ACCOUNT_NAME: "Account name",
    FIELD_ACCOUNT_TYPE: "Account type",
    FIELD_ACCOUNT_CLASS: "Account class",
    FIELD_AMOUNT: "Amount",
    FIELD_TAX_FORM_LINE: "Tax form line",
    FIELD_COLUMN_HEADER: "Standard field",
    FILE_COLUMN_HEADER: "File column",
    SAMPLES_COLUMN_HEADER: "Sample values",
    REQUIRED_MARK: "required",
    NOT_MAPPED_PLACEHOLDER: "Not mapped",
    REQUIRED_FIELDS_HINT: "Map Account ID and Amount to continue.",
    SELECT_ARIA_LABEL: (field: string) => `File column for ${field}`,
    BACK_BUTTON_TEXT: "Back",
    CONTINUE_BUTTON_TEXT: "Continue",
    UPDATING_PREVIEW_TEXT: "Updating preview…",
    IMPORT_BUTTON_TEXT: "Approve and Import",
    IMPORTING_TEXT: "Importing…",
    ROWS_IN_FILE_TEXT: (rows: number) => `${rows} row${rows === 1 ? "" : "s"} in file`,
    ERRORS_COUNT_TEXT: (n: number) => `${n} error${n === 1 ? "" : "s"}`,
    WARNINGS_COUNT_TEXT: (n: number) => `${n} warning${n === 1 ? "" : "s"}`,
    BANNER_ALL_CLEAR: "All clear — no errors or warnings.",
    BANNER_WARNINGS: (n: number) =>
      `${n} warning${n === 1 ? "" : "s"} — you can still import.`,
    BANNER_ERRORS: (errors: number, warnings: number) =>
      `${errors} error${errors === 1 ? "" : "s"}${warnings > 0 ? ` and ${warnings} warning${warnings === 1 ? "" : "s"}` : ""} — fix the file or the mapping. Nothing is saved while errors exist.`,
    DIAG_ROW_HEADER: "Row",
    DIAG_COLUMN_HEADER: "Column",
    DIAG_SEVERITY_HEADER: "Severity",
    DIAG_MESSAGE_HEADER: "Message",
    DOWNLOAD_CSV_TEXT: "Download CSV",
    CSV_FILE_NAME: "trial_balance_diagnostics.csv",
    PREVIEW_ROWS_TITLE: (n: number) => `First ${n} mapped row${n === 1 ? "" : "s"}`,
    NO_PREVIEW_ROWS_TEXT: "No rows to preview.",
    RESULT_CURRENT: (rows: number) =>
      `Trial balance imported — ${rows} row${rows === 1 ? "" : "s"}.`,
    RESULT_NO_CHANGE: "Already imported, no changes",
    RESULT_REJECTED: "Import rejected — nothing was saved.",
    RESULT_SUPERSEDED_NOTE: "This import replaced the earlier upload for this entity.",
    START_OVER_TEXT: "Start over",
    DONE_TEXT: "Done",
    PREVIEW_FAILED_MESSAGE: "Could not read the file — check it is a valid .xlsx and try again.",
    CONFIRM_FAILED_MESSAGE: "The import failed — try again.",
    MISMATCH_RESTART_MESSAGE: "The file changed since it was previewed — upload it again.",
  },

  ACCOUNT_MAPPING: {
    FAILED_TO_LOAD_MESSAGE: "Failed to load account mapping data",
    MAPPINGS_SAVED_MESSAGE: "Mappings saved successfully",
    FAILED_TO_SAVE_MAPPINGS_MESSAGE: "Failed to save mappings",
    SELECT_PARTNERSHIP_TEXT: "Select a partnership to view account mappings.",
    PAGE_TITLE: "CoA Mapping",
    PAGE_SUBTITLE_PREFIX: "Map trial balance accounts to income categories for",
    LOADING_TEXT: "Loading accounts and categories…",
    TRIAL_BALANCE_ACCOUNTS_PANEL_TITLE: "Trial Balance Accounts",
    MAPPED_COUNT_BADGE: (mapped: number, total: number) =>
      `${mapped} of ${total} mapped`,
    ACCOUNT_ID_COLUMN_HEADER: "Account ID",
    ACCOUNT_NAME_COLUMN_HEADER: "Account Name",
    AMOUNT_COLUMN_HEADER: "Amount",
    MAPPED_TO_COLUMN_HEADER: "Mapped To",
    SELECT_CATEGORY_PLACEHOLDER: "— Select category —",
    NO_TRIAL_BALANCE_ACCOUNTS_TEXT:
      "No trial balance accounts found. Upload a trial balance first.",
    INCOME_CATEGORIES_PANEL_TITLE: "Income Categories",
    NO_INCOME_CATEGORIES_TEXT:
      "No income categories found. Assign a template to Income Allocation in the Calculation Profile first.",
    NO_ACCOUNTS_LOADED_TEXT: "No accounts loaded",
    ALL_ACCOUNTS_MAPPED_TEXT: (total: number) => `All ${total} accounts mapped`,
    ACCOUNTS_MAPPED_STATUS_TEXT: (mapped: number, total: number) =>
      `${mapped} of ${total} accounts mapped`,
    SAVING_TEXT: "Saving…",
    SAVE_MAPPINGS_BUTTON_LABEL: "Save Mappings",
  },

  PROJECT_WORKSPACE: {
    // AG Grid themes — themeQuartz.withParams(...) inputs for INPUT / OUTPUT / CALC-chain sheets
    GRID_THEME_PARAMS: {
      backgroundColor: "transparent",
      foregroundColor: "#e2e8f0",
      borderColor: "rgba(255,255,255,0.08)",
      oddRowBackgroundColor: "rgba(255,255,255,0.02)",
      headerBackgroundColor: "rgba(26,39,68,0.80)",
      headerTextColor: "#94a3b8",
      rowHoverColor: "rgba(242,101,34,0.08)",
      accentColor: "#F26522",
      fontFamily: "Inter, sans-serif",
      fontSize: 13,
    },
    OUTPUT_GRID_THEME_PARAMS: {
      backgroundColor: "rgba(15,8,0,0.95)",
      foregroundColor: "#e2d5c0",
      borderColor: "rgba(242,101,34,0.15)",
      oddRowBackgroundColor: "rgba(242,101,34,0.04)",
      headerBackgroundColor: "rgba(40,18,0,0.90)",
      headerTextColor: "#F26522",
      rowHoverColor: "rgba(242,101,34,0.08)",
      accentColor: "#F26522",
      fontFamily: "Inter, sans-serif",
      fontSize: 13,
    },
    // CALC-chain sheets (R1–R4 style intermediate steps) get their own amber theme so they read
    // as distinct from both editable INPUT sheets and final OUTPUT sheets in the sidebar/grid.
    CALC_GRID_THEME_PARAMS: {
      backgroundColor: "rgba(20,16,0,0.90)",
      foregroundColor: "#e8dcc0",
      borderColor: "rgba(245,158,11,0.18)",
      oddRowBackgroundColor: "rgba(245,158,11,0.04)",
      headerBackgroundColor: "rgba(46,34,0,0.90)",
      headerTextColor: "#F59E0B",
      rowHoverColor: "rgba(245,158,11,0.08)",
      accentColor: "#F59E0B",
      fontFamily: "Inter, sans-serif",
      fontSize: 13,
    },

    DEFAULT_COL_DEF: {
      resizable: true,
      sortable: true,
      filter: true,
      enableRowGroup: true,
      enablePivot: true,
      enableValue: true,
      minWidth: 80,
      maxWidth: 400,
    },
    STATUS_BAR: {
      statusPanels: [
        {
          statusPanel: "agTotalAndFilteredRowCountComponent",
          align: "left" as const,
        },
        { statusPanel: "agTotalRowCountComponent", align: "center" as const },
        { statusPanel: "agAggregationComponent" },
      ],
    },

    // Plain-English descriptions for known CALC-chain column headers (Depreciation template's
    // R1–R4 sheets) — these sheets are read-only intermediate results, so the header tooltip is
    // the only place a reviewer can see what each column represents.
    CALC_COLUMN_DESCRIPTIONS: {
      "asset id": "Identifier for the depreciable asset this row belongs to.",
      "asset description": "Human-readable name of the asset.",
      "asset type":
        "Asset class used to look up the asset's depreciation method/rate.",
      method:
        "Depreciation method applied to this asset (e.g. MACRS, straight-line).",
      convention:
        "Depreciation convention governing the first-year deduction (e.g. half-year, mid-quarter).",
      life: "Recovery period (in years) used to depreciate this asset.",
      "current year boy net tax basis":
        "Net tax basis at the beginning of the current tax year.",
      "current year annual depreciation":
        "Depreciation expense computed for the current tax year.",
      "current year eoy net tax basis":
        "Net tax basis remaining at the end of the current tax year.",
      "sec. 704(c) layer id":
        "Identifier for the Sec. 704(c) built-in gain/loss layer this row allocates.",
      "sec. 704(c) type":
        "Type of Sec. 704(c) layer (e.g. contributed property, revaluation).",
      "current year boy net sec. 704(c) gain/loss":
        "Remaining Sec. 704(c) built-in gain/loss at the start of the year.",
      "current year eoy net sec. 704(c) gain/loss":
        "Remaining Sec. 704(c) built-in gain/loss at the end of the year.",
      "tax depreciation":
        "Tax depreciation carried over from R1 Tax Depreciation for this asset.",
      "sec. 704(c) depreciation":
        "Depreciation attributable to the Sec. 704(c) built-in gain/loss layer.",
      "sec. 704(b) depreciation":
        "Book (Sec. 704(b)) depreciation for this asset, used for capital account maintenance.",
      "sec. 704(c) layer type":
        "Type of Sec. 704(c) layer this basis-allocation row belongs to.",
      "net sec. 704(c) gain/loss":
        "Remaining Sec. 704(c) built-in gain/loss being allocated across partners.",
      ratio:
        "Partner's Sec. 704(b) sharing ratio, used to allocate this layer's basis/cost recovery.",
      "net tax basis assigned":
        "Portion of the asset's net tax basis assigned to this partner.",
      "sec. 704(c) cost recovery":
        "Partner's share of cost recovery attributable to the Sec. 704(c) layer.",
      "tax cost recovery":
        "Partner's total tax cost recovery (depreciation) for this asset layer.",
      "sec. 704(b) cr":
        "Partner's Sec. 704(b) (book) cost recovery for this asset layer.",
    } as Record<string, string>,
    CALC_COLUMN_TOOLTIP_FALLBACK:
      "Intermediate value computed in this calculation step — see the Excel template for the exact formula.",
    CALC_COLUMN_YEAR_TOOLTIP: (year: string) =>
      `Depreciation amount for year ${year} of this asset's recovery schedule.`,

    // Data / workspace load
    WORKSPACE_LOAD_FAILED_MESSAGE: "Failed to load workspace",
    WORKSPACE_LOAD_FAILED_RETRY_TEXT:
      "Failed to load workspace. Please try again.",
    ROWS_SAVED_MESSAGE: "Rows saved",
    SAVE_ROWS_FAILED_MESSAGE: "Failed to save rows",
    SHEET_LOAD_FAILED_MESSAGE: "Failed to load sheet",
    // Scroll loading + edit session
    MORE_ROWS_LOAD_FAILED_MESSAGE: "Failed to load more rows",
    // Server-side sort of Parquet-backed sheets
    SORT_BLOCKED_UNSAVED_MESSAGE: "Save or discard your changes before sorting this sheet.",
    SORT_FAILED_MESSAGE: "Failed to sort the sheet",
    SHEET_CHANGED_RELOADED_MESSAGE:
      "This sheet was changed by someone else and has been reloaded. Please make your edits again.",
    UNSAVED_CHANGES_TITLE: "Discard unsaved changes?",
    UNSAVED_CHANGES_CONTENT:
      "You have unsaved changes in this sheet. Leaving discards them and releases your edit lock.",
    UNSAVED_CHANGES_OK: "Discard",
    KEY_SHEET_LABEL: "Key sheet",
    LOADING_MORE_ROWS_TEXT: "Loading more rows…",
    ROWS_LOADED_TEXT: (loaded: number, total: number) => `${loaded} of ${total} rows loaded`,
    SAVE_NOT_AVAILABLE_MESSAGE:
      "This sheet has no project deliverable sheet to save to yet",
    NO_TEMPLATE_ASSIGNED_MESSAGE: "No template assigned to this calculation",
    DOWNLOAD_NOT_INPUT_MESSAGE:
      "This sheet takes no input data, so there is no template to download. Select an input sheet.",
    DOWNLOAD_EXAMPLE_FAILED_MESSAGE: "Could not build the template file for this sheet",
    EXPORT_FAILED_MESSAGE: "Export failed",
    ROWS_IMPORTED_MESSAGE: (imported: number) => `${imported} rows imported`,
    RUN_TRIGGER_FAILED_MESSAGE:
      "Failed to trigger calculation. Please try again.",
    RUN_GATE_TITLE: "Run blocked: required input sheets are empty",
    RUN_GATE_OPEN_INPUTS_LABEL: "Open Inputs",
    RUN_GATE_DISMISS_LABEL: "Dismiss",
    JOBS_FAILED_MESSAGE: (count: number) =>
      `${count} calculation${count > 1 ? "s" : ""} failed`,

    // Top bar
    BREAK_PERIOD_SCOPE_TOOLTIP:
      "This workspace is scoped to this break period's own input/output data",
    RESOLVE_ISSUES_TOOLTIP: "Resolve the issues below before running",
    RUNNING_TEXT: "Running...",
    RUN_PROJECT_BUTTON_LABEL: "Run Project",
    PROJECT_NAME_FALLBACK: "—",
    CALCULATIONS_FROM_PARTNERSHIP_TEXT: (
      count: number,
      partnershipName: string,
      taxYear: number | string,
    ) =>
      `${count} calculation${count !== 1 ? "s" : ""} from ${partnershipName} ${taxYear} profile`,

    // Readiness panel
    READY_TO_RUN_BADGE_TEXT: "✓ Ready to run",
    READY_CHECK_FAIL_ICON: "❌",
    READY_CHECK_WARN_ICON: "⚠",

    // Left calculations panel
    CALCULATIONS_PANEL_TITLE: "Calculations",
    EXPAND_CALCULATIONS_TOOLTIP: "Expand calculations (Shift+[)",
    COLLAPSE_CALCULATIONS_TOOLTIP: "Collapse calculations (Shift+[)",
    EXPAND_CALCULATIONS_PANEL_ARIA_LABEL: "Expand calculations panel",
    COLLAPSE_CALCULATIONS_PANEL_ARIA_LABEL: "Collapse calculations panel",
    NO_CALCULATIONS_CONFIGURED_MESSAGE: "No calculations configured",

    // Main area / empty states
    SELECT_CALCULATION_TEXT: "Select a calculation to enter data",
    EMPTY_STATE_OUTPUT_ICON: "⚡",
    RUN_CALCULATION_TO_SEE_RESULTS_TEXT: "Run calculation to see results",
    ENTER_INPUT_DATA_HINT_TEXT: "Enter input data and click Run Project",
    EMPTY_STATE_NO_TEMPLATE_ICON: "📋",
    ASSIGN_TEMPLATE_HINT_TEXT:
      "Assign a template in Configurations → Calc Profile to define columns",
    // WO-61: empty states and the read-only note. The "no template" text above is only for a calculation with no template.
    NO_ROWS_LOADED_TEXT: "No rows loaded. Load data on the Inputs tab.",
    NOT_CALCULATED_TEXT: "Not calculated yet. Run the calculation.",
    VIEW_ONLY_NOTE_TEXT: "View only. Change data on the Inputs tab.",
    ENTITY_PICKER_LABEL: "Entity",
    // WO-61: K-form output sheets (read from the K-1 line results). TEMPLATE ASSUMPTION: a generated sheet with no columns whose
    // name starts with one of these form codes shows that form's stored line values; the codes are the platform's form
    // classifications (the server's `form` query values), not template names.
    K_FORM_CLASSIFICATIONS: ["K1", "K2", "K3"],
    K_FORM_LINES_PAGE_SIZE: 200,
    K_FORM_RECIPIENT_HEADER: "Partner",
    K_FORM_ISSUER_HEADER: "Issued by",
    K_FORM_LOAD_FAILED_MESSAGE: "Could not load the stored form lines",

    // Sheet sidebar groups / badges
    INPUT_SHEETS_GROUP_LABEL: "Input Sheets",
    CALCULATION_CHAIN_GROUP_LABEL: "Calculation Chain",
    OUTPUT_SHEETS_GROUP_LABEL: "Output Sheets",
    OUTPUT_BADGE_LABEL: "OUTPUT",
    CALC_BADGE_LABEL: "CALC",
    CHAINED_BADGE_LABEL: "CHAINED",
    CHAINED_SHEET_ICON_TITLE:
      "Automatically populated from another calculation",
    EXPAND_SIDEBAR_TOOLTIP: "Expand sidebar ([)",
    COLLAPSE_SIDEBAR_TOOLTIP: "Collapse sidebar ([)",
    EXPAND_SIDEBAR_ARIA_LABEL: "Expand sidebar",
    COLLAPSE_SIDEBAR_ARIA_LABEL: "Collapse sidebar",

    // Source column (grid)
    SOURCE_COLUMN_HEADER: "Source",
    SOURCE_COLUMN_WIDTH_PX: 110,
    CHAINED_ROW_LABEL: "Chained",
    UPLOADED_ROW_LABEL: "Uploaded",
    MANUAL_ROW_LABEL: "Manual",
    CHAINED_ROW_TOOLTIP: "Populated automatically from another calculation",

    // AG Grid overlayNoRowsTemplate HTML — static markup, moved wholesale
    NO_ROWS_OVERLAY_HTML:
      '<div style="display:flex;flex-direction:column;align-items:center;gap:8px;padding:32px 16px;">' +
      '<span style="font-size:13px;color:rgba(255,255,255,0.40);">Upload partner data or click <strong>+ Add Row</strong> to get started</span>' +
      '<span style="font-size:20px;margin-top:4px;">↓</span>' +
      "</div>",
    OUTPUT_NO_ROWS_OVERLAY_HTML:
      '<div style="display:flex;flex-direction:column;align-items:center;gap:8px;padding:32px 16px;">' +
      '<span style="font-size:20px;margin-top:4px;">⚡</span>' +
      '<span style="font-size:13px;color:rgba(242,101,34,0.70);">Run calculation to see results</span>' +
      "</div>",
    CALC_NO_ROWS_OVERLAY_HTML:
      '<div style="display:flex;flex-direction:column;align-items:center;gap:8px;padding:32px 16px;">' +
      '<span style="font-size:20px;margin-top:4px;">🔗</span>' +
      '<span style="font-size:13px;color:rgba(245,158,11,0.75);">Run the project to see intermediate calculation results</span>' +
      "</div>",
    CHAINED_NO_ROWS_DEFAULT_SOURCE_TEXT: "another calculation",
    CHAINED_NO_ROWS_OVERLAY_HTML: (source: string) =>
      '<div style="display:flex;flex-direction:column;align-items:center;gap:8px;padding:32px 16px;">' +
      '<span style="font-size:20px;margin-top:4px;">⛓</span>' +
      `<span style="font-size:13px;color:rgba(167,139,250,0.85);text-align:center;">This sheet is automatically populated from <strong>${source}</strong>.<br/>Run the project to see the chained data.</span>` +
      "</div>",

    // Table actions
    PREPARING_WORK_PAPERS_TEXT: "Preparing work papers...",
    DOWNLOAD_WORK_PAPERS_BUTTON_LABEL: "Download Work Papers",
    CALCULATING_TEXT: "Calculating...",
    UPLOAD_DATA_TEXT: "Upload Data",

    // Progress modal
    PROGRESS_MODAL_WIDTH_PX: 420,
    RUNNING_CALCULATIONS_TITLE: "Running Calculations",
    JOBS_COMPLETE_TEXT: (completed: number, totalLabel: number | string) =>
      `${completed} of ${totalLabel} complete`,
    ALL_CALCULATIONS_COMPLETE_TEXT: "All calculations complete",
    POLLING_LOST_CONNECTION_TEXT:
      "Lost connection while checking job status — progress shown may be stale.",
    ALL_CALCULATIONS_COMPLETE_CHECK_TEXT: "✓ All calculations complete",
    JOBS_FAILED_HEADER_TEXT: (count: number) =>
      `⚠️ ${count} job${count > 1 ? "s" : ""} failed`,
    JOB_ENTITY_DETAIL_TEXT: (entityId: number | string, detail: string) =>
      `Entity: ${entityId} — ${detail}`,
    JOB_ENTITY_UNKNOWN_LABEL: "Unknown",
    JOB_STATUS_FALLBACK_TEXT: (status: string) => `Status: ${status}`,

    // Upload modal
    IMPORTING_TEXT: "Importing...",
    CLICK_OR_DRAG_XLSX_TEXT: "Click or drag an .xlsx file here",
    SELECTED_FILE_PREFIX_TEXT: (fileName: string) => `Selected: ${fileName}`,

    // Trial balance panel
    TRIAL_BALANCE_BADGE_LABEL: "TRIAL BALANCE",
    TRIAL_BALANCE_VIA_COA_MAPPING_TEXT: (count: number) =>
      `via CoA Mapping — ${count} account(s)`,
    WORK_PAPERS_FILE_NAME: (projectId: string) => `WorkPapers_${projectId}.zip`,
  },

  BREAK_PERIODS: {
    // Canonical event-type value→label list — BreakPeriodRow.tsx derives its display lookup
    // from this same array instead of keeping a separate Record in sync.
    EVENT_TYPE_OPTIONS: [
      { value: "Contribution", label: "Contribution" },
      { value: "Distribution", label: "Distribution" },
      { value: "Transfer", label: "Transfer of Interest" },
      { value: "Revaluation", label: "Revaluation" },
    ],
    DRAG_TO_REORDER_ARIA_LABEL: "Drag to reorder",
    VIEW_WORKSPACE_ARIA_LABEL: "View this period's workspace",
    DOWNLOAD_WORK_PAPERS_ARIA_LABEL: "Download work papers for this period",
    DOWNLOAD_WORK_PAPERS_TOOLTIP: "Download Work Papers",
    EDIT_BREAK_PERIOD_ARIA_LABEL: "Edit break period",
    DELETE_BREAK_PERIOD_ARIA_LABEL: "Delete break period",
    FAILED_TO_LOAD_MESSAGE: "Failed to load break periods",
    WORK_PAPERS_FILE_NAME: (projectId: string, periodName: string) =>
      `WorkPapers_${projectId}_${periodName.replace(/[^a-z0-9]+/gi, "_")}.zip`,
    FAILED_TO_DOWNLOAD_WORK_PAPERS_MESSAGE: "Failed to download work papers",
    FAILED_TO_SAVE_ORDER_MESSAGE: "Failed to save new order",
    DELETE_CONFIRM_TITLE: "Delete break period?",
    DELETE_CONFIRM_CONTENT: (name: string) =>
      `"${name}" will be removed from the tax year timeline. This can't be undone.`,
    BREAK_PERIOD_DELETED_MESSAGE: "Break period deleted",
    FAILED_TO_DELETE_MESSAGE: "Failed to delete break period",
    BACK_TO_PROJECT_BUTTON_LABEL: "Back to Project",
    PAGE_TITLE: "Break Periods",
    ADD_BREAK_PERIOD_BUTTON_LABEL: "Add Break Period",
    NO_BREAK_PERIODS_TEXT:
      "No break periods defined. Add a break period to split the tax year.",
    OPEN_WORKSPACE_NO_PERIOD_BUTTON_LABEL:
      "Open Workspace (whole tax year, no break period)",
    FAILED_TO_LOAD_CALCULATIONS_MESSAGE: "Failed to load calculations",
    BREAK_PERIOD_UPDATED_MESSAGE: "Break period updated",
    BREAK_PERIOD_ADDED_MESSAGE: "Break period added",
    FAILED_TO_SAVE_BREAK_PERIOD_MESSAGE: "Failed to save break period",
    CALCULATIONS_SAVED_MESSAGE: "Calculations saved",
    FAILED_TO_SAVE_CALCULATIONS_MESSAGE: "Failed to save calculations",
    EDIT_BREAK_PERIOD_MODAL_TITLE: "Edit Break Period",
    ADD_BREAK_PERIOD_MODAL_TITLE: "Add Break Period",
    SELECT_CALCULATIONS_MODAL_TITLE: "Select Calculations",
    NEXT_BUTTON_LABEL: "Next",
    NAME_LABEL: "Name",
    NAME_REQUIRED_MESSAGE: "Name is required",
    NAME_PLACEHOLDER: "e.g. Pre-Contribution Period",
    TYPE_LABEL: "Type",
    PERIOD_TYPE_LABEL: "Period",
    EVENT_TYPE_LABEL: "Event",
    DATE_RANGE_LABEL: "Date Range",
    DATE_RANGE_REQUIRED_MESSAGE: "Start and end date are required",
    END_DATE_AFTER_START_MESSAGE: "End date must be after start date",
    EVENT_DATE_LABEL: "Event Date",
    EVENT_DATE_REQUIRED_MESSAGE: "Event date is required",
    EVENT_TYPE_FIELD_LABEL: "Event Type",
    EVENT_TYPE_REQUIRED_MESSAGE: "Event type is required",
    SELECT_EVENT_TYPE_PLACEHOLDER: "Select event type",
    SELECT_CALCULATIONS_TEXT:
      "Select which standard calculations apply to this break period.",
    NO_CALCULATIONS_AVAILABLE_TEXT:
      "No calculations are available for this break period type.",
  },

  CASCADE: {
    // Tier progress-bar color lookup — same 3-state shape as CLIENT_OVERVIEW_CONSTANT's, but
    // this feature's own accent set, so kept local rather than reused.
    PROGRESS_COLORS: {
      COMPLETE: "#4CAF50",
      IN_PROGRESS: "#F26522",
      NOT_STARTED: "rgba(255,255,255,0.20)",
    },
    K1_OUTPUT_AVAILABLE_LABEL: "K-1 Output available",
    CALCULATION_RUNNING_LABEL: "Calculation running",
    CALCULATION_COMPLETE_LABEL: "Calculation complete",
    CALCULATION_FAILED_LABEL: "Calculation failed",
    NOT_STARTED_LABEL: "Not started",
    WAITING_FOR_PROJECT_SETUP_LABEL: "Waiting for project setup",
    FLOWING_LABEL: "Flowing",
    PENDING_LABEL: "Pending",
    SUB_FUNDS_LABEL: (count: number) =>
      `${count} sub-fund${count !== 1 ? "s" : ""}`,
    PARTNERS_LABEL: (count: number) =>
      `${count} partner${count !== 1 ? "s" : ""}`,
    ENTITIES_LABEL: (count: number) =>
      `${count} ${count === 1 ? "entity" : "entities"}`,
    K1_TO_INCOME_INPUT_TEXT: "K-1 → Income Input",
    ROWS_SUFFIX: (count: number) => `${count} rows`,
    TIER_BADGE_LABEL: (level: number) => `Tier ${level}`,
    CALCS_COMPLETE_LABEL: (completed: number, total: number) =>
      `${completed}/${total} complete`,
    VIEW_PROJECT_BUTTON_LABEL: "View Project",
    VIEW_MAIN_PROJECT_BUTTON_LABEL: "View Main Project",
    CREATE_PROJECT_BUTTON_LABEL: "Create Project",
    VIEW_K1_OUTPUT_BUTTON_LABEL: "View K-1 Output",
    SELECT_PARTNERSHIP_TEXT: "Select a partnership to view the tier flow.",
    PAGE_TITLE: (partnershipName: string) => `${partnershipName} — Tier Flow`,
    RUN_TIER_FLOW_BUTTON_LABEL: "Run Tier Flow",
    NO_TIER_STRUCTURE_TEXT: "No tier structure found for this partnership.",
    TIER_NAV_PILL_TITLE: (level: number, count: number) =>
      `Tier ${level} — ${count} ${count === 1 ? "entity" : "entities"}`,
    CLOSE_BUTTON_LABEL: "Close",
    // Run Tier Flow — run-plan confirmation + per-tier status (WO-2)
    RUN_ORDER_TITLE: "Run order",
    RUN_ORDER_HINT:
      "Tiers run lowest first; each tier pulls the saved K-1 of the tiers below it. A failed tier skips only the tiers that depend on it.",
    RUN_PLAN_LOAD_FAILED_MESSAGE: "Could not load the run plan for this partnership.",
    RUN_PREPARE_FAILED_MESSAGE: "Could not save the default tier sources before running.",
    START_RUN_BUTTON_LABEL: "Start run",
    CANCEL_BUTTON_LABEL: "Cancel",
    EXTERNAL_NOT_CALCULATED_LABEL: "External — not calculated",
    K1_NEEDED_NOTE: "K-1 needed",
    EXTERNAL_K1_UPLOADED_NOTE: "Uploaded K-1 will be used",
    NO_PROJECT_FAILURE_REASON: "No project set up for this tier",
    TIER_STATUS_QUEUED_LABEL: "Queued",
    TIER_STATUS_RUNNING_LABEL: "Running",
    TIER_STATUS_COMPLETED_LABEL: "Completed",
    TIER_STATUS_FAILED_LABEL: "Failed",
    TIER_STATUS_SKIPPED_LABEL: (dependsOn: string) => `Skipped — depends on ${dependsOn}`,
    TIER_START_FAILED_REASON: "Failed to start the calculation",
    RUN_GATE_TITLE: "Run blocked: required input sheets are empty",
    TIER_NOT_COMPLETE_REASON: "Calculation did not complete",
    RUN_COMPLETE_TEXT: "Tier flow complete.",
    // After a run, each finished tier links to its project, where the status and the results are (WO-44).
    OPEN_PROJECT_LINK_LABEL: "Open project",
    OPEN_PROJECT_LINK_ARIA: (name: string) => `Open the project of ${name}`,
    RUN_COMPLETE_WITH_FAILURES_TEXT: "Tier flow finished with failures.",
    STALE_REASON_INPUT_CHANGED: "Inputs changed since the last run",
    STALE_REASON_UPSTREAM: (name: string) => `${name} changed`,
    STALE_REASON_NO_K1: (name: string) => `${name} has no K-1 yet`,
    STALE_REASON_NEWER_K1: (name: string) => `${name} has a newer K-1`,

    // Tier Sources / Lower Tier injection / stale+Rerun — WO-2 (FR-20.4)
    TIER_SOURCES_BUTTON_LABEL: "Tier Sources",
    TIER_SOURCES_MODAL_TITLE: "Tier Sources",
    TIER_SOURCES_EMPTY_TEXT: "No lower-tier partnerships issue K-1s to this entity.",
    TIER_SOURCES_DEFAULTED_HINT:
      "No sources saved yet — showing the partnerships that issue K-1s to this entity as a suggested default.",
    TIER_SOURCES_SAVE_BUTTON_LABEL: "Save Sources",
    TIER_SOURCES_SAVED_MESSAGE: "Tier sources saved.",
    TIER_SOURCES_SAVE_FAILED_MESSAGE: "Failed to save tier sources.",
    NO_PROJECT_LABEL: "No project",
    STALE_BADGE_LABEL: "Stale — source(s) updated",
    RERUN_BUTTON_LABEL: "Rerun",
  },

  // WO-TF-5: Structure's Table view (replaces the old card List view).
  STRUCTURE: {
    VIEW_MODE_DIAGRAM_LABEL: "Diagram",
    VIEW_MODE_TABLE_LABEL: "Table",
    BUSY_STRUCTURE_NOTE:
      "Large or complex structure, shown as a table. Switch to Diagram to see the full picture.",
    SEARCH_PLACEHOLDER: "Search by entity name",
    SEARCH_ARIA_LABEL: "Search entities by name",
    EMPTY_DASH: "\u2014",
    NO_MATCHING_ENTITIES_TEXT: "No entities match the current search and filters.",
    COLUMN_ENTITY: "Entity",
    COLUMN_TYPE: "Type",
    COLUMN_TIER: "Tier",
    COLUMN_OWNED_BY: "Owned by",
    COLUMN_OWNS: "Owns",
    COLUMN_PROJECT: "Project",
    COLUMN_ACTION: "Action",
    PAGE_SIZE: 100,
    TIER_LABEL: (level: number) => `Tier ${level}`,
    // Same wording as ENTITY_RELATIONS_BULK_UPLOAD.EXTERNAL_TAG and CASCADE.EXTERNAL_MODE_LABEL.
    EXTERNAL_BADGE_LABEL: "External",
    OWNS_LINE: (percent: string, ownedName: string) => `Owns ${percent} of ${ownedName}`,
    OWNED_BY_LINE: (percent: string, ownerName: string) => `${percent} owned by ${ownerName}`,
    OPEN_PROJECT_ARIA_LABEL: (name: string) => `Open project for ${name}`,
  },

  GENERATE_TAX_FORM: {
    GRID_THEME_PARAMS: {
      backgroundColor: "transparent",
      foregroundColor: "rgba(255,255,255,0.85)",
      borderColor: "rgba(255,255,255,0.08)",
      oddRowBackgroundColor: "rgba(255,255,255,0.015)",
      // ce tokens (AG Grid passes var() through): header text was white at .4 (3.8:1) on a translucent
      // header that let the page backdrop show through (down to 1.7:1).
      headerBackgroundColor: "var(--ce-surface-dark)",
      headerTextColor: "var(--ce-text-secondary)",
      rowHoverColor: "rgba(255,255,255,0.025)",
      accentColor: "#F26522",
      fontFamily: "Inter, sans-serif",
      fontSize: 13,
    },
    GOSYSTEM_EXPORT_FILE_NAME: (projectId: number) =>
      `GoSystem_PartnerPackage_${projectId}.xml`,
    EXPORT_FAILED_MESSAGE: "Export failed — please try again",
    FAILED_TO_LOAD_PREVIEW_MESSAGE: "Failed to load K-1 preview",
    K1_PDF_FILE_NAME: (partnerName: string) =>
      `K1_${partnerName.replace(/ /g, "_")}_2024.pdf`,
    PARTNER_COLUMN_HEADER: "PARTNER",
    ENTITY_TYPE_COLUMN_HEADER: "ENTITY TYPE",
    ENTITY_TYPE_VALUE: "LP",
    OWNERSHIP_PERCENT_COLUMN_HEADER: "OWNERSHIP %",
    INCOME_ALLOCATED_COLUMN_HEADER: "INCOME ALLOCATED",
    STATUS_COLUMN_HEADER: "STATUS",
    READY_TO_GENERATE_BADGE_TEXT: "Ready to generate",
    ACTIONS_COLUMN_HEADER: "ACTIONS",
    PREVIEW_K1_BUTTON_LABEL: "Preview K-1",
    SELECT_CLIENT_PARTNERSHIP_TEXT:
      "Select a client and partnership to generate K-1s.",
    NO_PROJECT_FOUND_TEXT: (
      partnershipName: string | undefined,
      taxYear: string,
    ) =>
      `No project found for ${partnershipName} · ${taxYear}. Create a project first.`,
    NO_CALCULATION_RESULTS_TEXT:
      "No calculation results found. Run calculations from the Project screen first.",
    PAGE_TITLE: "Generate Tax Form",
    PAGE_SUBTITLE: (partnershipName: string, taxYear: string) =>
      `Schedule K-1 · ${partnershipName} · ${taxYear}`,
    SUMMARY_FORM_LABEL: "Schedule K-1 (Form 1065)",
    PARTNERS_STAT_LABEL: "PARTNERS",
    K1S_READY_STAT_LABEL: "K-1S READY",
    PARTNER_COUNT_TEXT: (count: number) =>
      `${count} partner${count !== 1 ? "s" : ""}`,
    PREPARING_EXPORT_TEXT: "Preparing export...",
    EXPORT_GOSYSTEM_XML_BUTTON_LABEL: "Export GoSystem XML",
    GENERATE_ALL_K1S_BUTTON_LABEL: "Generate all K-1s",
    K1_PREVIEW_MODAL_TITLE: (partnerName: string) =>
      `K-1 Preview — ${partnerName}`,
    DOWNLOAD_PDF_BUTTON_LABEL: "Download PDF",
    LOADING_K1_TEXT: "Loading K-1...",
    K1_PREVIEW_IFRAME_TITLE: "K-1 Preview",
    // WO-16 T5: recipient status. Statuses and diagnostics are the server's words; the screen only
    // shows them.
    STATUS_ERROR_BADGE_TEXT: "Error",
    STATUS_NO_RECORD_BADGE_TEXT: "No K-1 record",
    NO_DIAGNOSTICS_TEXT: "No details were returned.",
    PREVIEW_UNAVAILABLE_TOOLTIP: "No K-1 can be shown for this partner until its status is Ready.",
    PREVIEW_FAILED_WITH_REASON: (reason: string) => `Failed to load K-1 preview: ${reason}`,
    // WO-16 T5: Generate all K-1s downloads the server's ZIP.
    GENERATING_ZIP_TEXT: "Preparing K-1s...",
    ZIP_FILE_NAME: (partnershipName: string, taxYear: string) =>
      `K1s_${partnershipName.replace(/[ ,]/g, "")}_${taxYear.replace("FY", "")}.zip`,
    ZIP_DOWNLOADED_MESSAGE: (count: number) =>
      `${count} K-1${count !== 1 ? "s" : ""} downloaded`,
    ZIP_PARTIAL_MESSAGE: (included: number, left: number) =>
      `${included} K-1${included !== 1 ? "s" : ""} downloaded; ${left} left out (see _errors.txt in the ZIP)`,
    ZIP_FAILED_MESSAGE: "The K-1s could not be generated",
    // WO-16 T5: the server asks for a break period when a project has several.
    BREAK_PERIOD_PICKER_LABEL: "Break period",
    BREAK_PERIOD_PICKER_PLACEHOLDER: "Choose a break period",
    BREAK_PERIOD_REQUIRED_TEXT:
      "This project has several break periods. Choose the one to show K-1s for.",
    BREAK_PERIOD_LOAD_FAILED_MESSAGE: "The break periods could not be loaded",
    PARTNER_LIST_FAILED_MESSAGE: "The K-1 partner list could not be loaded",
    // WO-14 Part B: view switch and the per-line K-1 detail view. Amounts are shown as the server
    // stored them; nothing here is summed or derived.
    VIEW_SWITCH_ARIA_LABEL: "K-1 view",
    VIEW_PARTNER_SUMMARY_LABEL: "Partner summary",
    VIEW_LINE_DETAIL_LABEL: "K-1 line detail",
    LINE_DETAIL: {
      PAGE_SIZE: 50,
      ERROR_TEXT: "The K-1 line detail could not be loaded.",
      RETRY_LABEL: "Retry",
      EMPTY_TEXT:
        "No K-1 line values yet. Run the calculation from the Project screen first.",
      NO_MAPPED_LINES_TEXT: "The K-1 records have no mapped lines to show.",
      ERROR_RECORDS_TITLE: (count: number) =>
        `${count} K-1 record${count !== 1 ? "s" : ""} could not be built`,
      ERROR_RECORD_NO_MESSAGE_TEXT: "No message was recorded.",
      ERROR_RECORDS_TRUNCATED_TEXT:
        "More error records exist than are listed here.",
      CONFLICTS_TEXT: (count: number) =>
        `${count} stored value${count !== 1 ? "s" : ""} repeat${count !== 1 ? "" : "s"} a line already shown for the same partner and ${count !== 1 ? "are" : "is"} not displayed.`,
      UNKNOWN_LINE_HEADER: "Line no longer on the form",
      INACTIVE_LINE_SUFFIX: " (inactive)",
      GRID_ARIA_LABEL: "K-1 line values per partner",
      PARTNER_COUNT_TEXT: (shown: number, total: number) =>
        `Showing ${shown} of ${total} partner${total !== 1 ? "s" : ""}`,
    },
    // WO-18 (D18): the read-only tie-out panel. Every figure and the status are the template's own,
    // shown as returned; the screen subtracts, rounds and compares nothing.
    // WO-36: K-2 (one per project) and K-3 (one per partner) PDF downloads, TAX_FORM_ADMIN only.
    FORM_DOWNLOAD: {
      // Safety stop for the availability read: pages of line-results fetched per form at most.
      PROBE_MAX_PAGES: 200,
      K2_BUTTON_LABEL: "Download K-2",
      K3_BUTTON_LABEL: "Download K-3",
      K2_PREPARING_TEXT: "Preparing K-2...",
      K3_NO_RECORD_TOOLTIP: "No K-3 for this partner yet.",
      K2_DOWNLOADED_MESSAGE: "K-2 downloaded",
      K3_DOWNLOADED_MESSAGE: (partnerName: string) => `K-3 downloaded for ${partnerName}`,
      // Not K1_ / K1s_ names, so a downloaded K-2 or K-3 never overwrites a K-1 file.
      K3_FILE_NAME: (partnerName: string, taxYear: string) =>
        `K3_${partnerName.replace(/[ ,]/g, "_")}_${taxYear.replace("FY", "")}.pdf`,
      K2_FILE_NAME: (partnershipName: string, taxYear: string) =>
        `K2_${partnershipName.replace(/[ ,]/g, "")}_${taxYear.replace("FY", "")}.pdf`,
      NO_RECORD_MESSAGE: {
        K2: "There is no K-2 for this project yet. Run the calculation, then try again.",
        K3: (partnerName: string) =>
          `There is no K-3 for ${partnerName} yet. Run the calculation for this project, then try again.`,
      },
      NOT_SET_UP_MESSAGE: (form: string, year: string) =>
        `The ${form} form for ${year} has not been set up. Ask an administrator to add it in Tax Form Lines.`,
      FIELDS_MESSAGE: (form: string) =>
        `The ${form} could not be produced because the form template is missing fields that are mapped. Ask an administrator to check the form mapping.`,
      ACCESS_MESSAGE: "You don't have access to this client's forms.",
      PERIOD_REQUIRED_MESSAGE:
        "This project has several break periods. Choose one above, then try again.",
      FAILED_MESSAGE: (form: string) => `The ${form} could not be downloaded. Try again.`,
    },
    TIE_OUT: {
      TITLE: "Template tie-out",
      NOTE: "Figures and status are calculated by the template and shown as returned.",
      ARIA_LABEL: "Template tie-out",
      NO_VALUE_TEXT: "No value",
      COLUMNS: {
        CODE: "Code",
        LABEL: "Label",
        ENTITY: "Entity",
        VALUE: "Value",
        CONTROL: "Control",
        VARIANCE: "Variance",
        STATUS: "Status",
        ISSUE: "Issue",
      },
    },
  },

  PROJECT: {
    // FIX 1: Job label tier-based fallback — TIER_LABELS[index] is used only when the job's
    // own calcName/standardCalculationId are missing or placeholder values.
    TIER_LABELS: {
      1: "Taxable Income",
      2: "Income Allocation",
      3: "Capital Account Roll-forward",
      4: "Period Depreciation (MACRS)",
      5: "Debt Allocation",
      6: "State Apportionment",
      7: "Contribution Event",
    } as Record<number, string>,
    STEP_FALLBACK_LABEL: (index: number) => `Step ${index}`,
    PERIOD_DATE_FORMAT: "MMM D, YYYY",
    RESULTS_COLLAPSE_THEME: {
      token: {
        colorText: "rgba(255,255,255,0.85)",
        colorTextHeading: "#ffffff",
        colorBorder: "rgba(255,255,255,0.08)",
        colorBorderSecondary: "rgba(255,255,255,0.08)",
      },
      components: {
        Collapse: {
          headerBg: "rgba(26,39,68,0.82)",
          contentBg: "rgba(26,39,68,0.50)",
        },
      },
    },
    // K-1 line-code → display label list, shared by the aggregate summary and each
    // per-period breakdown card (was duplicated identically between the two before).
    K1_LINE_ITEMS: [
      { code: "K1_L1", line: "Line 1", label: "Ordinary Business Income" },
      { code: "K1_L5", line: "Line 5", label: "Interest Income" },
      { code: "K1_L9A", line: "Line 9a", label: "Net LT Capital Gain" },
      { code: "K1_L13", line: "Line 13", label: "Depreciation" },
      { code: "K1_L16", line: "Line 16", label: "Foreign Tax Credit" },
      { code: "K1_L20", line: "Line 20", label: "Ending Capital" },
    ],
    STATUS_COLORS: {
      Completed: "#22c55e",
      Archived: "#94a3b8",
    } as Record<string, string>,
    DEFAULT_STATUS_COLOR: "#f26522",
    ACTIVE_STATUS_LABEL: "Active",
    FAILED_TO_LOAD_PROJECT_MESSAGE: "Failed to load project",
    ALL_CALCULATIONS_COMPLETE_MESSAGE: "All calculations complete",
    FAILED_TO_START_RUN_TITLE: "Failed to start calculation run",
    UNEXPECTED_ERROR_TEXT: "An unexpected error occurred.",
    DELETE_PROJECT_CONFIRM_TITLE: (name: string) => `Delete project "${name}"?`,
    DELETE_PROJECT_CONFIRM_CONTENT:
      "This cannot be undone. The project will be archived and removed from this view.",
    DELETE_FROM_LIST_CONFIRM_TITLE: (name: string) => `Delete "${name}"?`,
    DELETE_FROM_LIST_CONFIRM_CONTENT: "This cannot be undone.",
    PROJECT_DELETED_MESSAGE: "Project deleted",
    FAILED_TO_DELETE_PROJECT_MESSAGE: "Failed to delete project",
    PROJECT_NAME_COLUMN_HEADER: "Project Name",
    TAX_YEAR_COLUMN_HEADER: "Tax Year",
    STATUS_COLUMN_HEADER: "Status",
    PROJECTS_PAGE_TITLE: "Projects",
    NEW_PROJECT_BUTTON_LABEL: "New Project",
    NO_PROJECTS_TEXT:
      "No calculation projects for this partnership and tax year.",
    CREATE_PROJECT_BUTTON_LABEL: "Create Project",
    NO_CALCULATIONS_CONFIGURED_TEXT:
      "No calculations configured for this project.",
    CALCULATION_SEQUENCE_LABEL: "Calculation Sequence",
    // One run is one job: a calculation item for one entity (a project with 4 entities and 2 items has 8 runs).
    PROGRESS_COUNT_TEXT: (completed: number, total: number, waiting: number) =>
      `${completed} of ${total} runs complete · ${waiting} waiting`,
    ROWS_SUFFIX: "rows",
    RUNNING_TEXT: "Running...",
    FAILED_TEXT: "Failed",
    WAITING_TEXT: "Waiting",
    RUN_CALCULATIONS_TO_SEE_RESULTS_TEXT:
      "Run calculations to see results here.",
    // WO-61: Results tab links into the workspace output sheet of each run.
    OUTPUT_LINKS_TITLE: "Calculation outputs",
    OPEN_OUTPUT_LABEL: "Open output",
    OUTPUT_LINK_ENTITY_FALLBACK_LABEL: "Entity",
    CALCULATIONS_COMPLETED_TEXT: (count: number) =>
      `${count} calculations completed`,
    ALL_COMPLETE_CHECK_TEXT: "All Complete ✓",
    OUTPUT_ROWS_LABEL: "Output Rows",
    // The project total sums the rows of every job, so with several entities it counts each entity's run (WO-44).
    OUTPUT_ROWS_ALL_ENTITIES_LABEL: "Output Rows (all entities)",
    ENTITIES_LABEL: "Entities",
    PARTNERS_LABEL: "Partners",
    INCOME_ALLOCATED_LABEL: "Income Allocated",
    TAX_YEAR_LABEL: "Tax Year",
    GENERATE_K1S_WITH_COUNT_BUTTON_LABEL: (count: number) =>
      `Generate ${count} K-1s →`,
    GENERATE_K1S_BUTTON_LABEL: "Generate K-1s →",
    K1_ALLOCATION_SUMMARY_TITLE: "K-1 Allocation Summary",
    // WO-18 (D18): totals on this screen are the template's own tie-out values, never a client sum.
    // The headline is the template's value for this line code; with none it shows NO_TOTAL_TEXT.
    HEADLINE_LINE_CODE: "K1_L1",
    NO_TOTAL_TEXT: "No total",
    TIE_OUT_PAGE_SIZE: 1,
    SELECT_CLIENT_PARTNERSHIP_TEXT:
      "Select a client and partnership to view calculations.",
    BACK_TO_PROJECTS_BUTTON_LABEL: "Back to Projects",
    PROJECT_NOT_FOUND_TITLE: "Project Not Found",
    PROJECT_NOT_FOUND_TEXT: "This project could not be found.",
    PROJECT_SELECTOR_LABEL: "PROJECT",
    DELETE_BUTTON_LABEL: "Delete",
    RUN_CALCULATION_BUTTON_LABEL: "Run Calculation",
    BREAK_PERIODS_TAB_LABEL: "Break Periods",
    CALCULATIONS_TAB_LABEL: "Calculations",
    RESULTS_TAB_LABEL: "Results",
    PROJECT_CODE_PREFIX: (id: string) => `PRJ-${id.slice(0, 8).toUpperCase()}`,
    TAX_YEAR_META_TEXT: (taxYear: number | string) => `Tax Year ${taxYear}`,
    ALL_COMPLETE_BADGE_TEXT: "All Complete",
    COMPLETE_BADGE_TEXT: (completed: number, total: number) =>
      `${completed} of ${total} Complete`,
  },
};

const ENTITY_DETAILS_ROUTE_PREFIX = "/entities/";

//TieringView constants — shared top-level keys + nested per component (PartnerRoster.tsx, TierList.tsx)
export const TIERING_VIEW_CONSTANT = {
  REQUIRED_FIELD_MESSAGE: "Required",
  OWNERSHIP_PERCENT_LABEL: "Ownership %",
  ENTRY_DATE_LABEL: "Entry Date",
  ACTIONS_COLUMN_HEADER: "Actions",
  BACK_TO_ENTITY_DETAILS_BUTTON_LABEL: "Back to Entity Details",
  ENTITY_DETAILS_ROUTE_PREFIX,
  ENTITY_DETAILS_ROUTE: (entityId: number | string) =>
    `${ENTITY_DETAILS_ROUTE_PREFIX}${entityId}`,
  TIERING_ROUTE: (entityId: number | string) => `/tiering/${entityId}`,
  ENTITY_DETAILS_TABS: {
    OWNERSHIP: "ownership",
    PARTNERS: "partners",
  },

  PARTNER_ROSTER: {
    FAILED_TO_LOAD_MESSAGE: "Failed to load partner roster",
    EXIT_PARTNER_TEXT: "Exit Partner",
    EXIT_CONFIRM_CONTENT: (partnerName: string) =>
      `Mark "${partnerName}" as exited from this partnership? This keeps the historical record but removes them from active ownership.`,
    PARTNER_EXITED_MESSAGE: (partnerName: string) => `${partnerName} exited`,
    FAILED_TO_EXIT_MESSAGE: "Failed to exit partner",
    PARTNER_UPDATED_MESSAGE: "Partner updated",
    PARTNER_ADDED_MESSAGE: "Partner added",
    FAILED_TO_SAVE_PARTNER_MESSAGE: "Failed to save partner",
    TIERING_GENERATED_MESSAGE: (updated: number) =>
      `Tiering structure updated — ${updated} relationships configured`,
    FAILED_TO_GENERATE_TIERING_MESSAGE: "Failed to generate tiering structure",
    IMPORT_FAILED_FALLBACK_MESSAGE: "Import failed",
    PARTNER_NAME_COLUMN_HEADER: "Partner Name",
    INTEREST_CLASS_LABEL: "Interest Class",
    EXIT_DATE_COLUMN_HEADER: "Exit Date",
    STATUS_COLUMN_HEADER: "Status",
    ACTIVE_STATUS_LABEL: "Active",
    EXITED_STATUS_LABEL: "Exited",
    LOOK_THROUGH_BADGE_LABEL: "Look-through",
    LOOK_THROUGH_CHECKBOX_LABEL: "Look-through (not counted toward 100%)",
    LOOK_THROUGH_SUMMARY_SUFFIX: (count: number) => ` (+${count} look-through)`,
    IMPORT_PARTNERS_TEXT: "Import Partners",
    GENERATE_TIERING_BUTTON_TEXT: "Generate Tiering Structure",
    ADD_PARTNER_BUTTON_TEXT: "+ Add Partner",
    NO_PARTNERS_MESSAGE: "No partners in this roster yet",
    EDIT_PARTNER_MODAL_TITLE: "Edit Partner",
    ADD_PARTNER_TEXT: "Add Partner",
    PARTNER_FORM_LABEL: "Partner",
    SEARCH_ENTITIES_PLACEHOLDER: "Search entities...",
    ADD_TO_PARTNERSHIP_LABEL: "Add to Partnership",
    SELECT_INTEREST_CLASS_PLACEHOLDER: "Select interest class",
    REMAINING_CAPACITY_PREFIX: "Remaining capacity: ",
    UPLOAD_HINT_TEXT:
      "Upload a .xlsx file with columns: Entity Name | EIN | Interest Class | Ownership % | Entry Date",
    CHOOSE_FILE_BUTTON_TEXT: "Choose File",
    // Result lines: the server's own counts, never recomputed here.
    IMPORT_ADDED_LINE: (created: number, entitiesCreated: number) =>
      `${created} ${created === 1 ? "partner" : "partners"} added`
      + (entitiesCreated > 0 ? `, ${entitiesCreated} new ${entitiesCreated === 1 ? "entity" : "entities"} created` : "")
      + ".",
    IMPORT_UPDATED_LINE: (updated: number) =>
      `${updated} ${updated === 1 ? "partner" : "partners"} updated.`,
    IMPORT_UNCHANGED_LINE: (unchanged: number) =>
      `${unchanged} ${unchanged === 1 ? "partner was" : "partners were"} already up to date.`,
    IMPORT_NOTHING_CHANGED_LINE:
      "Nothing changed. Every partner in this file is already on the list exactly as written.",
    IMPORT_NOTHING_WAS_CHANGED_LINE: "Nothing was changed.",
    TOTAL_OWNERSHIP_PREFIX: "Total ownership: ",
    // Older servers return only "skipped"; shown under this label when rejectedRows is absent.
    SKIPPED_LABEL: "Skipped:",
    REJECTED_ROWS_LABEL: "Rows not imported:",
    OTHER_NOTES_LABEL: "Other notes:",
    REJECTED_ROW_TEXT: (rowNumber: number, name: string, reason: string) =>
      name ? `Row ${rowNumber} · ${name}: ${reason}` : `Row ${rowNumber}: ${reason}`,
  },

  TIER_LIST: {
    FAILED_TO_LOAD_MESSAGE: "Failed to load tiering relationships",
    DELETE_RELATIONSHIP_MODAL_TITLE: "Delete Relationship",
    DELETE_CONFIRM_CONTENT: (startName: string, endName: string) =>
      `Remove "${startName} → ${endName}"? This cannot be undone.`,
    RELATIONSHIP_DELETED_MESSAGE: "Relationship deleted",
    FAILED_TO_DELETE_MESSAGE: "Failed to delete relationship",
    RELATIONSHIP_UPDATED_MESSAGE: "Relationship updated",
    RELATIONSHIP_CREATED_MESSAGE: "Relationship created",
    FAILED_TO_SAVE_MESSAGE: "Failed to save relationship",
    UPPER_TIER_ENTITY_LABEL: "Upper Tier Entity",
    LOWER_TIER_ENTITY_LABEL: "Lower Tier Entity",
    TIER_LEVEL_COLUMN_HEADER: "Tier Level",
    DIRECTION_LABEL: "Direction",
    ADD_RELATIONSHIP_BUTTON_TEXT: "+ Add Relationship",
    NO_RELATIONSHIPS_MESSAGE: "No tiering relationships found",
    EDIT_RELATIONSHIP_MODAL_TITLE: "Edit Relationship",
    ADD_RELATIONSHIP_MODAL_TITLE: "Add Relationship",
    SEARCH_SELECT_ENTITY_PLACEHOLDER: "Search and select entity...",
    SELECT_DIRECTION_PLACEHOLDER: "Select direction",
    RELATIONSHIP_DIRECTION_OPTIONS: [
      { value: "Direct", label: "Direct" },
      { value: "Indirect", label: "Indirect" },
    ],
    INTEREST_CLASS_LABEL: "Interest Class",
    EXIT_DATE_LABEL: "Exit Date",
    OWNERSHIP_WARNING_TOOLTIP: (percent: number) =>
      `Total ownership for this partnership is ${percent}% — below 100%`,
    BULK_UPLOAD_BUTTON_TEXT: "Bulk Upload",
  },

  ENTITY_RELATIONS_BULK_UPLOAD: {
    MODAL_TITLE: "Import Entities and Ownership",
    DOWNLOAD_TEMPLATE_BUTTON_TEXT: "Download Template",
    DOWNLOAD_TEMPLATE_FAILED_MESSAGE: "Failed to download template",
    UPLOAD_HINT_TEXT:
      "Upload a .xlsx file with one row per ownership link: Partnership and Partner (name, EIN, category), Ownership %, Interest Class, dates, External and Look-Through. Entities that do not exist yet are created. Download the template for the exact layout.",
    CHOOSE_FILE_BUTTON_TEXT: "Choose File",
    PREVIEW_BUTTON_TEXT: "Preview",
    PREVIEW_FAILED_MESSAGE: "Failed to preview file",
    CONFIRM_SAVE_BUTTON_TEXT: "Confirm & Save",
    COMMIT_FAILED_MESSAGE: "Failed to save upload",
    COMMIT_SUCCESS_MESSAGE: (created: number, updated: number, entitiesCreated: number = 0) =>
      entitiesCreated > 0
        ? `${entitiesCreated} entity(ies) and ${created} relationship(s) created, ${updated} updated.`
        : `${created} relationship(s) created, ${updated} updated.`,
    BLOCKING_ERRORS_MESSAGE: "Fix the row errors below before saving — nothing will be saved while any row has an error.",
    ROW_NUMBER_COLUMN_HEADER: "Row",
    START_ENTITY_COLUMN_HEADER: "Partnership",
    END_ENTITY_COLUMN_HEADER: "Partner",
    STATUS_COLUMN_HEADER: "Status",
    ERRORS_COLUMN_HEADER: "Errors",
    WARNINGS_COLUMN_HEADER: "Warnings",
    COUNTED_TOTAL_LABEL: (total: number) => `${total}% counted`,
    EXCLUDED_LOOK_THROUGH_TEXT: (count: number, total: number) =>
      `${count} look-through row${count === 1 ? "" : "s"} (${total}%) not counted`,
    NEW_ENTITY_TAG: "New entity",
    EXTERNAL_TAG: "External",
    LOOK_THROUGH_TAG: "Look-Through",
    STATUS_LABELS: {
      New: "New",
      Changed: "Changed",
      Unchanged: "Unchanged",
      Error: "Error",
    },
  },
};

// UserAccessView constants — shared by UserAccessEditComponent/UserAcessEdit.tsx and
// UserAccessListComponent/UserAccessList.tsx (the two shared components that back the
// features/UserAccessView pages).
export const USER_ACCESS_VIEW_CONSTANT = {
  OWNER_ACCESS_LABEL: "Owner",
  READ_ACCESS_LABEL: "Read",
  // UserAcessEdit.tsx's fallback label when both canRead/canWrite are false, distinct
  // from UserAccessList.tsx's NO_ACCESS_LABEL below — preserved as-is, not unified.
  ACCESS_REMOVED_LABEL: "Access Removed",
  NO_ACCESS_LABEL: "No Access",
  INVITE_BUTTON_LABEL: "Invite",
  SEARCH_ICON_SRC: "/search.svg",
  SEARCH_ICON_ALT_TEXT: "Search Icon",
  NO_OPTIONS_FOUND_LABEL: "Options not found",
  SEARCH_PLACEHOLDER: "Search",
  // Preserves the existing stray space before the interpolated id (pre-existing
  // behavior in UserAcessEdit.tsx's navigate calls — left unchanged).
  EDIT_PAGE_BACK_TO_VIEW_ROUTE: (deliverableId?: string) =>
    `/deliverable/user-access/ ${deliverableId}?${GLOBAL_CONSTANT.ACTIVE_TABS_KEY}=${GLOBAL_CONSTANT.USER_ACCESS}`,
  VIEW_PAGE_TO_EDIT_ROUTE: (deliverableId?: string) =>
    `/deliverable/user-access/${deliverableId}/edit?${GLOBAL_CONSTANT.ACTIVE_TABS_KEY}=${GLOBAL_CONSTANT.USER_ACCESS}`,
};

// ProjectView constants — shared top-level keys + nested per page (ProjectList.tsx,
// CreateProjectModal.tsx, ProjectDeliverables.tsx)
export const PROJECT_VIEW_CONSTANT = {
  PROJECT_LIST: {
    // Mirrors the status vocabulary used by CalculationsView/Project/Project.tsx's own
    // project-switcher — see the comment on STATUS_COLORS in ProjectList.tsx.
    STATUS_COLORS: {
      Completed: "#22c55e",
      Archived: "#94a3b8",
    } as Record<string, string>,
    DEFAULT_STATUS_COLOR: "#F26522",
    FAILED_TO_LOAD_PROJECTS_MESSAGE: "Failed to load projects",
    PROJECT_NAME_COLUMN_HEADER: "Project Name",
    ENGAGEMENT_COLUMN_HEADER: "Engagement",
    ENTITY_COLUMN_HEADER: "Entity",
    TAX_YEAR_COLUMN_HEADER: "Tax Year",
    STATUS_COLUMN_HEADER: "Status",
    PAGE_TITLE: "Projects",
    PAGE_SUBTITLE: "Select a project to view its deliverables",
    CREATE_PROJECT_BUTTON_LABEL: "Create Project",
    BULK_CREATE_BUTTON_LABEL: "Create for all partnerships",
    SELECT_CLIENT_PARTNERSHIP_HINT_TEXT:
      "Select a client and partnership to create a project.",
    CLIENT_LABEL: "Client:",
    SEARCH_PROJECTS_PLACEHOLDER: "Search Projects",
    PROJECTS_COUNT_SUFFIX: "PROJECTS",
    NO_PROJECTS_FOUND_TEXT: "No projects found",
  },

  CREATE_PROJECT_MODAL: {
    FAILED_TO_LOAD_ENGAGEMENTS_MESSAGE: "Failed to load engagements",
    PROJECT_NAME_REQUIRED_MESSAGE: "Project Name is required",
    NO_PARTNERSHIP_SELECTED_MESSAGE:
      "No partnership selected — cannot create a project.",
    PROJECT_CREATED_MESSAGE: "Project created",
    FAILED_TO_CREATE_PROJECT_MESSAGE: "Failed to create project",
    DUPLICATE_PROJECT_NAME_ERROR_CODE: "PROJ-409",
    PROJECT_NAME_PLACEHOLDER:
      "e.g. Nexus Capital Partners — FY2025 Tax Compliance",
    NO_ENGAGEMENT_PLACEHOLDER: "No engagement",
    CREATING_TEXT: "Creating...",
    AUTO_PROJECT_NAME: (partnershipName: string, year: number) =>
      `${partnershipName} — FY${year} Tax Compliance`,
    ENGAGEMENT_OPTION_LABEL: (name: string, taxYear: number) =>
      `${name} — FY${taxYear}`,
  },

  BULK_CREATE_PROJECTS_MODAL: {
    TITLE: "Create projects for all partnerships",
    CLIENT_LABEL: "Client",
    TAX_YEAR_LABEL: "Tax Year",
    ENGAGEMENT_LABEL: "Engagement",
    NO_ENGAGEMENT_PLACEHOLDER: "No engagement",
    PARTNERSHIP_COLUMN_HEADER: "Partnership",
    PROPOSED_NAME_COLUMN_HEADER: "Project name",
    STATUS_COLUMN_HEADER: "Status",
    STATUS_WILL_CREATE: "Will create",
    STATUS_EXISTING: "Already has a project",
    LOADING_TEXT: "Loading partnerships...",
    NO_CANDIDATES_TEXT: "No eligible partnerships for this client.",
    FAILED_TO_LOAD_PREVIEW_MESSAGE: "Failed to load partnerships",
    FAILED_TO_LOAD_ENGAGEMENTS_MESSAGE: "Failed to load engagements",
    FAILED_TO_CREATE_MESSAGE: "Failed to create projects",
    CREATING_TEXT: "Creating...",
    CREATE_BUTTON_LABEL: (count: number) =>
      `Create ${count} project${count === 1 ? "" : "s"}`,
    DONE_BUTTON_LABEL: "Done",
    NO_CALC_PROFILE_WARNING: (year: number) =>
      `No calculation profile for FY${year}. This project could not be run. Copy the profile first.`,
    ENGAGEMENT_YEAR_MISMATCH_HINT: (engagementYear: number, taxYear: number) =>
      `This engagement is for FY${engagementYear}, but projects will be created for FY${taxYear}.`,
    ENGAGEMENT_OPTION_LABEL: (name: string, taxYear: number) =>
      `${name} — FY${taxYear}`,
    RESULT_CREATED_HEADING: "Created",
    RESULT_EXISTING_HEADING: "Already existed",
    RESULT_FAILED_HEADING: "Failed",
    RESULT_NONE_TEXT: "None",
  },

  PROJECT_DELIVERABLES: {
    TABS: [
      { key: "calculations", label: "Calculations" },
      { key: "reports", label: "Reports" },
      { key: "tiering", label: "Tiering" },
    ],
    FAILED_TO_LOAD_PROJECT_DATA_MESSAGE: "Failed to load project data",
    FAILED_TO_LOAD_UNASSIGNED_DELIVERABLES_MESSAGE:
      "Failed to load unassigned deliverables",
    DELIVERABLE_ASSIGNED_MESSAGE: "Deliverable assigned to project",
    FAILED_TO_ASSIGN_DELIVERABLE_MESSAGE: "Failed to assign deliverable",
    CLIENT_FALLBACK_LABEL: "Client",
    ENTITY_FALLBACK_LABEL: "Entity",
    ENGAGEMENT_FALLBACK_LABEL: "Engagement",
    ASSIGN_DELIVERABLE_BUTTON_LABEL: "+ Assign Deliverable",
    NO_DELIVERABLES_ASSIGNED_MESSAGE:
      'No deliverables assigned to this project yet. Click "Assign Deliverable" to link existing deliverables.',
    VIEW_DETAILS_BUTTON_LABEL: "View Details",
    // Placeholder card content — not wired to real per-deliverable data yet.
    ALLOCATE_INCOME_DESCRIPTION:
      "Allocate income using Target Allocation Method",
    PARTNER_INTEREST_METRIC_LABEL: "Number of\nPartner Interest",
    PARTNER_INTEREST_METRIC_VALUE: "10",
    TAXABLE_INCOME_METRIC_LABEL: "Taxable\nIncome",
    TAXABLE_INCOME_METRIC_VALUE: "$ 2,000,000",
    SEC_704B_INCOME_METRIC_LABEL: "Sec. 704(b)\nIncome",
    SEC_704B_INCOME_METRIC_VALUE: "$ 2,000,000",
    TAX_DEPRECIATION_METRIC_LABEL: "Tax\nDepreciation",
    TAX_DEPRECIATION_METRIC_VALUE: "$ 200,000",
    ASSIGN_DELIVERABLE_MODAL_TITLE: "Assign Deliverable to Project",
    ASSIGN_BUTTON_LABEL: "Assign",
    SELECT_UNASSIGNED_DELIVERABLE_TEXT:
      "Select an unassigned deliverable to link to this project:",
    SELECT_DELIVERABLE_PLACEHOLDER: "Select a deliverable",
  },
};

// ClientOverview constants
export const CLIENT_OVERVIEW_CONSTANT = {
  STATUS_COLORS: {
    COMPLETE: "#4CAF50",
    IN_PROGRESS: "#F26522",
    NOT_STARTED: "rgba(255,255,255,0.25)",
  },
  COMPLETE_LABEL: "Complete",
  IN_PROGRESS_LABEL: "In Progress",
  NOT_STARTED_LABEL: "Not Started",
  PARTNERS_SUFFIX: "partners",
  CALCS_SUFFIX: "calcs",
  CALCULATIONS_CONFIGURED_SUFFIX: "calculations configured",
  VIEW_PROJECT_BUTTON_LABEL: "View Project",
  CONFIGURE_BUTTON_LABEL: "Configure",
  SELECT_CLIENT_TEXT: "Select a client to view the overview.",
  PAGE_TITLE: (clientName: string, taxYear: string) =>
    `${clientName} — ${taxYear} Overview`,
  PAGE_SUBTITLE: (totalPartnerships: number, totalPartners: string) =>
    `${totalPartnerships} partnerships · ${totalPartners} total partners`,
  NO_PARTNERSHIPS_FOUND_TEXT: "No partnerships found for this client.",
  TOTAL_PARTNERSHIPS_LABEL: "Total Partnerships",
  CALCULATIONS_CONFIGURED_LABEL: "Calculations Configured",
  OVERALL_PROGRESS_LABEL: "Overall Progress",
};

// EngagementView constants — shared top-level keys (used by both EngagementList.tsx and
// EngagementDetails.tsx) + nested per page.
export const ENGAGEMENT_VIEW_CONSTANT = {
  // Fixed vocabularies (not derived from loaded data) — see EngagementList.tsx's own comment
  // on why these are hardcoded rather than sourced from the API response.
  TYPE_COLORS: {
    Audit: "#8B2500",
    Tax: "#2563eb",
    Compliance: "#7c3aed",
    Consulting: "#16a34a",
    Advisory: "#0891b2",
  } as Record<string, string>,
  DEFAULT_TYPE_COLOR: "#64748b",
  // Workflow status (Active/Draft/Completed) — distinct from the backend's IsActive-based
  // status filter. See EngagementList.tsx's own comment.
  STATUS_COLORS: {
    Active: "#22c55e",
    Draft: "#f59e0b",
    Completed: "#94a3b8",
  } as Record<string, string>,
  DEFAULT_STATUS_COLOR: "#ADADAD",
  ENTITY_TYPE_COLORS: {
    Partnership: "#2563eb",
    Partner: "#16a34a",
  } as Record<string, string>,
  BACK_TO_ENGAGEMENTS_BUTTON_LABEL: "Back to Engagements",

  LIST: {
    PAGE_TITLE: "Engagements",
    SEARCH_ENGAGEMENTS_PLACEHOLDER: "Search engagements...",
    TYPE_ALL_OPTION_LABEL: "Type: All",
    STATUS_ALL_OPTION_LABEL: "Status: All",
    CLEAR_FILTERS_TEXT: "Clear filters",
    SELECT_CLIENT_TEXT: "Select a client to view engagements",
    ENGAGEMENT_ID_COLUMN_HEADER: "Engagement ID",
    ENGAGEMENT_NAME_COLUMN_HEADER: "Engagement Name",
    TYPE_COLUMN_HEADER: "Type",
    PERIOD_COLUMN_HEADER: "Period",
    VIEW_DETAILS_MENU_LABEL: "View details",
    TABLE_FOOTER_TEXT: (shown: number, total: number) =>
      `Showing ${shown} of ${total} engagement${total !== 1 ? "s" : ""}`,
    CREATE_ENGAGEMENT_DISABLED_TOOLTIP:
      "Select a client to create an engagement",
  },

  // Shared by the standalone Engagements list and the Master Client Engagements tab.
  CREATE_MODAL: {
    ADD_ENGAGEMENT_MODAL_TITLE: "Add Engagement",
    CREATE_ENGAGEMENT_BUTTON_LABEL: "Create Engagement",
    ENGAGEMENT_CREATED_MESSAGE: "Engagement created",
    FAILED_TO_CREATE_ENGAGEMENT_MESSAGE: "Failed to create engagement",
    ENGAGEMENT_TYPE_LABEL: "Engagement Type",
    ENGAGEMENT_TYPE_REQUIRED_MESSAGE: "Please select an engagement type",
    SELECT_TYPE_PLACEHOLDER: "Select type",
    // Deliberately its own explicit order (not derived from ENGAGEMENT_VIEW_CONSTANT.TYPE_COLORS'
    // key order) — preserves this modal's existing dropdown ordering as-is.
    ENGAGEMENT_TYPE_OPTIONS: [
      "Compliance",
      "Tax",
      "Advisory",
      "Consulting",
      "Audit",
    ],
    ENGAGEMENT_NAME_LABEL: "Engagement Name",
    ENGAGEMENT_NAME_REQUIRED_MESSAGE: "Please enter an engagement name",
    ENGAGEMENT_NAME_PLACEHOLDER: "e.g. Partnership K-1 preparation",
    TAX_YEAR_LABEL: "Tax Year",
    TAX_YEAR_REQUIRED_MESSAGE: "Please enter a tax year",
    START_DATE_LABEL: "Start Date",
    START_DATE_REQUIRED_MESSAGE: "Please select a start date",
  },

  DETAILS: {
    DETAIL_TABS: [
      { key: "entities", label: "Entities" },
      { key: "projects", label: "Projects" },
      { key: "auditLog", label: "Audit Log" },
    ],
    EMPTY_VALUE_PLACEHOLDER: "—",
    ENGAGEMENT_UPDATED_MESSAGE: "Engagement updated",
    EDIT_ENGAGEMENT_MODAL_TITLE: "Edit Engagement",
    EDIT_MODAL_WIDTH_PX: 520,
    ENGAGEMENT_NAME_LABEL: "Engagement name",
    ENGAGEMENT_NAME_REQUIRED_MESSAGE: "Please enter an engagement name",
    ENGAGEMENT_NAME_PLACEHOLDER: "e.g. FY24 Annual Audit",
    ENGAGEMENT_TYPE_LABEL: "Engagement type",
    ENGAGEMENT_TYPE_REQUIRED_MESSAGE: "Please select a type",
    SELECT_TYPE_PLACEHOLDER: "Select type",
    STATUS_LABEL: "Status",
    // Edit modal's own status vocabulary — has "In Progress" instead of STATUS_COLORS'
    // "Draft"; a pre-existing inconsistency, preserved as-is, not unified.
    STATUS_OPTIONS: ["Active", "In Progress", "Completed"],
    DURATION_LABEL: "Duration",
    SINGLE_YEAR_OPTION_LABEL: "Single-year",
    MULTI_YEAR_OPTION_LABEL: "Multi-year",
    START_DATE_LABEL: "Start Date",
    END_DATE_LABEL: "End Date",
    LEAD_PARTNER_LABEL: "Lead Partner",
    LEAD_PARTNER_PLACEHOLDER: "e.g. John Anderson",
    NOTES_LABEL: "Notes",
    NOTES_PLACEHOLDER: "Additional context for this engagement...",
    SAVING_TEXT: "Saving…",
    SAVE_CHANGES_BUTTON_LABEL: "Save Changes",
    ENGAGEMENT_NOT_FOUND_TEXT: "Engagement not found",
    ENGAGEMENT_NOT_FOUND_SUBTEXT:
      "No engagement with this ID was found in your tenant's engagement list.",
    DEACTIVATE_CONFIRM_TITLE: "Deactivate engagement?",
    DEACTIVATE_CONFIRM_CONTENT: (description: string) =>
      `This will mark "${description}" as inactive. You can reactivate it later.`,
    ENGAGEMENT_DEACTIVATED_MESSAGE: "Engagement deactivated",
    GANTT_TIMELINE_TOOLTIP:
      "Gantt Timeline (2.4) — flagged as a follow-up, not yet built",
    GANTT_TIMELINE_ALERT_MESSAGE:
      "Show Timeline (2.4 Gantt) is a follow-up component — not built in this pass.",
    SHOW_TIMELINE_BUTTON_LABEL: "Show Timeline",
    ENGAGEMENT_DETAILS_CARD_TITLE: "Engagement Details",
    TYPE_LABEL: "Type",
    TAX_YEAR_LABEL: "Tax Year",
    TAX_YEAR_META_PREFIX: "Tax Year",
    ENGAGEMENT_ID_LABEL: "Engagement ID",
    OPEN_ENDED_TEXT: "Open-ended",
    LINKED_ENTITIES_CARD_TITLE: "Linked Entities & Partnerships",
    ADD_ENTITY_BUTTON_LABEL: "+ Add Entity",
    SELECT_ENTITY_TO_LINK_PLACEHOLDER: "Select an entity to link",
    NO_LINKED_ENTITIES_TEXT: "No linked entities",
    NO_LINKED_ENTITIES_SUBTEXT:
      'Use "Add Entity" above to link a partnership or partner to this engagement.',
    REMOVE_BUTTON_LABEL: "Remove",
    REMOVE_ENTITY_CONFIRM_TITLE: "Remove entity?",
    REMOVE_ENTITY_CONFIRM_CONTENT: (name: string) =>
      `Remove "${name}" from this engagement?`,
    ENTITY_REMOVED_MESSAGE: "Entity removed",
    ENTITY_LINKED_MESSAGE: "Entity linked",
    FAILED_TO_LOAD_ENTITIES_MESSAGE: "Failed to load entities",
    NOTES_CARD_TITLE: "Notes",
    NO_ENTITIES_IN_SCOPE_TEXT: "No entities in scope",
    NO_ENTITIES_IN_SCOPE_SUBTEXT:
      'Use "Add Entity" in the Linked Entities panel above to link a partnership or partner.',
    NO_PROJECTS_YET_TEXT: "No projects yet",
    NO_PROJECTS_YET_SUBTEXT:
      "Project listing scoped to an engagement is not yet supported in the backend.",
    NO_AUDIT_HISTORY_TEXT: "No audit history available",
    NO_AUDIT_HISTORY_SUBTEXT:
      "Engagement-level audit logging is not yet implemented in the backend.",
  },
};

// ClientView constants — shared top-level keys + nested per component
// (ClientList.tsx's several sub-components and CreateClientModal.tsx).
export const CLIENT_VIEW_CONSTANT = {
  ACTIVE_STATUS_COLORS: {
    Active: "#22c55e",
    Inactive: "#f59e0b",
  } as Record<string, string>,
  ACTIVE_LABEL: "Active",
  INACTIVE_LABEL: "Inactive",

  ENGAGEMENTS_TAB: {
    ADD_ENGAGEMENT_BUTTON_LABEL: "+ Add Engagement",
    ENGAGEMENT_ID_COLUMN_HEADER: "Engagement ID",
    ENGAGEMENT_TYPE_COLUMN_HEADER: "Engagement Type",
    DESCRIPTION_COLUMN_HEADER: "Description",
    TAX_YEAR_COLUMN_HEADER: "Tax Year",
    STATUS_COLUMN_HEADER: "Status",
    NO_ENGAGEMENTS_TEXT:
      "No engagements yet. Click + Add Engagement to create one.",
  },

  PARTNERSHIPS_TAB: {
    PARTNERSHIP_NAME_COLUMN_HEADER: "Partnership Name",
    STATUS_COLUMN_HEADER: "Status",
    NO_PARTNERSHIPS_TEXT: "No partnerships found.",
  },

  COA_TAB: {
    ACCOUNT_NUMBER_COLUMN_HEADER: "Account #",
    ACCOUNT_NAME_COLUMN_HEADER: "Account Name",
    TYPE_COLUMN_HEADER: "Type",
    CATEGORY_COLUMN_HEADER: "Category",
    BALANCE_COLUMN_HEADER: "Balance",
  },

  CALC_PROFILES_TAB: {
    COMING_SOON_TEXT: "Calculation Profiles — coming soon",
    NO_ENDPOINT_SUBTEXT:
      "No backend endpoint exists for calculation profiles yet.",
  },

  DETAILS_TAB: {
    CLIENT_INFORMATION_CARD_TITLE: "Client Information",
    CLIENT_NAME_LABEL: "Client Name",
    CLIENT_CODE_LABEL: "Client Code",
    STATUS_LABEL: "Status",
    CREATED_LABEL: "Created",
    WEBSITE_LABEL: "Website",
    PRIMARY_CONTACT_LABEL: "Primary Contact",
    CONTACT_EMAIL_LABEL: "Contact Email",
    CONTACT_PHONE_LABEL: "Contact Phone",
    STREET_ADDRESS_LABEL: "Street Address",
    CITY_LABEL: "City",
    STATE_LABEL: "State",
    ZIP_CODE_LABEL: "Zip Code",
    NOTES_LABEL: "Notes",
  },

  PROJECTS_TAB: {
    PROJECT_NAME_COLUMN_HEADER: "Project Name",
    TAX_YEAR_COLUMN_HEADER: "Tax Year",
    STATUS_COLUMN_HEADER: "Status",
    NO_PROJECTS_TEXT: "No projects found.",
  },

  AUDIT_LOG_TAB: {
    NO_AUDIT_HISTORY_TEXT: "No audit history available.",
    NO_ENDPOINT_SUBTEXT:
      "Client-level audit logging is not yet implemented in the backend.",
  },

  DETAIL_TABS: [
    { key: "engagements", label: "Engagements" },
    { key: "partnerships", label: "Partnerships" },
    { key: "details", label: "Details" },
    { key: "projects", label: "Projects" },
    { key: "tiering", label: "Tiering Relationship" },
    { key: "coa", label: "Chart of Accounts" },
    { key: "calcProfiles", label: "Calculation Profiles" },
    { key: "auditLog", label: "Audit Log" },
  ],

  DETAIL_PANEL: {
    CLOSE_PANEL_ARIA_LABEL: "Close panel",
    PARTNERSHIPS_STAT_LABEL: "Partnerships",
    ENGAGEMENTS_STAT_LABEL: "Engagements",
    PROJECTS_STAT_LABEL: "Projects",
    PARTNERS_STAT_LABEL: "Partners",
  },

  FILTER_PANEL: {
    CLOSE_FILTERS_ARIA_LABEL: "Close filters",
    FILTERS_TITLE: "Filters",
    STATUS_LABEL: "Status",
    ALL_LABEL: "All",
    DATE_CREATED_RANGE_LABEL: "Date Created Range",
  },

  LIST: {
    FAILED_TO_LOAD_CLIENTS_MESSAGE: "Failed to load clients",
    CLIENT_NAME_COLUMN_HEADER: "Client Name",
    CLIENT_SINCE_COLUMN_HEADER: "Client Since",
    SELECT_MENU_LABEL: "Select",
    DESELECT_MENU_LABEL: "Deselect",
    PAGE_TITLE: "Master Clients",
    CREATE_NEW_CLIENT_BUTTON_LABEL: "Create New Client",
    SEARCH_CLIENTS_PLACEHOLDER: "Search clients...",
    FILTERS_BUTTON_LABEL: "Filters",
    ACTIVE_ONLY_CHIP_TEXT: "Active only",
    INACTIVE_ONLY_CHIP_TEXT: "Inactive only",
    TABLE_FOOTER_TEXT: (shown: number, total: number) =>
      `Showing ${shown} of ${total} client${total !== 1 ? "s" : ""}`,
    DEACTIVATE_CLIENT_MODAL_TITLE: "Deactivate client?",
    REACTIVATE_CLIENT_MODAL_TITLE: "Reactivate client?",
    DEACTIVATE_NOT_SUPPORTED_MESSAGE:
      "Deactivate / reactivate is not yet supported (no backend endpoint). TODO: add PATCH /api/client/{id}/status.",
    DEACTIVATE_CONFIRM_CONTENT: (name?: string) =>
      `This will mark "${name}" as inactive. You can reactivate it later.`,
    REACTIVATE_CONFIRM_CONTENT: (name?: string) =>
      `This will reactivate "${name}".`,
  },

  CREATE_MODAL: {
    CLIENT_CREATED_MESSAGE: "Client created successfully",
    FAILED_TO_CREATE_CLIENT_MESSAGE: "Failed to create client",
    CLIENT_ALREADY_EXISTS_MESSAGE: "Client already exists.",
    MODAL_TITLE: "Create New Client",
    MODAL_WIDTH_PX: 560,
    CLIENT_NAME_LABEL: "Client Name",
    CLIENT_NAME_REQUIRED_MESSAGE: "Client Name is required",
    CLIENT_NAME_PLACEHOLDER: "e.g. Westfield Capital Partners LP",
    CLIENT_CODE_LABEL: "Client Code",
    CLIENT_CODE_REQUIRED_MESSAGE: "Client Code is required",
    CLIENT_CODE_HINT: "Short ID, e.g. WCP",
    CLIENT_CODE_PLACEHOLDER: "WCP",
    WEBSITE_LABEL: "Website",
    WEBSITE_PLACEHOLDER: "https://www.example.com",
    PRIMARY_CONTACT_NAME_LABEL: "Primary Contact Name",
    PRIMARY_CONTACT_NAME_PLACEHOLDER: "Jane Smith",
    EMAIL_LABEL: "Email",
    EMAIL_INVALID_MESSAGE: "Enter a valid email",
    EMAIL_PLACEHOLDER: "jane@example.com",
    PHONE_LABEL: "Phone",
    PHONE_PLACEHOLDER: "(555) 000-0000",
    STREET_ADDRESS_LABEL: "Street Address",
    STREET_ADDRESS_PLACEHOLDER: "1200 Innovation Way, Suite 400",
    CITY_LABEL: "City",
    CITY_PLACEHOLDER: "San Francisco",
    STATE_LABEL: "State",
    STATE_PLACEHOLDER: "CA",
    ZIP_CODE_LABEL: "ZIP Code",
    ZIP_CODE_PLACEHOLDER: "94105",
    NOTES_LABEL: "Notes",
    NOTES_PLACEHOLDER: "Additional notes about this client...",
    // Field length limits / format rules (mirror the API's column sizes).
    CLIENT_NAME_MAX: 100,
    CLIENT_CODE_MAX: 20,
    WEBSITE_MAX: 200,
    CONTACT_NAME_MAX: 100,
    EMAIL_MAX: 254,
    ADDRESS_MAX: 200,
    PHONE_INPUT_MAX_LENGTH: 20,
    PHONE_MIN_DIGITS: 7,
    PHONE_MAX_DIGITS: 15,
    CLIENT_CODE_PATTERN: /^[A-Za-z0-9_-]+$/,
    WEBSITE_PATTERN: /^https?:\/\/[^\s/$.?#][^\s]*$/i,
    PHONE_DISALLOWED_CHARS_PATTERN: /[^0-9()+\-.\s]/g,
    PHONE_ALLOWED_PATTERN: /^[0-9()+\-.\s]+$/,
    CLIENT_NAME_MAX_MESSAGE: (max: number) =>
      `Client Name must be ${max} characters or fewer`,
    CLIENT_CODE_PATTERN_MESSAGE: "Use letters, numbers, - or _ only",
    WEBSITE_INVALID_MESSAGE:
      "Enter a valid URL starting with http:// or https://",
    WEBSITE_MAX_MESSAGE: (max: number) =>
      `Website must be ${max} characters or fewer`,
    CONTACT_NAME_MAX_MESSAGE: (max: number) =>
      `Must be ${max} characters or fewer`,
    EMAIL_MAX_MESSAGE: (max: number) =>
      `Email must be ${max} characters or fewer`,
    PHONE_INVALID_MESSAGE: "Enter a valid phone number",
    ADDRESS_MAX_MESSAGE: (max: number) =>
      `Address must be ${max} characters or fewer`,
    // Modal body scrolls inside the modal (header/footer stay put). Offsets in px for the
    // header + footer chrome; scrollbar gutter pulled into the modal's side padding.
    BODY_MAX_HEIGHT: "calc(100vh - 16.25rem)",
    BODY_SCROLLBAR_GUTTER: "1rem",
    DISABLED_BUTTON_OPACITY: 0.6,
  },
};

// EntityView constants — shared top-level keys (used by both EntityList.tsx's create/edit
// forms and EntityDetails.tsx's inline edit modal) + nested per page.
export const ENTITY_VIEW_CONSTANT = {
  PARTNERSHIP_CATEGORIES: [
    "Limited Partnership",
    "LLC",
    "S-Corporation",
    "C-Corporation",
    "General Partnership",
  ],
  STATUS_OPTIONS: ["Active", "Inactive"],
  ENTITY_NAME_LABEL: "Entity Name",
  TAX_ENTITY_TYPE_LABEL: "Tax Entity Type",
  STATUS_LABEL: "Status",
  STREET_ADDRESS_LABEL: "Street Address",
  CITY_LABEL: "City",
  STATE_LABEL: "State",
  ZIP_CODE_LABEL: "ZIP Code",
  NOTES_LABEL: "Notes",
  SAVING_TEXT: "Saving…",
  BACK_TO_ENTITIES_BUTTON_LABEL: "Back to Entities",
  ENTITIES_ROUTE: "/entities",
  ENTITY_KIND: {
    PARTNERSHIP: "partnership",
    PARTNER: "partner",
    OTHER: "other",
  } as const,
  FORM_MODE: {
    CREATE: "create",
    EDIT: "edit",
  } as const,
  // Shared create/edit form (EntityFormModal)
  FORM: {
    MODAL_WIDTH_PX: 560,
    // entityType values the API stores/expects.
    API_ENTITY_TYPE_PARTNERSHIP: "Partnership",
    API_ENTITY_TYPE_PARTNER: "Partner",
    DEFAULT_PARTNERSHIP_CATEGORY: "Limited Partnership",
    DEFAULT_TAX_YEAR_START: "January 1",
    DEFAULT_STATUS: "Active",
    STATE_MAX_LENGTH: 2,
    NOTES_ROWS: 3,
    SSN_INPUT_PADDING_RIGHT: "2.4rem",
  },
  EDIT_ENTITY_MODAL_TITLE: "Edit Entity",
  DEACTIVATE_ENTITY_CONFIRM_TITLE: "Deactivate entity?",
  ENTITY_DEACTIVATED_MESSAGE: "Entity deactivated",
  // External K1 Intake (WO-3 Part 2) — marks a lower-tier partnership whose K-1 is uploaded as a
  // PDF rather than produced by this platform's own calc engine.
  IS_EXTERNAL_CHECKBOX_LABEL: "External (K-1 uploaded, not calculated)",
  IS_EXTERNAL_CHECKBOX_HINT: "This partnership's K-1 is received as a PDF from outside the platform, not produced by its own calculation.",

  LIST: {
    PARTNERSHIP_BADGE_LABEL: "Partnership",
    TYPE_FILTER_OPTIONS: [
      { label: "All", value: "all" },
      { label: "Partnerships", value: "partnership" },
      { label: "Partners", value: "partner" },
    ],
    TYPE_FILTER_ARIA_LABEL: "Filter by entity type",
    TYPE_FILTER_ALL_VALUE: "all",
    SEARCH_PARAM_KEY: "q",
    TYPE_PARAM_KEY: "type",
    ENT_ID_PREFIX: "ent-",
    ENT_ID_PAD_LENGTH: 3,
    NO_FILTER_MATCHES_TEXT: "No entities match your search or filter",
    NO_ENTITIES_FOR_CLIENT_TEXT:
      "No entities found for this client. Click + Create Entity to add one.",
    TABLE_FOOTER_ENTITIES_TEXT: (shown: number, total: number) =>
      `Showing ${shown} of ${total} ${total !== 1 ? "entities" : "entity"}`,
    PARTNER_BADGE_LABEL: "Partner",
    PARTNERSHIP_NAME_REQUIRED_MESSAGE: "Partnership name is required",
    EIN_LABEL: "EIN",
    EIN_HINT: "Format: XX-XXXXXXX",
    EIN_PLACEHOLDER: "12-3456789",
    ENTITY_NAME_PLACEHOLDER: "e.g. TechCorp Global LP",
    TAX_YEAR_START_LABEL: "Tax Year Start",
    TAX_YEAR_START_OPTIONS: ["January 1", "April 1", "July 1", "October 1"],
    PARTNERSHIP_ADDRESS_PLACEHOLDER: "1200 Innovation Way, Suite 400",
    PARTNERSHIP_CITY_PLACEHOLDER: "Palo Alto",
    PARTNERSHIP_STATE_PLACEHOLDER: "CA",
    PARTNERSHIP_ZIP_PLACEHOLDER: "94304",
    PARTNERSHIP_NOTES_PLACEHOLDER: "Notes about this entity...",
    SAVE_ENTITY_BUTTON_LABEL: "Save Entity",
    FULL_NAME_LABEL: "Full Name",
    FULL_NAME_REQUIRED_MESSAGE: "Full name is required",
    ENTITY_TYPES_LOAD_ERROR_MESSAGE: "Could not load the entity type list. Please reload and try again.",
    FULL_NAME_PLACEHOLDER: "e.g. James Worthington",
    SSN_LABEL: "SSN",
    SSN_ENCRYPTED_BADGE_TEXT: "Encrypted",
    SSN_PLACEHOLDER: "123-45-6789",
    SSN_HINT:
      "SSN is encrypted at rest. Only last 4 digits visible after save.",
    PARTNER_ADDRESS_PLACEHOLDER: "123 Main St",
    PARTNER_CITY_PLACEHOLDER: "New York",
    PARTNER_STATE_PLACEHOLDER: "NY",
    PARTNER_ZIP_PLACEHOLDER: "10001",
    PARTNER_NOTES_PLACEHOLDER: "Notes about this partner...",
    SAVE_PARTNER_BUTTON_LABEL: "Save Partner",
    ADD_ENTITY_MODAL_TITLE: "Add Entity",
    ADD_ENTITY_MODAL_SUBTITLE: "What type of entity would you like to create?",
    PARTNERSHIP_CARD_TITLE: "Partnership",
    PARTNERSHIP_CARD_SUBTEXT:
      "A legal entity (LP, LLC, S-Corp) that files its own return",
    PARTNER_CARD_TITLE: "Partner",
    PARTNER_CARD_SUBTEXT:
      "An individual or entity that holds interest in a partnership",
    ENTITY_SAVED_MESSAGE: (mode: "create" | "edit") =>
      `Entity ${mode === "create" ? "created" : "updated"} successfully`,
    CREATE_PARTNERSHIP_MODAL_TITLE: "Create Partnership",
    CREATE_PARTNER_MODAL_TITLE: "Create Partner",
    FAILED_TO_LOAD_ENTITIES_MESSAGE: "Failed to load entities",
    PAGE_TITLE: "Entities",
    PAGE_SUBTITLE: "Manage all partnerships and partners under master clients.",
    IMPORT_SELECT_CLIENT_MESSAGE: "Select a client before importing entities.",
    IMPORT_BUTTON_LABEL: "Import entities",
    CREATE_ENTITY_BUTTON_LABEL: "+ Create Entity",
    SEARCH_ENTITIES_PLACEHOLDER: "Search by name or ENT-id...",
    NO_ENTITIES_FOUND_TEXT:
      "No entities found. Click + Create Entity to add one.",
    ENTITY_NAME_COLUMN_HEADER: "ENTITY NAME",
    TYPE_COLUMN_HEADER: "TYPE",
    EIN_SSN_COLUMN_HEADER: "EIN / SSN",
    TAX_ENTITY_TYPE_COLUMN_HEADER: "TAX ENTITY TYPE",
    NO_SEARCH_MATCHES_TEXT: "No partnerships match your search",
    NO_PARTNERSHIPS_FOUND_TEXT:
      "No partnerships found for this client. Click + Create Entity to add one.",
    MANAGE_PARTNERS_BUTTON_LABEL: "Manage Partners →",
    DEACTIVATE_ENTITY_CONFIRM_CONTENT: (name: string) =>
      `This will mark "${name}" as inactive.`,
    TABLE_FOOTER_TEXT: (shown: number, total: number) =>
      `Showing ${shown} of ${total} partnership${total !== 1 ? "s" : ""}`,
  },

  DETAILS: {
    DETAIL_TABS: [
      { key: "ownership", label: "Ownership" },
      { key: "partners", label: "Partners" },
      { key: "projects", label: "Projects" },
      { key: "engagements", label: "Engagements" },
      { key: "auditLog", label: "Audit Log" },
    ],
    ENTITY_NOT_FOUND_TEXT: "Entity not found",
    ENTITY_NOT_FOUND_SUBTEXT:
      "No entity with this ID was found in your tenant.",
    FAILED_TO_LOAD_OWNERSHIP_TEXT: "Failed to load ownership data",
    NO_OWNERSHIP_RELATIONSHIPS_TEXT: "No ownership relationships",
    NO_OWNERSHIP_RELATIONSHIPS_SUBTEXT:
      "No tiering relationships are defined for this entity. Use the Tiering module to define ownership structure.",
    OPEN_IN_TIERING_VIEW_BUTTON_LABEL: "Open in Tiering View →",
    PARTNER_NAME_COLUMN_HEADER: "Partner Name",
    RELATIONSHIP_COLUMN_HEADER: "Relationship",
    OWNERSHIP_PERCENT_COLUMN_HEADER: "Ownership %",
    TIER_LEVEL_COLUMN_HEADER: "Tier Level",
    TIER_LEVEL_VALUE: (level: number) => `Level ${level}`,
    FAILED_TO_LOAD_PROJECTS_TEXT: "Failed to load projects",
    NO_PROJECTS_YET_TEXT: "No projects yet",
    NO_PROJECTS_YET_SUBTEXT: "No projects are linked to this entity.",
    PROJECT_NAME_COLUMN_HEADER: "Project Name",
    TAX_YEAR_COLUMN_HEADER: "Tax Year",
    TYPE_COLUMN_HEADER: "Type",
    STATUS_COLUMN_HEADER: "Status",
    CREATED_COLUMN_HEADER: "Created",
    NAME_REQUIRED_MESSAGE: "Name is required",
    ENTITY_UPDATED_MESSAGE: "Entity updated",
    CATEGORY_LABEL: "Category",
    ENTITY_NAME_INPUT_PLACEHOLDER: "Entity name",
    ADDRESS_PLACEHOLDER: "123 Main St",
    CITY_PLACEHOLDER: "New York",
    STATE_PLACEHOLDER: "NY",
    ZIP_PLACEHOLDER: "10001",
    SAVE_CHANGES_BUTTON_LABEL: "Save Changes",
    EDIT_MODAL_WIDTH_PX: 520,
    ENTITY_DETAILS_CARD_TITLE: "Entity Details",
    NAME_LABEL: "Name",
    ENTITY_ID_LABEL: "Entity ID",
    ENTITY_TYPE_LABEL: "Entity Type",
    EIN_SSN_LABEL: "EIN / SSN",
    CATEGORY_FIELD_LABEL: "Category",
    LOCATION_SYSTEM_CARD_TITLE: "Location & System",
    TAX_YEAR_START_LABEL: "Tax Year Start",
    DATE_CREATED_LABEL: "Date Created",
    CITY_FIELD_LABEL: "City",
    STATE_FIELD_LABEL: "State",
    ADDRESS_FIELD_LABEL: "Address",
    CLIENT_LABEL: "Client",
    ENGAGEMENTS_COMING_SOON_TITLE: "Engagements",
    AUDIT_LOG_COMING_SOON_TITLE: "Audit Log",
    DEACTIVATE_ENTITY_CONFIRM_CONTENT: (name: string) =>
      `This will mark "${name}" as inactive. You can reactivate it later.`,
  },
};

// Per-sheet input readiness panel (WO-8). Its own top-level export, rather than a key inside
// CALCULATIONS_VIEW_CONSTANT.PROJECT_WORKSPACE, so it doesn't share a hunk with the workspace
// string additions other in-flight branches make.
export const INPUT_READINESS_CONSTANT = {
  PANEL_TITLE: "Input readiness",
  EXPAND_ARIA_LABEL: "Show input readiness",
  COLLAPSE_ARIA_LABEL: "Hide input readiness",
  LOADING_TEXT: "Checking inputs...",
  UNAVAILABLE_TEXT: "Input readiness is unavailable right now.",
  NO_SHEETS_TEXT: "There are no input sheets to report on.",
  SELECT_SHEET_TOOLTIP: "Open this sheet in the workspace",
  STATUS_LABELS: {
    missing: "Missing",
    partial: "Partial",
    ready: "Ready",
    chained: "Chained",
    optional: "Optional",
  },
  SUMMARY_TEXT: (missing: number, ready: number, chained: number, optional: number) =>
    `${missing} missing · ${ready} ready · ${chained} chained · ${optional} optional`,
  ROW_COUNT_TEXT: (count: number) => `${count} ${count === 1 ? "row" : "rows"}`,
  LAST_LOADED_TEXT: (when: string) => `Loaded ${when}`,
  NEVER_LOADED_TEXT: "No data loaded",
  // Shown above the workspace grid when the sheet has rows loaded from the Inputs tab that the grid does not read (WO-44).
  LOADED_ROWS_NOT_SHOWN_TEXT: "Rows loaded from the Inputs tab are not shown here. Save or Upload Data will replace them.",
  // WO-60: the grid shows those rows, read-only, and Save, Upload Data and Add Row are off for that sheet.
  INPUTS_TAB_ROWS_NOTICE_TEXT: "These rows were loaded from the Inputs tab. To change them, use Replace data on the Inputs tab.",
  INPUTS_TAB_ROWS_ACTION_DISABLED_TITLE: "These rows were loaded from the Inputs tab. Use Replace data on the Inputs tab to change them.",
  // Keyed by the server's source value. A source with no entry here shows no label (never "undefined").
  SOURCE_TEXT: {
    manual: "entered in workspace",
    upload: "uploaded",
    roster: "filled from the partner list",
    rollforward: "rolled forward from last year",
  } as Record<string, string>,
};

// Inputs tab and the input import wizard (WO-10, wiki FR-20.12). Its own top-level export, like
// INPUT_READINESS_CONSTANT above, so it does not share a hunk with other in-flight string additions.
// Plain language on purpose: the audience is a preparer, not an engineer. No template sheet or
// column name appears here — those always come from the API.
export const INPUT_WIZARD_CONSTANT = {
  TAB_LABEL: "Inputs",
  LOADING_TEXT: "Checking your inputs...",
  UNAVAILABLE_TEXT: "We couldn't load the list of inputs right now.",
  TRY_AGAIN_TEXT: "Try again",
  NO_SHEETS_TEXT: "This project has no input sheets to load.",
  NO_LOAD_PERMISSION_TEXT: "You do not have permission to load data on this project.",
  REFRESH_PERMISSIONS_TEXT: "Refresh permissions",
  REFRESHING_PERMISSIONS_TEXT: "Refreshing...",
  REFRESH_UNMATCHED_TEXT: "Your account could not be matched to a user profile. Contact an administrator.",
  REFRESH_FAILED_TEXT: "We couldn't refresh your permissions right now. Try again.",
  REFRESH_NO_SESSION_TEXT: "Permissions refresh is only available when signed in with single sign-on.",
  REFRESH_NO_CHANGE_TEXT: "Your permissions were refreshed. This account has no permission to load data on this project.",
  READINESS_MESSAGE_PREFIX: "Note: ",
  BANNER_READY: "Ready to run",
  BANNER_NEEDS_DATA: (missing: number, unloadable: number) =>
    `${missing} required ${missing === 1 ? "sheet needs" : "sheets need"} data` +
    (unloadable > 0 ? ` (${unloadable} can't be loaded here yet)` : ""),
  PERIOD_LABEL: "Period",
  PERIOD_PLACEHOLDER: "Choose a period",
  PERIOD_REQUIRED_HINT: "Choose a period to see and load its inputs.",
  CHIP: {
    missing: "Missing",
    loaded: "Loaded",
    optionalEmpty: "Optional, not loaded",
    chained: "Filled automatically",
    cannotLoad: "Can't load here",
  },
  REQUIRED_TEXT: "Required",
  OPTIONAL_TEXT: "Optional",
  NO_DATA_TEXT: "No data yet",
  ROWS_TEXT: (count: number) => `${count} ${count === 1 ? "row" : "rows"}`,
  SOURCE_IMPORTED: (fileName: string, rows: string, when: string | null, who?: string | null) =>
    `Imported from ${fileName} · ${rows}${when ? ` · ${when}` : ""}${who ? ` · by ${who}` : ""}`,
  SOURCE_ROSTER: (rows: string, when: string | null, who?: string | null) =>
    `Filled from the partner list · ${rows}${when ? ` · ${when}` : ""}${who ? ` · by ${who}` : ""}`,
  SOURCE_ROLLFORWARD: (rows: string, when: string | null, who?: string | null) =>
    `Rolled forward from last year · ${rows}${when ? ` · ${when}` : ""}${who ? ` · by ${who}` : ""}`,
  SOURCE_MANUAL: (rows: string, when: string | null) =>
    `Entered by hand in the workspace · ${rows}${when ? ` · ${when}` : ""}`,
  SOURCE_UPLOADED_IN_WORKSPACE: (rows: string, when: string | null) =>
    `Uploaded in the workspace · ${rows}${when ? ` · ${when}` : ""}`,
  SOURCE_LOADED_OTHER: (rows: string, when: string | null) =>
    `Loaded · ${rows}${when ? ` · ${when}` : ""}`,
  FILLED_FROM: (hint: string) => `Filled automatically from ${hint}`,
  FILLED_FROM_OTHER: "Filled automatically from another calculation",
  ACTION_LOAD: "Load data",
  ACTION_REPLACE: "Replace data",
  ACTION_ARIA: (verb: string, sheet: string) => `${verb} for ${sheet}`,
  // View rows (WO-44): a read-only look at the rows a loaded sheet holds.
  VIEW_ROWS_ACTION: "View rows",
  VIEW_ROWS_HIDE_ACTION: "Hide rows",
  VIEW_ROWS_ARIA: (sheet: string) => `View rows of ${sheet}`,
  VIEW_ROWS_HIDE_ARIA: (sheet: string) => `Hide rows of ${sheet}`,
  VIEW_ROWS_REGION_ARIA: (sheet: string) => `Rows of ${sheet}`,
  VIEW_ROWS_LIMIT: 100,
  VIEW_ROWS_LOADING: "Loading the rows...",
  VIEW_ROWS_FAILED: "We couldn't load the rows. Please try again.",
  VIEW_ROWS_RETRY: "Try again",
  VIEW_ROWS_EMPTY: "There are no rows to show for this sheet.",
  VIEW_ROWS_READ_ONLY: "Read only. Use Replace data to change these rows.",
  VIEW_ROWS_COUNT: (shown: number, total: number) =>
    shown < total
      ? `Showing the first ${shown.toLocaleString()} of ${total.toLocaleString()} rows.`
      : `${total.toLocaleString()} ${total === 1 ? "row" : "rows"}.`,
  VIEW_ROWS_COLUMN_FALLBACK: (index: number) => `Column ${index}`,
  GROUP_ARIA: (calc: string) => `Input sheets for ${calc}`,

  // ── Fill from the partner list (WO-10 Part 2) ─────────────────────────────────────────────
  // Counts and totals come from the server; these strings only format them.
  FILL_ACTION: "Fill from partner list",
  FILL_ARIA: (sheet: string) => `Fill from partner list for ${sheet}`,
  FILL_DIALOG_TITLE: (sheet: string) => `Fill ${sheet} from the partner list`,
  FILL_READING: "Reading the partner list...",
  FILL_SUMMARY: (added: number, updated: number, kept: number) =>
    `${added} ${added === 1 ? "partner" : "partners"} will be added, ${updated} updated and ${kept} kept on the sheet.`,
  FILL_ROWS_TOTAL: (rows: number) => `The sheet will have ${rows} ${rows === 1 ? "row" : "rows"}.`,
  FILL_OWNERSHIP: (pct: string) => `The partners filled in own ${pct}% in total.`,
  FILL_LOOK_THROUGH: (count: number, names: string) =>
    `${count} look-through ${count === 1 ? "partner is" : "partners are"} left out: ${names}.`,
  FILL_PARTNERSHIPS: (count: number) =>
    `${count} ${count === 1 ? "partner on the list is itself a partnership and is" : "partners on the list are themselves partnerships and are"} filled in like any other partner.`,
  FILL_NOTES_HEADING: "How the sheet will be filled",
  FILL_CLASS_CHANGE_TITLE: "Some partner IDs will change",
  FILL_CLASS_CHANGE_INTRO: "A partner's class changed, which changes its ID on this sheet. Rows on other sheets that still use the old ID need updating:",
  FILL_CLASS_CHANGE_TICK: "I understand these IDs will change and the rows listed need updating.",
  FILL_BLOCKED_ADVICE: "Fix these on the partner list or on the sheet, then check again.",
  // "Showing 2 of 600 problems and 1 of 3 warnings." — each pair is the server's own two counts.
  FILL_CAPPED_PART: (shown: number, total: number, noun: string) => `${shown} of ${total} ${noun}`,
  FILL_CAPPED: (parts: string) => `Showing ${parts}. Fix the first ones, then check again.`,
  FILL_NO_CHANGE: "The sheet already matches the partner list.",
  FILL_CONFIRM_BUTTON: "Fill the sheet",
  FILL_CHECK_AGAIN: "Check again",
  FILL_FILLING: "Filling the sheet...",
  FILL_RESULT_NO_CHANGE: "The sheet already matches the partner list. Nothing was changed.",
  FILL_RESULT_REJECTED: "Nothing was filled because of problems.",
  FILL_ROSTER_CHANGED_NOTICE: "The partner list or the sheet changed since you previewed, so we checked again. Please review before filling.",
  FILL_FAILED: "We couldn't read the partner list. Please try again.",
  FILL_UNSUPPORTED: "This sheet cannot be filled from the partner list.",
  FILL_UNKNOWN_OUTCOME_TITLE: "We couldn't confirm whether the sheet was filled.",

  // ── Roll forward from last year (WO-25 Part B) ────────────────────────────────────────────
  // Counts, names and keys come from the server; these strings only format them. No sheet or
  // column name appears here. The server's own description is preferred for a refused call; the
  // sentences below are only the fallback when it sends none.
  ROLLFORWARD_ACTION: "Roll forward from last year",
  ROLLFORWARD_ARIA: (sheet: string) => `Roll forward from last year for ${sheet}`,
  ROLLFORWARD_DIALOG_TITLE: (sheet: string) => `Roll ${sheet} forward from last year`,
  ROLLFORWARD_READING: "Reading last year's results...",
  ROLLFORWARD_SOURCE: (name: string, year: number | null) => `From ${name}${year !== null ? ` (${year})` : ""}.`,
  ROLLFORWARD_SUMMARY: (copied: number, updated: number, kept: number) =>
    `${copied} ${copied === 1 ? "row" : "rows"} will be copied from last year, ${updated} replaced and ${kept} kept on the sheet.`,
  ROLLFORWARD_ROWS_TOTAL: (rows: number) => `The sheet will have ${rows} ${rows === 1 ? "row" : "rows"}.`,
  ROLLFORWARD_DROPPED: (count: number) =>
    `${count} ${count === 1 ? "row" : "rows"} from last year ${count === 1 ? "was" : "were"} left out because ${count === 1 ? "that partner is" : "those partners are"} not on this year's partner list:`,
  ROLLFORWARD_DROPPED_SHOWN: (shown: number, total: number) => `Showing ${shown} of ${total}.`,
  ROLLFORWARD_UNMATCHED: (count: number) =>
    `${count} ${count === 1 ? "row" : "rows"} from last year did not apply to this year's partner list and ${count === 1 ? "was" : "were"} not copied.`,
  ROLLFORWARD_PARTNER_LIST_FOOTNOTE: "If rows were left out and that looks wrong, fill or update the partner list first, then check again.",
  ROLLFORWARD_NOTES_HEADING: "How last year's values are matched",
  ROLLFORWARD_BLOCKED_ADVICE: "Fix these, then check again.",
  ROLLFORWARD_NO_CHANGE: "The sheet already matches last year's results.",
  ROLLFORWARD_CONFIRM_BUTTON: "Roll forward",
  ROLLFORWARD_CHECK_AGAIN: "Check again",
  ROLLFORWARD_ROLLING: "Rolling the sheet forward...",
  ROLLFORWARD_RESULT_NO_CHANGE: "The sheet already matches last year's results. Nothing was changed.",
  ROLLFORWARD_RESULT_REJECTED: "Nothing was rolled forward because of problems.",
  ROLLFORWARD_CHANGED_NOTICE: "The sheets or last year's results changed since you previewed, so we checked again. Please review before rolling forward.",
  ROLLFORWARD_FAILED: "We couldn't read last year's results. Please try again.",
  ROLLFORWARD_UNSUPPORTED: "This sheet cannot be rolled forward.",
  ROLLFORWARD_NO_SOURCE: "There is no prior-year project for this partnership to roll forward from.",
  ROLLFORWARD_SOURCE_NOT_COMPLETED: "Last year's project has no completed calculation yet.",
  ROLLFORWARD_PICK_HEADING: "More than one project from a prior year could be used. Choose the one to roll forward from:",
  ROLLFORWARD_PICK_ARIA: "Prior-year projects",
  ROLLFORWARD_PICK_COMPLETED: (when: string) => `Completed ${when}`,
  ROLLFORWARD_PICK_NONE: "We couldn't find a project to choose from. Please try again.",
  ROLLFORWARD_CONTINUE: "Continue",
  ROLLFORWARD_UNKNOWN_OUTCOME_TITLE: "We couldn't confirm whether the sheet was rolled forward.",

  // ── Wizard ────────────────────────────────────────────────────────────────────────────────
  WIZARD_TITLE: (sheet: string) => `Load data into ${sheet}`,
  STEP_TITLES: ["Choose your file", "Match your columns", "Check results", "Done"],
  STEP_PROGRESS: (n: number, total: number, title: string) => `Step ${n} of ${total}: ${title}`,
  SPEC_LOADING: "Reading what this sheet needs...",
  SPEC_FAILED: "We couldn't read what this sheet needs.",
  NEEDS_HEADING: "What this sheet needs",
  NEEDS_COLUMNS: ["Column", "Type", "Required?", "Example", "Allowed values"],
  NEEDS_ROW_LIMIT: (limit: number) => `Up to ${limit.toLocaleString()} rows per file.`,
  TYPE_LABELS: {
    Text: "Text",
    Decimal: "Number",
    Integer: "Whole number",
    Date: "Date",
    List: "One of a list",
  } as Record<string, string>,
  YES_TEXT: "Yes",
  NO_TEXT: "No",
  EXAMPLE_FILE_BUTTON: "Download an example file (CSV)",
  EXAMPLE_FILE_NAME: (sheet: string) => `${sheet} - example.csv`,
  REPLACE_NOTICE: (rows: number) =>
    `This sheet already has ${rows} ${rows === 1 ? "row" : "rows"}. Loading a new file replaces them.`,
  CHOOSE_FILE_BUTTON: "Choose a file",
  CHOOSE_FILE_HINT: "Excel (.xlsx) or CSV (.csv), up to 20 MB.",
  FILE_CHOSEN: (name: string) => `Selected file: ${name}`,
  MAX_FILE_BYTES: 20 * 1024 * 1024,
  FILE_TOO_BIG: "This file is larger than 20 MB. Split it into smaller files.",
  FILE_WRONG_TYPE: "Only Excel (.xlsx) and CSV (.csv) files can be loaded.",
  FILE_EMPTY: "This file is empty.",
  CHECKING_FILE: "Checking your file...",
  MAP_INTRO: "Tell us which column in your file holds each piece of information. Required items are marked *.",
  MAP_COLUMNS: ["What we need", "Column in your file", "Examples from your file", "How it was matched"],
  MAP_LEAVE_EMPTY: "Leave empty",
  MAP_SELECT_ARIA: (target: string) => `Column in your file for ${target}`,
  MAP_ORIGIN: {
    saved: "Remembered from last time",
    auto: "Matched automatically",
    user: "You chose this",
    none: "Not matched yet",
  } as Record<string, string>,
  MAP_REQUIRED_BLOCK: "Match every required column (marked *) to continue.",
  MAP_DIRTY_BLOCK: "You changed the matches. Choose “Update check” to re-check your file before continuing.",
  MAP_UPDATE_BUTTON: "Update check",
  HEADER_ROW_NOTE: (row: number) => `We used row ${row} of your file as the heading row.`,
  BUTTON_BACK: "Back",
  BUTTON_NEXT: "Next",
  BUTTON_CANCEL: "Cancel",
  BUTTON_CLOSE: "Close",
  BUTTON_DONE: "Done",
  BUTTON_CHOOSE_OTHER_FILE: "Choose a different file",
  BUTTON_CHANGE_MATCHES: "Change column matches",
  BUTTON_APPROVE: "Approve and load",
  REVIEW_STATUS: {
    AllClear: "Looks good",
    Warnings: "Looks good, with warnings",
    Errors: "Problems to fix",
  } as Record<string, string>,
  REVIEW_COUNTS: (errors: number, warnings: number) =>
    `${errors} ${errors === 1 ? "problem" : "problems"} · ${warnings} ${warnings === 1 ? "warning" : "warnings"}`,
  REVIEW_CAPPED: (shown: number, total: number) =>
    `Showing the first ${shown} of ${total}. Fix the first ones, then check again.`,
  REVIEW_WILL_LOAD: (rows: number) => `${rows.toLocaleString()} ${rows === 1 ? "row" : "rows"} will be loaded.`,
  REVIEW_WILL_REPLACE: (rows: number) =>
    `This replaces ${rows.toLocaleString()} ${rows === 1 ? "row" : "rows"} currently in this sheet.`,
  REVIEW_SKIPPED: (rows: number) => `${rows} blank ${rows === 1 ? "row was" : "rows were"} skipped.`,
  REVIEW_BLOCKED: "Fix the problems above before you can load this file.",
  TOTALS_HEADING: "Totals in your file",
  TOTALS_COLUMNS: ["Column", "Group", "Rows", "Total"],
  PREVIEW_HEADING: "First rows",
  PREVIEW_NOTE: (shown: number, total: number) => `Showing the first ${shown} of ${total.toLocaleString()} rows.`,
  REMEMBER_MATCHES: "Remember these column matches for next time",
  DIAG_COLUMNS: ["Row", "Column", "Type", "What happened"],
  DIAG_FILTER_ALL: "All",
  DIAG_FILTER_ARIA: "Show",
  DIAG_CAPTION: "Problems and notes found in your file",
  DIAG_NO_ROW: "Whole file",
  DIAG_DOWNLOAD: "Download this list (CSV)",
  DIAG_CSV_HEADER: ["Row", "Column", "Type", "Code", "What happened"],
  DIAG_CSV_NAME: (sheet: string) => `${sheet} - problems.csv`,
  SEVERITY_LABELS: { Error: "Problem", Warning: "Warning", Info: "Note" } as Record<string, string>,
  COMMITTING: "Loading your data...",
  COMMITTING_LONG: "This is taking longer than usual. Large files can take a minute or two. Please keep this window open.",
  COMMIT_LONG_AFTER_MS: 20000,
  RESULT_LOADED: (rows: number, sheet: string) => `Loaded ${rows.toLocaleString()} ${rows === 1 ? "row" : "rows"} into ${sheet}.`,
  RESULT_REPLACED_PREVIOUS: "The previous file's rows were replaced.",
  RESULT_MAPPING_SAVED: "Your column matches were saved for next time.",
  RESULT_NO_CHANGE: "This is the same file that is already loaded. Nothing was changed.",
  RESULT_REJECTED: "Nothing was loaded because of problems in the file.",
  RESULT_DOWNLOAD_REPORT: "Download the problem list",
  REPORT_FILE_NAME: (sheet: string) => `${sheet} - problems.csv`,
  UNKNOWN_OUTCOME_TITLE: "We couldn't confirm whether your data was loaded.",
  UNKNOWN_OUTCOME_LOADED: "We checked: the data was loaded. The list behind this window is up to date.",
  UNKNOWN_OUTCOME_NOT_LOADED: "We checked: the data was not loaded. You can try again.",
  UNKNOWN_OUTCOME_UNCHECKED: "We couldn't check either. Close this window and look at the list to see whether the data is there before trying again.",
  HASH_MISMATCH_NOTICE: "Your file changed since the check, so we checked it again. Please review the results before loading.",
  ERR_FORBIDDEN: "You don't have access to this client's data.",
  ERR_NOT_FOUND: "This project could not be found.",
  ERR_PREVIEW_FAILED: "We couldn't check your file. Please try again.",
  CLOSE_CONFIRM_TITLE: "Leave without loading?",
  CLOSE_CONFIRM_BODY: "Your file and column matches haven't been loaded and will be lost.",
  CLOSE_CONFIRM_STAY: "Keep working",
  CLOSE_CONFIRM_LEAVE: "Leave",

  // Server finding code → plain-language title and advice. The server's own message (which carries
  // the row-specific detail) is always shown underneath; an unknown code shows only that message.
  DIAGNOSTICS: {
    // Fill from the partner list (RosterFillCodes.cs): 7 errors, 3 warnings, 6 notes.
    "IMP-E-ROSTER-EMPTY": { title: "The partner list is empty", advice: "Add partners to this partnership's partner list, then check again." },
    "IMP-E-ROSTER-NO-NAME": { title: "A partner has no name", advice: "Give it a name on the partner list." },
    "IMP-E-ROSTER-NO-CLASS": { title: "A partner has no interest class", advice: "Set a class on the partner list." },
    "IMP-E-ROSTER-DUPLICATE-NAME": { title: "Two partners have the same name", advice: "Rename one of them on the partner list." },
    "IMP-E-SHEET-DUPLICATE-NAME": { title: "The sheet has two rows with the same name", advice: "Remove one of the rows from the sheet." },
    "IMP-E-ROSTER-SHEET-MISMATCH": { title: "The saved rows don't match the template's columns", advice: "Load the sheet again from a file, then fill it." },
    "IMP-E-ROSTER-NO-ID-FORMAT": { title: "We can't tell how IDs are written on this sheet", advice: "Check how the template sets up its IDs." },
    "IMP-W-ROSTER-CLASS-CHANGED": { title: "A partner's ID will change", advice: "Update the rows on other sheets that use the old ID." },
    "IMP-W-ROSTER-ROW-KEPT": { title: "A row on the sheet is not on the partner list", advice: "The row was kept. Remove it yourself if it shouldn't be there." },
    "IMP-W-ROSTER-CLASS-NOT-FOUND": { title: "A class isn't on the class list sheet", advice: "Add it to the class list sheet or change the class." },
    "IMP-I-ROSTER-LOOK-THROUGH": { title: "Look-through partners were left out", advice: "" },
    "IMP-I-ROSTER-CLASS-LIST-NOT-LOADED": { title: "The class list sheet has no data yet", advice: "Classes were not checked. Load that sheet to check them." },
    "IMP-I-ROSTER-CLASS-NOT-CONFIGURED": { title: "This template doesn't name a class list sheet", advice: "Classes were not checked." },
    "IMP-I-ROSTER-MERGE": { title: "Partners added, updated and kept", advice: "" },
    "IMP-I-ROSTER-NO-CHANGE": { title: "The sheet already matches the partner list", advice: "" },
    "IMP-I-ROSTER-ID-TAG-IGNORED": { title: "A template ID setting was ignored", advice: "The sheet's own ID format was kept." },
    // WO-22: what a file load replaces (ImportFindings.cs) and the extra fill findings (RosterFillCodes.cs).
    "IMP-W-SOURCE-ROSTER": { title: "This sheet was filled from the partner list", advice: "Loading this file replaces those rows. The IDs given to partners can change, and rows on other sheets that use the old IDs are not updated." },
    "IMP-W-SOURCE-MANUAL": { title: "This sheet has rows entered or edited by hand", advice: "Loading this file replaces them. Make sure you don't need them." },
    "IMP-W-ORPHAN-REFERENCE": { title: "Other sheets use values this sheet will no longer have", advice: "The load does not update those rows. Fix them afterwards." },
    "IMP-W-ROSTER-ROW-KEPT-LOOK-THROUGH": { title: "A look-through partner still has a row on the sheet", advice: "A fill leaves look-through partners out, so the row was kept. Remove it yourself if it shouldn't be there." },
    "IMP-W-ROSTER-ROW-KEPT-EXITED": { title: "A partner who has exited still has a row on the sheet", advice: "The row was kept. Remove it if they should no longer be calculated." },
    "IMP-W-ROSTER-POSSIBLE-RENAME": { title: "A partner may have been renamed", advice: "A kept row may be an added partner under an old name, so the sheet could now have both, with a new ID for the partner. Remove the old row." },
    "IMP-I-ROSTER-ID-HISTORY": { title: "New partner IDs continue after earlier IDs", advice: "New partner IDs continue after the highest ID this sheet has ever had, so an ID is never reused." },
    // Roll forward from last year (RollForwardCodes.cs): 3 errors, 3 warnings, 2 notes.
    "IMP-E-ROLLFWD-SHEET-MISMATCH": { title: "The saved rows don't match the template's columns", advice: "Load the sheet again from a file, then roll it forward." },
    "IMP-E-ROLLFWD-DUPLICATE-KEY": { title: "Two rows have the same key", advice: "Remove or correct the duplicate rows, then check again." },
    "IMP-E-ROLLFWD-MULTIPLE-SOURCE-JOBS": { title: "Last year's project has more than one result for the same calculation", advice: "Check last year's project, then check again." },
    "IMP-W-ROLLFWD-KEY-UNMATCHED": { title: "A row from last year doesn't apply to this year's partner list", advice: "Check that the partner is on the partner list, then check again." },
    "IMP-W-ROLLFWD-DROPPED": { title: "A row from last year was left out", advice: "Check that this partner is on the partner list, then check again." },
    "IMP-W-ROLLFWD-ROW-KEPT": { title: "A row on the sheet has no value from last year", advice: "The row was kept as it is." },
    "IMP-I-ROLLFWD-NO-CHANGE": { title: "The sheet already matches last year's results", advice: "" },
    "IMP-I-ROLLFWD-NEW-PARTNER": { title: "A partner has no row from last year", advice: "" },
    "IMP-E-FILE": { title: "We couldn't read this file", advice: "Save it again as .xlsx or .csv and try again." },
    "IMP-E-NO-DATA": { title: "No data rows found", advice: "Check that the file has rows under the headings." },
    "IMP-E-ROW-LIMIT": { title: "Too many rows", advice: "Split the file into smaller files and load them one at a time." },
    "IMP-E-MISSING-COLUMN": { title: "A required column is missing", advice: "Match it to a column in your file, or add it to your file." },
    "IMP-E-MAPPING": { title: "A column match isn't valid", advice: "Go back and match the columns again." },
    "IMP-E-REQUIRED": { title: "A required value is empty", advice: "Fill in that cell." },
    "IMP-E-NUMBER": { title: "This should be a number", advice: "Remove letters and symbols from the cell." },
    "IMP-E-INTEGER": { title: "This should be a whole number", advice: "Remove any decimals, letters and symbols." },
    "IMP-E-DATE": { title: "This isn't a date we can read", advice: "Use a format like 2024-12-31." },
    "IMP-E-LIST": { title: "This isn't one of the allowed values", advice: "Use one of the values listed for this column." },
    "IMP-E-RANGE": { title: "This number is out of range", advice: "Check the value." },
    "IMP-E-LENGTH": { title: "This text is too long", advice: "Shorten it." },
    "IMP-E-DUPLICATE-KEY": { title: "This row repeats another row", advice: "Each row needs a unique value in the key column." },
    "IMP-W-UNUSED-COLUMN": { title: "A column in your file isn't used", advice: "It will be ignored." },
    "IMP-W-EMPTY-COLUMN": { title: "A column is empty", advice: "Check that this is expected." },
    "IMP-W-SKIPPED-ROW": { title: "A row was skipped", advice: "Blank rows are not loaded." },
    "IMP-W-IDENTICAL-ROWS": { title: "Two rows are identical", advice: "Check that this is expected." },
    "IMP-W-UNKNOWN-REFERENCE": { title: "This value isn't on a related sheet", advice: "Check the spelling or load the related sheet." },
    "IMP-W-SAVED-HEADER-MISSING": { title: "Your remembered match isn't in this file", advice: "Match that column again." },
    "IMP-I-REFERENCE-NOT-LOADED": { title: "A related sheet has no data yet", advice: "Load that sheet too." },
    "IMP-I-REPLACES": { title: "This will replace existing rows", advice: "" },
    "IMP-I-HEADER-ROW": { title: "We chose the heading row", advice: "" },
    "IMP-I-MAPPING-NOT-SAVED": { title: "Rows were loaded, but your column matches weren't saved", advice: "Match the columns again next time." },
  } as Record<string, { title: string; advice: string }>,
};

// Lower Tier section on the Inputs tab (WO-13). Reasons are shown instead of a value, never a zero.
export const LOWER_TIER_CONSTANT = {
  SECTION_TITLE: "Lower Tier",
  SECTION_HINT: "Values copied from each lower tier's current K-1. Read only.",
  LOADING_TEXT: "Loading lower tier values...",
  UNAVAILABLE_TEXT: "We couldn't load the lower tier values right now.",
  STALE_BANNER_TITLE: "These values may be out of date. Rerun this tier to refresh them.",
  K1_DATE_PREFIX: "K-1 dated ",
  NO_LINES_TEXT: "No lines",
  AMOUNT_COLUMN_LABEL: "Amount",
  STATUS_REASONS: {
    NoProject: "No project exists for this lower tier yet.",
    NoCurrentK1: "This lower tier has no current K-1 yet.",
    NoLinesForRecipient: "The current K-1 has no lines for this partnership.",
  } as Record<string, string>,
  STATUS_REASON_FALLBACK: "No values are available from this lower tier.",
};
